<template>
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
        <!-- Usage:
		<svg class="icon"><use href="#delete"></use></svg>
		-->

        <!-- LOGOS -->
        <g>
            <symbol id="ihs-logo" viewBox="0 0 400 400">
                <g style="fill: var(--env-logo-bg)">
                    <path
                        d="M289.044 248.468c2.032-3.272 3.048-7.45 3.048-12.53 0-5.08-1.003-9.242-3.005-12.489-2.004-3.244-4.868-5.714-8.594-7.408-3.725-1.693-9.708-2.51-17.949-2.454v45.21c8.015 0 13.928-.902 17.737-2.709 3.811-1.805 6.731-4.345 8.763-7.62M126.16 300.448c0 8.459 2.711 12.48 8.42 13.959h18.416c5.69-1.479 8.401-5.5 8.401-13.96v-35.54H126.16v35.54M282.017 267.856c-4.346-1.693-10.837-2.51-19.473-2.455v36.83l-.084 4.233c0 3.048.775 5.348 2.328 6.9 1.552 1.553 3.852 2.328 6.9 2.328 4.515 0 8.679-1.001 12.488-3.006 3.81-2.002 6.73-4.91 8.763-8.72 2.032-3.81 3.048-8.057 3.048-12.742 0-5.361-1.243-10.173-3.726-14.436-2.484-4.26-5.898-7.239-10.244-8.932"
                    />
                    <path
                        d="M315.375 311.714c-8.523 6.829-20.912 10.243-37.167 10.243H76.449v-7.55h8.289c5.462-1.385 7.757-5.14 7.757-13.96V225.61c0-12.005-4.381-14.661-14.983-14.661v-3.432h62.379v3.432c-9.35.304-13.732 3.908-13.732 14.661v31.806h35.238v-31.806c0-10.753-4.361-14.357-13.712-14.661v-3.432h62.379v3.432c-10.772 0-14.983 2.656-14.983 14.661v74.839c0 8.819 2.295 12.574 7.756 13.959h31.275c.199-.295.381-.598.535-.916.762-1.58 1.142-5.474 1.142-11.684v-74.504c0-6.208-.38-10.118-1.142-11.727-.762-1.608-2.103-2.892-4.022-3.852-1.918-.959-5.502-1.44-10.752-1.44v-3.132h55.032c13.151 0 22.464 1.172 27.94 3.513 5.474 2.343 9.791 5.842 12.954 10.499 3.16 4.656 4.741 9.61 4.741 14.859 0 5.532-2.004 10.456-6.012 14.774-4.008 4.318-11.063 7.747-21.165 10.286 10.892 2.541 18.541 5.617 22.944 9.229 6.32 5.137 9.482 11.797 9.482 19.981 0 8.635-3.472 15.776-10.414 21.42zM200.028 98.516l120.421 86.861h-51.834l-68.587-49.465-68.586 49.465h-51.89zM200 54.324L19.464 184.528v161.15h361.072v-161.15L200 54.324"
                    />
                </g>
            </symbol>
            <!-- <symbol id="ihs-logo" viewBox="0 0 161.76 130.52"><polygon points="161.76 58.33 80.88 0 0 58.33 0 130.52 161.76 130.52 161.76 58.33" style="fill: var(--env-logo-bg)"/><polygon points="134.83 58.71 111.61 58.71 80.89 36.55 50.16 58.71 26.91 58.71 80.89 19.8 134.83 58.71" style="fill: var(--env-logo-main)"/><path d="M134.29,109.68c4-2.28,6.54-6.29,6.54-12.4,0-17.22-25.11-13.93-25.11-23.15,0-3.84,3.16-5.68,7.19-5.68,7.33,0,13,4.23,14.65,11.36h1.38V66.43h-1.38c-.13,2-.76,2.65-2.09,2.65-2.4,0-5.55-3.41-13.25-3.41-8.32,0-17,4.36-17,13.7,0,16.53,25.61,13.62,25.61,24.16,0,3.91-4,5.81-8.7,5.81a15.47,15.47,0,0,1-15.65-13.12h-1.39v13.46h-4.75c-2.21-.56-3.13-2.07-3.13-5.64V73.75c0-4.85,1.7-5.93,6.06-5.93V66.43H78.06v1.39c3.78.12,5.55,1.58,5.55,5.93V86.62H69.35V73.75c0-4.35,1.77-5.81,5.55-5.93V66.43H49.66v1.39c4.29,0,6.07,1.08,6.07,5.93V104c0,3.57-.93,5.08-3.14,5.64H43.72c-2.18-.56-3.11-2.07-3.11-5.64V73.75c0-4.85,1.71-5.93,6-5.93V66.43H20.92v1.39c4.36,0,6.07,1.08,6.07,5.93V104c0,3.57-.93,5.08-3.14,5.64H16.1v2.89H145.66v-2.89ZM83.61,104c0,3.42-1.1,5-3.4,5.64H72.75c-2.31-.59-3.4-2.22-3.4-5.64V89.66H83.61Z" style="fill: var(--env-logo-main)"/></symbol> -->
            <symbol id="ihs-logo-text" viewBox="0 0 400 400">
                <path fill="#231f20" d="M339.125 296.073H35.63V160.276l164.49-123.95 160.877 123.038v136.71h-21.873" />
                <path
                    style="fill: var(--env-logo-bg)"
                    d="M200.149 65.184l120.42 86.861h-51.834L200.15 102.58l-68.587 49.465h-51.89zm-.028-44.192L19.585 151.196v161.15h361.072v-161.15L200.12 20.992"
                />
                <path
                    fill="#231f20"
                    d="M293.06 270.635c-2.033 3.809-4.953 6.717-8.763 8.72-3.81 2.004-7.974 3.005-12.488 3.005-3.048 0-5.348-.775-6.9-2.328-1.554-1.552-2.328-3.852-2.328-6.9l.084-4.233v-36.83c8.636-.056 15.126.762 19.473 2.455 4.345 1.693 7.76 4.672 10.244 8.932 2.483 4.263 3.725 9.075 3.725 14.436 0 4.685-1.016 8.932-3.048 12.743zm-30.395-90.38c8.24-.056 14.224.761 17.949 2.454 3.725 1.694 6.59 4.164 8.593 7.408 2.003 3.247 3.006 7.41 3.006 12.49s-1.016 9.257-3.048 12.529c-2.032 3.275-4.952 5.815-8.763 7.62-3.81 1.807-9.723 2.71-17.737 2.71zm-136.385 86.86v-35.54h35.238v35.54c0 8.46-2.712 12.481-8.401 13.96H134.7c-5.71-1.479-8.421-5.5-8.421-13.96zm190.147-30.135c-4.402-3.612-12.052-6.688-22.944-9.23 10.103-2.538 17.158-5.967 21.166-10.285 4.008-4.318 6.012-9.242 6.012-14.774 0-5.25-1.582-10.203-4.742-14.859-3.162-4.657-7.48-8.156-12.953-10.499-5.476-2.341-14.79-3.513-27.94-3.513h-55.032v3.132c5.25 0 8.833.481 10.752 1.44 1.919.96 3.26 2.244 4.021 3.852.763 1.61 1.143 5.519 1.143 11.727v74.504c0 6.21-.38 10.103-1.143 11.684a7.337 7.337 0 01-.534.916h-31.275c-5.461-1.385-7.756-5.14-7.756-13.96v-74.838c0-12.005 4.21-14.661 14.983-14.661v-3.432h-62.38v3.432c9.352.304 13.713 3.908 13.713 14.661v31.806H126.28v-31.806c0-10.753 4.381-14.357 13.731-14.661v-3.432H77.633v3.432c10.602 0 14.983 2.656 14.983 14.661v74.839c0 8.819-2.295 12.574-7.757 13.959h-8.29v7.55h201.76c16.254 0 28.644-3.414 37.166-10.243 6.943-5.645 10.415-12.786 10.415-21.42 0-8.185-3.163-14.846-9.483-19.982"
                />
                <g>
                    <path
                        style="fill: var(--env-logo-bg)"
                        d="M43.466 361.2v-7.6h-9.239v7.6h-3.54v-18.8h3.54v7.923h9.24V342.4h3.518v18.8zM81.474 351.881c-.054 4.862-3.035 9.722-9.643 9.722-6.608 0-9.67-4.754-9.67-9.69S65.329 342 71.831 342c6.501 0 9.695 5.15 9.643 9.88zm-15.82.08c.08 3.088 1.745 6.392 6.177 6.392 4.431 0 6.097-3.33 6.15-6.42.053-3.168-1.72-6.708-6.15-6.708-4.43 0-6.25 3.423-6.178 6.735zM113.14 347.556l-6.123 8.166h-.699l-5.989-8.2v13.671h-3.54V342.4h4.082l5.883 8.084 5.882-8.084h4.056v18.8h-3.54zM146.715 361.175h-14.073v-18.803h14.073v3.436H136.16v4.325h10.18v3.315h-10.18v4.244h10.555zM195.52 347.824c0 1.452-.697 2.848-2.443 3.627 2.203.67 3.008 3.007 3.008 4.19 0 4.19-3.142 5.534-7.037 5.534h-8.918v-18.803h8.918c3.707 0 6.472 1.666 6.472 5.452zm-11.898 2.095h5.426c2.236 0 2.954-.932 2.954-2.014 0-.86-.699-2.31-2.954-2.31h-5.426zm0 7.952h5.426c1.45 0 3.519-.485 3.519-2.257 0-1.692-2.069-2.58-3.519-2.58h-5.426zM227.753 342.4v10.769c0 5.56-3.412 8.408-8.14 8.408-4.511 0-8.352-2.74-8.352-8.408v-10.77h3.518v10.77c0 3.386 1.935 5.184 4.862 5.184 2.928 0 4.594-1.96 4.594-5.184v-10.77zM243.917 361.175v-18.803h3.518v18.803zM266.995 342.372v15.525h9.67v3.278H263.45v-18.803zM308.394 351.613c.08 4.754-2.821 9.562-9.401 9.562h-7.387v-18.803h7.387c6.438 0 9.313 4.78 9.4 9.24zm-13.268 6.15h3.867c4.27 0 5.963-3.116 5.883-6.178-.082-2.928-1.8-5.855-5.883-5.855h-3.867zM337.422 361.175h-14.075v-18.803h14.075v3.436h-10.557v4.325h10.18v3.315h-10.18v4.244h10.557zM369.517 361.175h-4.218l-5.478-6.286h-3.412v6.286h-3.54v-18.822c2.98 0 5.962.026 8.944.026 4.431.028 6.768 2.982 6.768 6.232 0 2.579-1.181 5.184-4.754 5.909l5.693 6.42zm-13.108-15.5v6.018h5.404c2.255 0 3.222-1.504 3.222-3.01 0-1.505-.993-3.007-3.222-3.007zM14.707 326.286h370.785v1.795H14.707zM14.707 375.52h370.785v1.794H14.707z"
                    />
                </g>
            </symbol>
            <!-- <symbol id="ihs-logo-text" viewBox="0 0 1989.73 1323.07"><polygon points="1579.87 421.91 994.87 0 409.87 421.91 409.87 944.08 1579.87 944.08 1579.87 421.91" style="fill: var(--env-logo-bg)"/><polygon points="1385.16 424.66 1217.2 424.66 994.96 264.37 772.72 424.66 604.57 424.66 994.96 143.2 1385.16 424.66" style="fill: var(--env-logo-main)"/><path d="M1381.24,793.36c29.19-16.54,47.29-45.52,47.29-89.7,0-124.56-181.63-100.81-181.63-167.47,0-27.81,22.82-41.08,52-41.08,52.95,0,94,30.59,105.91,82.16h10V480.51h-10c-.95,14.6-5.5,19.15-15.1,19.15-17.32,0-40.13-24.64-95.81-24.64-60.23,0-122.78,31.53-122.78,99.08,0,119.57,185.28,98.53,185.28,174.74,0,28.31-28.75,42-62.94,42-54.79,0-102.69-35.13-113.19-94.92h-10v97.42h-34.36c-16-4.05-22.71-15-22.71-40.85v-219c0-35.14,12.33-42.91,43.86-42.91V480.51H974.47v10.05c27.36.89,40.13,11.44,40.13,42.91v93.09H911.47V533.47c0-31.47,12.82-42,40.18-42.91V480.51H769.09v10.05c31,0,43.85,7.77,43.85,42.91v219c0,25.81-6.72,36.8-22.71,40.85H726.12c-15.82-4.05-22.48-15-22.48-40.85v-219c0-35.14,12.32-42.91,43.35-42.91V480.51H561.21v10.05c31.52,0,43.85,7.77,43.85,42.91v219c0,25.81-6.72,36.8-22.71,40.85H526.29v20.87h937.15V793.36ZM1014.6,752.51c0,24.75-7.94,36.52-24.59,40.85h-53.9c-16.71-4.33-24.64-16.1-24.64-40.85v-104H1014.6Z" style="fill: var(--env-logo-main)"/><g><g><path d="M154.33,1236.6v-40.79H104.75v40.79h-19V1135.71h19v42.52h49.58v-42.52h18.88V1236.6Z" style="fill: #fff"/><path d="M358.29,1186.59c-.29,26.09-16.29,52.17-51.75,52.17s-51.89-25.51-51.89-52,17-53.19,51.89-53.19S358.57,1160.21,358.29,1186.59Zm-84.9.43c.43,16.57,9.37,34.3,33.15,34.3s32.72-17.87,33-34.45c.29-17-9.23-36-33-36S273,1170,273.39,1187Z" style="fill: #fff"/><path d="M528.22,1163.38l-32.86,43.82h-3.75l-32.14-44v73.36h-19V1135.71h21.91l31.57,43.38,31.56-43.38h21.77V1236.6h-19Z" style="fill: #fff"/><path d="M708.39,1236.46H632.87v-100.9h75.52V1154H651.75v23.21h54.63V1195H651.75v22.77h56.64Z" style="fill: #fff"/><path d="M970.29,1164.82c0,7.79-3.74,15.28-13.11,19.46,11.82,3.6,16.14,16.14,16.14,22.49,0,22.48-16.86,29.69-37.76,29.69H887.7v-100.9h47.86C955.45,1135.56,970.29,1144.5,970.29,1164.82Zm-63.85,11.24h29.12c12,0,15.85-5,15.85-10.81,0-4.61-3.75-12.39-15.85-12.39H906.44Zm0,42.67h29.12c7.78,0,18.88-2.6,18.88-12.11,0-9.08-11.1-13.84-18.88-13.84H906.44Z" style="fill: #fff"/><path d="M1143.26,1135.71v57.79c0,29.84-18.31,45.12-43.68,45.12-24.21,0-44.82-14.7-44.82-45.12v-57.79h18.88v57.79c0,18.17,10.38,27.82,26.09,27.82s24.65-10.52,24.65-27.82v-57.79Z" style="fill: #fff"/><path d="M1230,1236.46v-100.9h18.88v100.9Z" style="fill: #fff"/><path d="M1353.84,1135.56v83.31h51.89v17.59h-70.91v-100.9Z" style="fill: #fff"/><path d="M1576,1185.15c.43,25.51-15.14,51.31-50.45,51.31h-39.64v-100.9h39.64C1560.1,1135.56,1575.53,1160.21,1576,1185.15Zm-71.2,33h20.75c22.92,0,32-16.72,31.57-33.15-.44-15.71-9.66-31.42-31.57-31.42h-20.75Z" style="fill: #fff"/><path d="M1731.77,1236.46h-75.53v-100.9h75.53V1154h-56.65v23.21h54.63V1195h-54.63v22.77h56.65Z" style="fill: #fff"/><path d="M1904,1236.46h-22.63l-29.4-33.73h-18.31v33.73h-19v-101c16,0,32,.14,48,.14,23.78.15,36.32,16,36.32,33.44,0,13.84-6.34,27.82-25.51,31.71l30.55,34.45Zm-70.34-83.17v32.29h29c12.1,0,17.29-8.07,17.29-16.15s-5.33-16.14-17.29-16.14Z" style="fill: #fff"/></g><rect y="1049.24" width="1989.73" height="9.63" style="fill: #fff"/><rect y="1313.44" width="1989.73" height="9.63" style="fill: #fff"/></g></symbol> -->
        </g>

        <g>
            <path
                d="M154.33,1236.6v-40.79H104.75v40.79h-19V1135.71h19v42.52h49.58v-42.52h18.88V1236.6Z"
                style="fill: #fff"
            />
            <path
                d="M358.29,1186.59c-.29,26.09-16.29,52.17-51.75,52.17s-51.89-25.51-51.89-52,17-53.19,51.89-53.19S358.57,1160.21,358.29,1186.59Zm-84.9.43c.43,16.57,9.37,34.3,33.15,34.3s32.72-17.87,33-34.45c.29-17-9.23-36-33-36S273,1170,273.39,1187Z"
                style="fill: #fff"
            />
            <path
                d="M528.22,1163.38l-32.86,43.82h-3.75l-32.14-44v73.36h-19V1135.71h21.91l31.57,43.38,31.56-43.38h21.77V1236.6h-19Z"
                style="fill: #fff"
            />
            <path
                d="M708.39,1236.46H632.87v-100.9h75.52V1154H651.75v23.21h54.63V1195H651.75v22.77h56.64Z"
                style="fill: #fff"
            />
            <path
                d="M970.29,1164.82c0,7.79-3.74,15.28-13.11,19.46,11.82,3.6,16.14,16.14,16.14,22.49,0,22.48-16.86,29.69-37.76,29.69H887.7v-100.9h47.86C955.45,1135.56,970.29,1144.5,970.29,1164.82Zm-63.85,11.24h29.12c12,0,15.85-5,15.85-10.81,0-4.61-3.75-12.39-15.85-12.39H906.44Zm0,42.67h29.12c7.78,0,18.88-2.6,18.88-12.11,0-9.08-11.1-13.84-18.88-13.84H906.44Z"
                style="fill: #fff"
            />
            <path
                d="M1143.26,1135.71v57.79c0,29.84-18.31,45.12-43.68,45.12-24.21,0-44.82-14.7-44.82-45.12v-57.79h18.88v57.79c0,18.17,10.38,27.82,26.09,27.82s24.65-10.52,24.65-27.82v-57.79Z"
                style="fill: #fff"
            />
            <path d="M1230,1236.46v-100.9h18.88v100.9Z" style="fill: #fff" />
            <path d="M1353.84,1135.56v83.31h51.89v17.59h-70.91v-100.9Z" style="fill: #fff" />
            <path
                d="M1576,1185.15c.43,25.51-15.14,51.31-50.45,51.31h-39.64v-100.9h39.64C1560.1,1135.56,1575.53,1160.21,1576,1185.15Zm-71.2,33h20.75c22.92,0,32-16.72,31.57-33.15-.44-15.71-9.66-31.42-31.57-31.42h-20.75Z"
                style="fill: #fff"
            />
            <path
                d="M1731.77,1236.46h-75.53v-100.9h75.53V1154h-56.65v23.21h54.63V1195h-54.63v22.77h56.65Z"
                style="fill: #fff"
            />
            <path
                d="M1904,1236.46h-22.63l-29.4-33.73h-18.31v33.73h-19v-101c16,0,32,.14,48,.14,23.78.15,36.32,16,36.32,33.44,0,13.84-6.34,27.82-25.51,31.71l30.55,34.45Zm-70.34-83.17v32.29h29c12.1,0,17.29-8.07,17.29-16.15s-5.33-16.14-17.29-16.14Z"
                style="fill: #fff"
            />
        </g>
        <rect y="1049.24" width="1989.73" height="9.63" style="fill: #fff" />
        <rect y="1313.44" width="1989.73" height="9.63" style="fill: #fff" />

        <!-- UI icons -->
        <g>
            <symbol id="file" viewBox="0 96 960 960">
                <path
                    d="M319 806h322v-60H319v60Zm0-170h322v-60H319v60Zm-99 340q-24 0-42-18t-18-42V236q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm331-554h189L551 236v186Z"
                />
            </symbol>
            <symbol id="file-add" viewBox="0 96 960 960">
                <path
                    d="M450 822h60V693h130v-60H510V503h-60v130H320v60h130v129ZM220 976q-24 0-42-18t-18-42V236q0-24 18-42t42-18h361l219 219v521q0 24-18 42t-42 18H220Zm331-554h189L551 236v186Z"
                />
            </symbol>
            <symbol id="folder" viewBox="0 96 960 960">
                <path
                    d="M141 896q-24 0-42-18.5T81 836V316q0-23 18-41.5t42-18.5h280l60 60h340q23 0 41.5 18.5T881 376v460q0 23-18.5 41.5T821 896H141Z"
                />
            </symbol>
            <symbol id="folder-add" viewBox="0 96 960 960">
                <path
                    d="M570 736h60v-90h90v-60h-90v-90h-60v90h-90v60h90v90ZM141 896q-24 0-42-18.5T81 836V316q0-23 18-41.5t42-18.5h280l60 60h340q23 0 41.5 18.5T881 376v460q0 23-18.5 41.5T821 896H141Z"
                />
            </symbol>
            <symbol id="folder-shared" viewBox="0 96 960 960">
                <path
                    d="M599 602q30 0 51.5-21.5T672 529q0-30-21.5-51.5T599 456q-30 0-51.5 21.5T526 529q0 30 21.5 51.5T599 602ZM439 776h320v-19q0-42-42.5-65T599 669q-75 0-117.5 23T439 757v19ZM141 896q-24 0-42-18.5T81 836V316q0-23 18-41.5t42-18.5h280l60 60h340q23 0 41.5 18.5T881 376v460q0 23-18.5 41.5T821 896H141Z"
                />
            </symbol>
            <symbol id="visible" viewBox="0 96 960 960">
                <path
                    d="m629 637-44-44q26-71-27-118t-115-24l-44-44q17-11 38-16t43-5q71 0 120.5 49.5T650 556q0 22-5.5 43.5T629 637Zm129 129-40-40q49-36 85.5-80.5T857 556q-50-111-150-175.5T490 316q-42 0-86 8t-69 19l-46-47q35-16 89.5-28T485 256q143 0 261.5 81.5T920 556q-26 64-67 117t-95 93Zm58 226L648 827q-35 14-79 21.5t-89 7.5q-146 0-265-81.5T40 556q20-52 55.5-101.5T182 360L56 234l42-43 757 757-39 44ZM223 402q-37 27-71.5 71T102 556q51 111 153.5 175.5T488 796q33 0 65-4t48-12l-64-64q-11 5-27 7.5t-30 2.5q-70 0-120-49t-50-121q0-15 2.5-30t7.5-27l-97-97Zm305 142Zm-116 58Z"
                />
            </symbol>
            <symbol id="visible-off" viewBox="0 96 960 960">
                <path
                    d="M480.118 726Q551 726 600.5 676.382q49.5-49.617 49.5-120.5Q650 485 600.382 435.5q-49.617-49.5-120.5-49.5Q409 386 359.5 435.618q-49.5 49.617-49.5 120.5Q310 627 359.618 676.5q49.617 49.5 120.5 49.5Zm-.353-58Q433 668 400.5 635.265q-32.5-32.736-32.5-79.5Q368 509 400.735 476.5q32.736-32.5 79.5-32.5Q527 444 559.5 476.735q32.5 32.736 32.5 79.5Q592 603 559.265 635.5q-32.736 32.5-79.5 32.5ZM480 856q-146 0-264-83T40 556q58-134 176-217t264-83q146 0 264 83t176 217q-58 134-176 217t-264 83Zm0-300Zm-.169 240Q601 796 702.5 730.5 804 665 857 556q-53-109-154.331-174.5-101.332-65.5-222.5-65.5Q359 316 257.5 381.5 156 447 102 556q54 109 155.331 174.5 101.332 65.5 222.5 65.5Z"
                />
            </symbol>
            <symbol id="percent" viewBox="0 0 18.5 18.5">
                <line
                    x1="16.25"
                    y1="2.25"
                    x2="2.25"
                    y2="16.25"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px"
                />
                <circle
                    cx="3.75"
                    cy="3.75"
                    r="2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px"
                />
                <circle
                    cx="14.75"
                    cy="14.75"
                    r="2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px"
                />
            </symbol>
            <symbol id="search" viewBox="0 0 71.65 71.65">
                <path
                    d="M28.63,0a28.63,28.63,0,1,0,15,53l.63-.39L61.53,69.91a5.93,5.93,0,1,0,8.38-8.38L52.62,44.24l.39-.63A28.61,28.61,0,0,0,28.63,0Zm0,50.55A21.93,21.93,0,1,1,50.55,28.63,21.95,21.95,0,0,1,28.63,50.55Z"
                ></path>
            </symbol>
            <symbol
                id="link"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                viewBox="0 0 24 24"
            >
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
            </symbol>
            <symbol id="leads-solid" viewBox="0 0 79.97 64.53">
                <path
                    d="M42.77,34V32.32a3.41,3.41,0,1,0-6.8,0V34a3.51,3.51,0,0,0,3.12,3.71l.81,0A3.59,3.59,0,0,0,42.77,34Z"
                ></path>
                <path
                    d="M24.43,44.89V43.23A3.54,3.54,0,0,0,21,39.5a3.54,3.54,0,0,0-3.4,3.73v1.66a3.56,3.56,0,0,0,3.12,3.71l.81,0A3.59,3.59,0,0,0,24.43,44.89Z"
                ></path>
                <path
                    d="M62.27,44.89V43.23a3.41,3.41,0,1,0-6.8,0v1.66a3.56,3.56,0,0,0,3.12,3.71l.81,0A3.6,3.6,0,0,0,62.27,44.89Z"
                ></path>
                <path
                    d="M40,0,0,28.84V64.53H80V28.84Zm0,9.79L66.66,29H55.18L40,18.07,24.8,29H13.3ZM31.54,58H29.07V54.44c0-1.91-4.41-3.36-7.35-3.4a5.09,5.09,0,0,1-.69.05h-.22c-2.89.22-6.66,1.59-6.66,3.36V58H11.68V54.44c0-2.58,2.51-4.22,5.23-5.1a6.38,6.38,0,0,1-1.75-4.45V43.23a5.88,5.88,0,1,1,11.74,0v1.66a6.41,6.41,0,0,1-1.51,4.19c3.05.78,6.15,2.49,6.15,5.36Zm8.52-17.83c-.22,0-.45,0-.69,0h-.22c-2.89.22-6.66,1.59-6.66,3.36v3.53H30V43.53c0-2.58,2.51-4.22,5.24-5.09A6.35,6.35,0,0,1,33.5,34V32.32a5.88,5.88,0,1,1,11.74,0V34a6.36,6.36,0,0,1-1.52,4.19c3.06.78,6.16,2.49,6.16,5.36v3.53H47.41V43.53C47.41,41.62,43,40.17,40.06,40.14ZM69.38,58H66.91V54.44c0-1.91-4.41-3.36-7.35-3.4a5.09,5.09,0,0,1-.69.05h-.22C55.76,51.3,52,52.67,52,54.44V58H49.52V54.44c0-2.58,2.51-4.22,5.23-5.1A6.38,6.38,0,0,1,53,44.89V43.23a5.88,5.88,0,1,1,11.74,0v1.66a6.36,6.36,0,0,1-1.52,4.19c3.06.78,6.16,2.49,6.16,5.36Z"
                ></path>
            </symbol>
            <symbol id="notepad" viewBox="0 0 88.76 80.47">
                <rect x="13.65" y="22.25" width="36.03" height="5.79"></rect>
                <path d="M71.59,15.91,35.8,51.7,32.44,64.83a1.36,1.36,0,0,0,1.65,1.65l13.12-3.36L83,27.33Z"></path>
                <path
                    d="M57.48,61.34V74.73H5.75v-69H57.48V21.53l5.75-5.75V6.08A6.08,6.08,0,0,0,57.15,0H5.75A5.74,5.74,0,0,0,0,5.75v69a5.74,5.74,0,0,0,5.75,5.74H57.48a5.74,5.74,0,0,0,5.75-5.74V55.59Z"
                ></path>
                <path d="M26.63,63.35l.51-2H13.65v5.79h13A7.19,7.19,0,0,1,26.63,63.35Z"></path>
                <polygon
                    points="29.98 50.22 30.39 48.62 30.71 48.3 13.65 48.3 13.65 54.09 28.99 54.09 29.98 50.22"
                ></polygon>
                <polygon points="43.75 35.27 13.65 35.27 13.65 41.06 37.96 41.06 43.75 35.27"></polygon>
                <path d="M86.4,12.52a8.08,8.08,0,0,0-11.42,0l-.3.3L86.1,24.24l.3-.3A8.08,8.08,0,0,0,86.4,12.52Z"></path>
            </symbol>
            <symbol id="pdf" viewBox="0 0 86.22 80.47">
                <path
                    d="M36.73,48.77c0,4.11-2.31,5.84-4.82,5.84H28.74V43.11h3.31C34.42,43.11,36.73,45.18,36.73,48.77ZM15.17,43.11H11.5v5.75h3.67a3.16,3.16,0,0,0,2.17-.67,2.45,2.45,0,0,0,.73-1.94,3,3,0,0,0-.73-2.16A3.42,3.42,0,0,0,15.17,43.11ZM60.36,63.23H2.87A2.88,2.88,0,0,1,0,60.36v-23a2.88,2.88,0,0,1,2.87-2.87H60.36a2.88,2.88,0,0,1,2.87,2.87v23A2.88,2.88,0,0,1,60.36,63.23ZM21.51,46A5.4,5.4,0,0,0,20,42a6.4,6.4,0,0,0-4.29-1.71H8.62V57.48H11.5V51.67c2.87,0,2.52,0,3.85,0A7.17,7.17,0,0,0,20,50.26,5.82,5.82,0,0,0,21.51,46Zm18.05,3.08c0-4.37-2.65-8.84-7.28-8.84H25.87V57.48H32C36.9,57.48,39.56,53.75,39.56,49.08Zm15-8.84H43.11V57.48H46V51.73h8.62V48.86H46V43.11h8.62ZM62.78,0h-34A5.76,5.76,0,0,0,23,5.75v23h5.75v-23H60.36V20.12a5.75,5.75,0,0,0,5.74,5.75H80.47V74.73H28.74V69H23v5.75a5.75,5.75,0,0,0,5.75,5.74H80.47a5.74,5.74,0,0,0,5.75-5.74V23.44Z"
                ></path>
            </symbol>
            <symbol id="settings" viewBox="0 0 58.84 58.84">
                <path
                    d="M57.83,37l1-7.61-7.42-2.9-1.5-5.59,5-6.22L50.22,8.62l-7.3,3.2-5-2.9L37,1,29.42,0l-2.9,7.42-5.59,1.5-6.22-5L8.62,8.62l3.2,7.29-2.9,5L1,21.8,0,29.42l7.42,2.89,1.5,5.6-5,6.22,4.68,6.09L15.91,47l5,2.9.87,7.91,7.62,1,2.89-7.42,5.6-1.5,6.22,5,6.09-4.68L47,42.92l2.9-5ZM29.42,41A11.55,11.55,0,1,1,41,29.42,11.55,11.55,0,0,1,29.42,41Z"
                ></path>
            </symbol>
            <symbol id="users" viewBox="0 0 101.44 75.84">
                <path
                    d="M48.69,25.24c-5.94,0-10.59-4.91-10.59-11.18V11.17C38.1,4.91,42.75,0,48.69,0s10.6,4.91,10.6,11.17v2.89C59.29,20.33,54.64,25.24,48.69,25.24ZM48.69,5C45.5,5,43.1,7.65,43.1,11.17v2.89c0,3.53,2.4,6.18,5.59,6.18s5.6-2.65,5.6-6.18V11.17C54.29,7.65,51.89,5,48.69,5Z"
                ></path>
                <path
                    d="M67.39,36.91h-5V30.75c0-3.09-7.67-5.6-12.68-5.6S37,27.66,37,30.75v6.16H32V30.75c0-7.92,12.14-10.59,17.68-10.59s17.68,2.67,17.68,10.59Z"
                ></path>
                <path
                    d="M50.72,64.17c-5.94,0-10.6-4.91-10.6-11.17V50.1c0-6.26,4.66-11.17,10.6-11.17S61.31,43.84,61.31,50.1V53C61.31,59.26,56.66,64.17,50.72,64.17Zm0-20.24c-3.19,0-5.6,2.65-5.6,6.17V53c0,3.52,2.41,6.17,5.6,6.17s5.6-2.65,5.6-6.17V50.1C56.32,46.58,53.91,43.93,50.72,43.93Z"
                ></path>
                <path
                    d="M69.41,75.84h-5V69.68c0-3.09-7.67-5.59-12.68-5.59s-12.68,2.5-12.68,5.59v6.16h-5V69.68c0-7.92,12.14-10.59,17.68-10.59s17.68,2.67,17.68,10.59Z"
                ></path>
                <path
                    d="M82.75,44.29c-5.94,0-10.6-4.91-10.6-11.17v-2.9c0-6.26,4.66-11.17,10.6-11.17S93.34,24,93.34,30.22v2.9C93.34,39.38,88.69,44.29,82.75,44.29Zm0-20.24c-3.2,0-5.6,2.65-5.6,6.17v2.9c0,3.52,2.4,6.17,5.6,6.17s5.6-2.65,5.6-6.17v-2.9C88.35,26.7,85.94,24.05,82.75,24.05Z"
                ></path>
                <path
                    d="M101.44,56h-5V49.8c0-3.09-7.67-5.6-12.68-5.6s-12.68,2.51-12.68,5.6V56h-5V49.8c0-7.92,12.14-10.59,17.68-10.59s17.68,2.67,17.68,10.59Z"
                ></path>
                <path
                    d="M16.67,44.29c-5.94,0-10.6-4.91-10.6-11.17v-2.9c0-6.26,4.66-11.17,10.6-11.17S27.26,24,27.26,30.22v2.9C27.26,39.38,22.61,44.29,16.67,44.29Zm0-20.24c-3.19,0-5.6,2.65-5.6,6.17v2.9c0,3.52,2.41,6.17,5.6,6.17s5.6-2.65,5.6-6.17v-2.9C22.27,26.7,19.86,24.05,16.67,24.05Z"
                ></path>
                <path
                    d="M35.36,56h-5V49.8c0-3.09-7.67-5.6-12.68-5.6S5,46.71,5,49.8V56H0V49.8c0-7.92,12.14-10.59,17.68-10.59S35.36,41.88,35.36,49.8Z"
                ></path>
            </symbol>
            <symbol id="single-user" viewBox="0 0 35.36 36.91">
                <path
                    d="M16.67,25.24c-5.94,0-10.6-4.91-10.6-11.18V11.17C6.07,4.91,10.73,0,16.67,0S27.26,4.91,27.26,11.17v2.89C27.26,20.33,22.61,25.24,16.67,25.24ZM16.67,5c-3.19,0-5.6,2.65-5.6,6.17v2.89c0,3.53,2.41,6.18,5.6,6.18s5.6-2.65,5.6-6.18V11.17C22.27,7.65,19.86,5,16.67,5Z"
                />
                <path
                    d="M35.36,36.91h-5V30.75c0-3.09-7.67-5.6-12.68-5.6S5,27.66,5,30.75v6.16H0V30.75c0-7.92,12.14-10.59,17.68-10.59s17.68,2.67,17.68,10.59Z"
                />
            </symbol>
            <symbol id="edit" viewBox="0 0 78.64 77.42">
                <path d="M61.46,5.76,25.67,41.55,22.32,54.68A1.35,1.35,0,0,0,24,56.32L37.09,53,72.88,17.18Z"></path>
                <path d="M69.32,29.23A32.47,32.47,0,1,1,50,8.74l4.59-4.58A38.42,38.42,0,1,0,74,24.54Z"></path>
                <path d="M76.27,2.36a8.07,8.07,0,0,0-11.41,0l-.3.3L76,14.08l.29-.3A8.06,8.06,0,0,0,76.27,2.36Z"></path>
            </symbol>
            <symbol id="history" viewBox="0 0 80.64 77.27">
                <path
                    d="M42,77.27A38.64,38.64,0,1,0,30.82,1.66V8.73a31.92,31.92,0,1,1-20.75,29.9c0-.75,0-1.54.11-2.49l0-.48c.07-.81.18-1.61.31-2.38l.08-.42A32.18,32.18,0,0,1,13,25.33l.48-1,8,4.63,0-24.8L0,16.52l7.66,4.42-.42.88a38.78,38.78,0,0,0-2.34,6.1l0,.12h0c-.25.86-.45,1.66-.62,2.44s-.31,1.58-.44,2.43l-.06.38c-.1.77-.19,1.57-.25,2.38l0,.46c-.07,1-.09,1.74-.09,2.49A38.68,38.68,0,0,0,42,77.27Z"
                ></path>
                <path
                    d="M54.79,53a3.43,3.43,0,0,1-1.86-.54L37.7,42.89V17.3a3.5,3.5,0,1,1,7,0V39l12,7.53A3.5,3.5,0,0,1,54.79,53Z"
                ></path>
            </symbol>
            <symbol id="leads" viewBox="0 0 76.14 63.58">
                <polygon
                    points="37.35 10.93 57.4 25.39 72.55 25.39 37.35 0 2.14 25.39 17.31 25.39 37.35 10.93"
                ></polygon>
                <path
                    d="M50.41,49.18V44.53c0-3.79-4.09-6-8.12-7.07a8.47,8.47,0,0,0,2-5.54V29.74a7.76,7.76,0,1,0-15.5,0v2.18a8.39,8.39,0,0,0,2.32,5.89c-3.6,1.15-6.91,3.31-6.91,6.72v4.65h3.26V44.53c0-2.34,5-4.14,8.79-4.44l.29,0a9.07,9.07,0,0,0,.91-.06c3.88.05,9.7,2,9.7,4.48v4.65ZM32.05,31.92V29.74a4.51,4.51,0,1,1,9,0v2.18a4.74,4.74,0,0,1-3.8,4.86c-.33,0-.69,0-1.06,0A4.71,4.71,0,0,1,32.05,31.92Z"
                ></path>
                <path
                    d="M68,51.85a8.47,8.47,0,0,0,2-5.53V44.13a7.76,7.76,0,1,0-15.5,0v2.19a8.41,8.41,0,0,0,2.32,5.88c-3.6,1.15-6.91,3.32-6.91,6.73v4.65H53.2V58.93c0-2.34,5-4.14,8.78-4.44h.29a7,7,0,0,0,.92-.06c3.87.05,9.69,2,9.69,4.49v4.65h3.26V58.93C76.14,55.14,72.05,52.88,68,51.85ZM57.79,46.32V44.13a4.5,4.5,0,1,1,9,0v2.19A4.74,4.74,0,0,1,63,51.18c-.34,0-.7,0-1.07,0A4.7,4.7,0,0,1,57.79,46.32Z"
                ></path>
                <path
                    d="M18.08,51.85a8.42,8.42,0,0,0,2-5.53V44.13A7.89,7.89,0,0,0,12.34,36a7.88,7.88,0,0,0-7.75,8.18v2.19A8.37,8.37,0,0,0,6.91,52.2C3.31,53.35,0,55.52,0,58.93v4.65H3.26V58.93c0-2.34,5-4.14,8.78-4.44h.3a6.84,6.84,0,0,0,.91-.06c3.88.05,9.69,2,9.69,4.49v4.65h3.27V58.93C26.21,55.14,22.12,52.88,18.08,51.85ZM7.85,46.32V44.13a4.67,4.67,0,0,1,4.49-4.92,4.67,4.67,0,0,1,4.49,4.92v2.19A4.74,4.74,0,0,1,13,51.18c-.33,0-.69,0-1.06,0A4.7,4.7,0,0,1,7.85,46.32Z"
                ></path>
            </symbol>
            <symbol id="download" viewBox="0 0 53.79 62.7">
                <g>
                    <line
                        x1="42.29"
                        y1="22.34"
                        x2="27.05"
                        y2="40.05"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                    <path
                        d="M11.63,22.34,26.54,39.67a.18.18,0,0,0,.32-.12V3"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                </g>
                <g>
                    <line
                        x1="5.89"
                        y1="57.2"
                        x2="47.92"
                        y2="57.2"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 11px"
                    />
                    <polyline
                        points="3.34 44.41 3.08 54.4 50.79 54.4 50.79 44.2"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                </g>
            </symbol>
            <symbol id="contract" viewBox="0 0 87.6 80.52">
                <g>
                    <line
                        x1="27.3"
                        y1="41.07"
                        x2="27.3"
                        y2="65.37"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                    <line
                        x1="15.15"
                        y1="53.22"
                        x2="39.45"
                        y2="53.22"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                </g>
                <path
                    d="M27.3,25.92a27.3,27.3,0,1,0,27.3,27.3A27.3,27.3,0,0,0,27.3,25.92Zm0,48.6a21.3,21.3,0,1,1,21.3-21.3A21.32,21.32,0,0,1,27.3,74.52Z"
                />
                <path d="M60.22,48.22a33,33,0,0,1,.38,5c0,.26,0,.52,0,.79H74.27V48.22Z" />
                <path d="M55.27,35.18a33.67,33.67,0,0,1,3,5.79h16V35.18Z" />
                <path
                    d="M64.15,0h-34a5.76,5.76,0,0,0-5.75,5.75V20.06c1-.09,1.94-.14,2.93-.14s1.89,0,2.82.13V5.75H61.73V20.12a5.76,5.76,0,0,0,5.75,5.75H81.85V74.73H52.69a33.37,33.37,0,0,1-6.3,5.74H81.85a5.75,5.75,0,0,0,5.75-5.74V23.44Z"
                />
            </symbol>
            <symbol id="chevron-down" viewBox="0 0 32.56 21.33">
                <g>
                    <line
                        x1="29.56"
                        y1="3"
                        x2="16.36"
                        y2="18.33"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                    <line
                        x1="16.2"
                        y1="18.33"
                        x2="3"
                        y2="3"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                </g>
            </symbol>
            <symbol id="chevron-right" viewBox="0 0 21.33 32.56">
                <line
                    x1="3"
                    y1="3"
                    x2="18.33"
                    y2="16.2"
                    style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                />
                <line
                    x1="18.33"
                    y1="16.36"
                    x2="3"
                    y2="29.56"
                    style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                />
            </symbol>
            <symbol id="chevron-up" viewBox="0 0 32.56 21.33">
                <line
                    x1="3"
                    y1="18.33"
                    x2="16.2"
                    y2="3"
                    style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                />
                <line
                    x1="16.36"
                    y1="3"
                    x2="29.56"
                    y2="18.33"
                    style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                />
            </symbol>
            <symbol id="chevron-left" viewBox="0 0 21.33 32.56">
                <line
                    x1="18.33"
                    y1="29.56"
                    x2="3"
                    y2="16.36"
                    style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                />
                <line
                    x1="3"
                    y1="16.2"
                    x2="18.33"
                    y2="3"
                    style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                />
            </symbol>
            <symbol id="check" viewBox="0 0 76.83 76.83">
                <g>
                    <line
                        x1="52.12"
                        y1="27.81"
                        x2="32.22"
                        y2="51.11"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 7px"
                    />
                    <line
                        x1="31.74"
                        y1="51.07"
                        x2="22"
                        y2="39.8"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 7px"
                    />
                </g>
                <path
                    d="M38.41,6A32.42,32.42,0,1,1,6,38.41,32.45,32.45,0,0,1,38.41,6m0-6A38.42,38.42,0,1,0,76.83,38.41,38.41,38.41,0,0,0,38.41,0Z"
                    style=""
                />
            </symbol>
            <symbol id="check-2" viewBox="0 0 22 22">
                <path
                    d="M21,10.09V11a10,10,0,1,1-5.93-9.14"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2px"
                />
                <polyline
                    points="21 3.01 11 13.02 8 10.02"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2px"
                />
            </symbol>
            <symbol id="warn" viewBox="0 0 22 22">
                <circle
                    cx="11"
                    cy="11"
                    r="10"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2px"
                />
                <line
                    x1="11"
                    y1="7"
                    x2="11"
                    y2="11"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <line
                    x1="11"
                    y1="15"
                    x2="11.01"
                    y2="15"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
            </symbol>
            <symbol id="warn-triangle" viewBox="0 0 20.9 18.1">
                <path
                    d="M20.9,16.08a2,2,0,0,1-2,2H2a2,2,0,0,1-1.71-3L8.74,1A2,2,0,0,1,9.41.29,2,2,0,0,1,12.16,1L20.63,15.1A2.09,2.09,0,0,1,20.9,16.08Z"
                />
                <line
                    x1="10.45"
                    y1="6.1"
                    x2="10.45"
                    y2="10.1"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2px"
                />
                <line
                    x1="10.45"
                    y1="14.1"
                    x2="10.46"
                    y2="14.1"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2px"
                />
            </symbol>
            <symbol id="calendar" viewBox="0 0 72.53 78.25">
                <path
                    d="M53.61,8.8H62.5a7,7,0,0,1,7,7V68.2a7,7,0,0,1-7,7H10.12a7,7,0,0,1-7-7V15.83a7,7,0,0,1,7-7H19"
                    style="
                        fill: none;
                        stroke: #6d6e71;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-width: 6px;
                    "
                />
                <line
                    x1="19"
                    y1="8.8"
                    x2="53.61"
                    y2="8.8"
                    style="
                        fill: none;
                        stroke: #6d6e71;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-width: 6px;
                    "
                />
                <line
                    x1="19"
                    y1="16.1"
                    x2="19"
                    y2="3"
                    style="
                        fill: none;
                        stroke: #6d6e71;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-width: 6px;
                    "
                />
                <line
                    x1="53.61"
                    y1="16.1"
                    x2="53.61"
                    y2="3"
                    style="
                        fill: none;
                        stroke: #6d6e71;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-width: 6px;
                    "
                />
                <line
                    x1="47.38"
                    y1="27.13"
                    x2="47.38"
                    y2="75.25"
                    style="
                        fill: none;
                        stroke: #6d6e71;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-width: 6px;
                    "
                />
                <line
                    x1="25.23"
                    y1="27.13"
                    x2="25.23"
                    y2="75.25"
                    style="
                        fill: none;
                        stroke: #6d6e71;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-width: 6px;
                    "
                />
                <line
                    x1="68.3"
                    y1="27.13"
                    x2="3"
                    y2="27.13"
                    style="
                        fill: none;
                        stroke: #6d6e71;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-width: 6px;
                    "
                />
                <line
                    x1="69.53"
                    y1="51.19"
                    x2="3"
                    y2="51.19"
                    style="
                        fill: none;
                        stroke: #6d6e71;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-width: 6px;
                    "
                />
            </symbol>
            <symbol id="add" viewBox="0 0 76.83 76.83">
                <path
                    d="M38.41,6A32.42,32.42,0,1,1,6,38.41,32.45,32.45,0,0,1,38.41,6m0-6A38.42,38.42,0,1,0,76.83,38.41,38.41,38.41,0,0,0,38.41,0Z"
                    style=""
                />
                <g>
                    <line
                        x1="38.41"
                        y1="21.31"
                        x2="38.41"
                        y2="55.52"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                    <line
                        x1="21.31"
                        y1="38.41"
                        x2="55.52"
                        y2="38.41"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                </g>
            </symbol>
            <symbol id="account" viewBox="0 0 76.99 76.99">
                <path
                    d="M38.5,6A32.5,32.5,0,1,1,6,38.5,32.54,32.54,0,0,1,38.5,6m0-6A38.5,38.5,0,1,0,77,38.5,38.5,38.5,0,0,0,38.5,0Z"
                    style=""
                />
                <g>
                    <path
                        d="M38.5,46c5.48,0,9.58-4.59,9.58-10.26V32.28C48.08,26.62,44,22,38.5,22s-9.58,4.6-9.58,10.26v3.43C28.92,41.38,33,46,38.5,46Z"
                        style="fill: none; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                    <path
                        d="M56.46,68.22V55.45c0-6.6-12-9.58-18-9.58s-18,3-18,9.58V68"
                        style="fill: none; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                </g>
            </symbol>
            <symbol id="account-manage" viewBox="0 0 39.56 33.25">
                <path
                    d="M16,15A7.19,7.19,0,0,1,8.5,7.5,7.19,7.19,0,0,1,16,0a7.19,7.19,0,0,1,7.5,7.5A7.19,7.19,0,0,1,16,15ZM1.5,31.05a1.42,1.42,0,0,1-1.07-.43A1.42,1.42,0,0,1,0,29.55v-3.2A5.75,5.75,0,0,1,.88,23.2,5.62,5.62,0,0,1,3.4,21.05a36.67,36.67,0,0,1,6.68-2.3,26.44,26.44,0,0,1,5.92-.7h1.15a11.61,11.61,0,0,0-.63,1.6c-.18.6-.34,1.22-.47,1.85a14,14,0,0,0-.17,3.22,13.07,13.07,0,0,0,.52,3.33A8.54,8.54,0,0,0,17,29.67a9,9,0,0,0,.88,1.38ZM30.7,27.2a3.78,3.78,0,0,0,4-4,4,4,0,1,0-8,0,3.78,3.78,0,0,0,4,4ZM28.85,30a9.27,9.27,0,0,1-1.72-.72,6.36,6.36,0,0,1-1.48-1.08l-2.2.5a.62.62,0,0,1-.5,0,.6.6,0,0,1-.35-.35L22,27.15a.55.55,0,0,1-.1-.45.85.85,0,0,1,.25-.45l1.9-1.8a5.86,5.86,0,0,1-.1-1.25A5.86,5.86,0,0,1,24,22l-1.9-1.8a.85.85,0,0,1-.25-.45.55.55,0,0,1,.1-.45l.65-1.15a.6.6,0,0,1,.35-.35.62.62,0,0,1,.5,0l2.2.5a6.36,6.36,0,0,1,1.48-1.08,9.27,9.27,0,0,1,1.72-.72l.4-2.65a.8.8,0,0,1,.25-.48.76.76,0,0,1,.5-.17h1.4a.76.76,0,0,1,.5.17.8.8,0,0,1,.25.48l.4,2.65a9.64,9.64,0,0,1,1.73.72,6.51,6.51,0,0,1,1.47,1.08l2.2-.5a.62.62,0,0,1,.5,0,.6.6,0,0,1,.35.35l.65,1.15a.55.55,0,0,1,.1.45.85.85,0,0,1-.25.45L37.4,22a5.86,5.86,0,0,1,.1,1.25,5.86,5.86,0,0,1-.1,1.25l1.9,1.8a.85.85,0,0,1,.25.45.55.55,0,0,1-.1.45L38.8,28.3a.6.6,0,0,1-.35.35.62.62,0,0,1-.5,0l-2.2-.5a6.51,6.51,0,0,1-1.47,1.08,9.64,9.64,0,0,1-1.73.72l-.4,2.65a.8.8,0,0,1-.25.48.76.76,0,0,1-.5.17H30a.76.76,0,0,1-.5-.17.8.8,0,0,1-.25-.48Z"
                />
            </symbol>
            <symbol id="transfer" viewBox="0 0 101.68 70.63">
                <path
                    d="M99.53,44.78,78.13,23a1.39,1.39,0,0,0-2.32.58l0,9.45a.83.83,0,0,1-.82.81H24a.82.82,0,0,0-.81.82v8.61L5,24.88,23.19,6.44v8.62a.81.81,0,0,0,.81.81H60.73A1.37,1.37,0,0,0,62.1,14.5h0a1.37,1.37,0,0,0-1.37-1.37h-34a.81.81,0,0,1-.81-.81V3.14a1.39,1.39,0,0,0-2.38-1L2.15,23.9a1.39,1.39,0,0,0,0,2l21.4,21.74a1.39,1.39,0,0,0,2.38-1v-9a.82.82,0,0,1,.82-.82H77.68a.81.81,0,0,0,.81-.81V27.31L96.64,45.75,78.49,64.19V55.57a.81.81,0,0,0-.81-.81H41a1.37,1.37,0,0,0-1.37,1.37h0A1.37,1.37,0,0,0,41,57.5H74.94a.81.81,0,0,1,.81.81v9.18a1.39,1.39,0,0,0,2.38,1l21.4-21.74A1.38,1.38,0,0,0,99.53,44.78Z"
                    style="stroke-miterlimit: 10; stroke-width: 3.5px"
                />
            </symbol>
            <symbol id="save" viewBox="0 0 76.44 76.44">
                <path
                    d="M73.44,19.42V67.81a5.63,5.63,0,0,1-5.63,5.63H8.64A5.63,5.63,0,0,1,3,67.81V8.64A5.63,5.63,0,0,1,8.64,3H57a5.63,5.63,0,0,1,4,1.65L71.79,15.44A5.62,5.62,0,0,1,73.44,19.42Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 6px"
                />
                <path
                    d="M55.13,3V16.53a3.38,3.38,0,0,1-3.38,3.38h-27a3.38,3.38,0,0,1-3.38-3.38V3"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 6px"
                />
                <path
                    d="M17.09,73.44V41.6a3.38,3.38,0,0,1,3.38-3.38H56a3.39,3.39,0,0,1,3.39,3.38V73.44"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 6px"
                />
            </symbol>
            <symbol id="remove" viewBox="0 0 76.83 76.83">
                <path
                    d="M38.41,6A32.41,32.41,0,0,1,61.33,61.33,32.41,32.41,0,0,1,15.49,15.49,32.23,32.23,0,0,1,38.41,6m0-6A38.42,38.42,0,1,0,65.58,11.25,38.29,38.29,0,0,0,38.41,0Z"
                />
                <g>
                    <line
                        x1="26.32"
                        y1="26.32"
                        x2="50.51"
                        y2="50.51"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                    <line
                        x1="26.32"
                        y1="50.51"
                        x2="50.51"
                        y2="26.32"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                </g>
            </symbol>
            <symbol id="previous" viewBox="0 0 76.83 76.83">
                <path
                    d="M38.41,6A32.42,32.42,0,1,1,6,38.41,32.45,32.45,0,0,1,38.41,6m0-6A38.42,38.42,0,1,0,76.83,38.41,38.41,38.41,0,0,0,38.41,0Z"
                />
                <g>
                    <line
                        x1="43.95"
                        y1="51.69"
                        x2="28.61"
                        y2="38.5"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                    <line
                        x1="28.61"
                        y1="38.33"
                        x2="43.95"
                        y2="25.13"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                </g>
            </symbol>
            <symbol id="offline" viewBox="0 0 62.43 52.2">
                <g>
                    <line
                        x1="21.4"
                        y1="29.53"
                        x2="41.07"
                        y2="49.2"
                        style="
                            fill: none;
                            stroke: #d7301a;
                            stroke-linecap: round;
                            stroke-miterlimit: 10;
                            stroke-width: 6px;
                        "
                    />
                    <line
                        x1="21.4"
                        y1="49.2"
                        x2="41.07"
                        y2="29.53"
                        style="
                            fill: none;
                            stroke: #d7301a;
                            stroke-linecap: round;
                            stroke-miterlimit: 10;
                            stroke-width: 6px;
                        "
                    />
                </g>
                <path
                    d="M9,25a3,3,0,0,0,4.28-.05l.1-.09a25.29,25.29,0,0,1,35.77,0l.05.05a3,3,0,0,0,4.29,0h0a3,3,0,0,0,0-4.2.8.8,0,0,0-.13-.13,31.29,31.29,0,0,0-44.26,0c0,.06-.11.11-.17.17A3,3,0,0,0,9,25Z"
                    style="fill: #dbdbdb"
                />
                <path
                    d="M.88,16.9a3,3,0,0,0,4.28,0l.1-.1a36.72,36.72,0,0,1,51.94,0l.06.06a3,3,0,0,0,4.28,0h0a3,3,0,0,0,.05-4.19l-.14-.15A42.74,42.74,0,0,0,1,12.51l-.17.18a3,3,0,0,0,0,4.21Z"
                    style="fill: #848484"
                />
            </symbol>
            <symbol id="online" viewBox="0 0 62.43 47.94">
                <circle cx="31.21" cy="36.19" r="11.75" style="fill: #fff" />
                <g>
                    <line
                        x1="36.77"
                        y1="31.89"
                        x2="28.88"
                        y2="41.14"
                        style="
                            fill: none;
                            stroke: #0a0c15;
                            stroke-linecap: round;
                            stroke-miterlimit: 10;
                            stroke-width: 2.777760205601752px;
                        "
                    />
                    <line
                        x1="28.69"
                        y1="41.12"
                        x2="24.82"
                        y2="36.65"
                        style="
                            fill: none;
                            stroke: #0a0c15;
                            stroke-linecap: round;
                            stroke-miterlimit: 10;
                            stroke-width: 2.777760205601752px;
                        "
                    />
                </g>
                <g>
                    <path
                        d="M9,25a3,3,0,0,0,4.28-.05l.1-.09a25.29,25.29,0,0,1,35.77,0l.05.05a3,3,0,0,0,4.29,0h0a3,3,0,0,0,0-4.2.8.8,0,0,0-.13-.13,31.29,31.29,0,0,0-44.26,0c0,.06-.11.11-.17.17A3,3,0,0,0,9,25Z"
                        style="fill: #fff"
                    />
                    <path
                        d="M.88,16.9a3,3,0,0,0,4.28,0l.1-.1a36.72,36.72,0,0,1,51.94,0l.06.06a3,3,0,0,0,4.28,0h0a3,3,0,0,0,.05-4.19l-.14-.15A42.74,42.74,0,0,0,1,12.51l-.17.18a3,3,0,0,0,0,4.21Z"
                        style="fill: #fff"
                    />
                </g>
            </symbol>
            <symbol id="next" viewBox="0 0 76.83 76.83">
                <path
                    d="M38.41,6A32.42,32.42,0,1,1,6,38.41,32.45,32.45,0,0,1,38.41,6m0-6A38.42,38.42,0,1,0,76.83,38.41,38.41,38.41,0,0,0,38.41,0Z"
                />
                <g>
                    <line
                        x1="32.88"
                        y1="25.13"
                        x2="48.21"
                        y2="38.33"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                    <line
                        x1="48.21"
                        y1="38.5"
                        x2="32.88"
                        y2="51.69"
                        style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 6px"
                    />
                </g>
            </symbol>
            <symbol id="lock" viewBox="0 0 55.71 71.69">
                <path
                    d="M30.76,49.18a4.8,4.8,0,1,0-5.82,0,1.23,1.23,0,0,1,.46,1.16l-1.1,6.82a.76.76,0,0,0,.75.89h5.61a.77.77,0,0,0,.76-.89l-1.1-6.82A1.2,1.2,0,0,1,30.76,49.18Z"
                    style="stroke-miterlimit: 10"
                />
                <path
                    d="M45.94,27.42H44.26V16.91a16.41,16.41,0,1,0-32.81,0V27.42H9.77A9.28,9.28,0,0,0,.5,36.7V61.91a9.28,9.28,0,0,0,9.27,9.28H45.94a9.28,9.28,0,0,0,9.27-9.28V36.7A9.28,9.28,0,0,0,45.94,27.42ZM16.32,16.91a11.54,11.54,0,1,1,23.07,0V27.42H16.32Zm34,45a4.4,4.4,0,0,1-4.4,4.4H9.77a4.41,4.41,0,0,1-4.4-4.4V36.7a4.41,4.41,0,0,1,4.4-4.4H45.94a4.4,4.4,0,0,1,4.4,4.4Z"
                    style="stroke-miterlimit: 10"
                />
            </symbol>
            <symbol
                id="refresh"
                viewBox="0 0 24 24"
                fill="none"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <polyline points="23 4 23 10 17 10"></polyline>
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
            </symbol>
            <symbol id="leave" viewBox="0 0 20 20">
                <path
                    d="M7,19H3a2,2,0,0,1-2-2V3A2,2,0,0,1,3,1H7"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <polyline
                    points="14 15 19 10 14 5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <line
                    x1="19"
                    y1="10"
                    x2="7"
                    y2="10"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
            </symbol>
            <symbol id="external-link" viewBox="0 0 20 20">
                <path
                    d="M16,11v6a2,2,0,0,1-2,2H3a2,2,0,0,1-2-2V6A2,2,0,0,1,3,4H9"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <polyline
                    points="13 1 19 1 19 7"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <line
                    x1="8"
                    y1="12"
                    x2="19"
                    y2="1"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
            </symbol>
            <symbol id="email" viewBox="0 0 23 19">
                <path
                    d="M3.5,1.5h16a2,2,0,0,1,2,2v12a2,2,0,0,1-2,2H3.5a2,2,0,0,1-2-2V3.5A2,2,0,0,1,3.5,1.5Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2px"
                />
                <polyline
                    points="21.5 3.5 11.5 10.5 1.5 3.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2px"
                />
            </symbol>
            <symbol id="square-x" viewBox="0 0 21 21">
                <rect
                    x="1.5"
                    y="1.5"
                    width="18"
                    height="18"
                    rx="2"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <line
                    x1="7.5"
                    y1="7.5"
                    x2="13.5"
                    y2="13.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <line
                    x1="13.5"
                    y1="7.5"
                    x2="7.5"
                    y2="13.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
            </symbol>
            <symbol id="square-check" viewBox="0 0 22 21">
                <polyline
                    points="7.5 9.5 10.5 12.5 20.5 2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <path
                    d="M19.5,10.5v7a2,2,0,0,1-2,2H3.5a2,2,0,0,1-2-2V3.5a2,2,0,0,1,2-2h11"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
            </symbol>
            <symbol id="square" viewBox="0 0 21 21">
                <rect
                    x="1.5"
                    y="1.5"
                    width="18"
                    height="18"
                    rx="2"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
            </symbol>
            <symbol id="msg-close" viewBox="0 0 122.88 122.88">
                <path
                    d="M61.44,0A61.42,61.42,0,1,1,18,18,61.3,61.3,0,0,1,61.44,0Zm12,39.15a7,7,0,0,1,10,0,7.19,7.19,0,0,1,0,10.08L71.4,61.44,83.48,73.69a7.13,7.13,0,0,1-.08,10,7,7,0,0,1-10,0l-12-12.16-12,12.19a7,7,0,0,1-10,0,7.18,7.18,0,0,1,0-10.08L51.48,61.44,39.4,49.19a7.14,7.14,0,0,1,.08-10,7,7,0,0,1,10,0l12,12.16,12-12.19ZM96.9,26a50.17,50.17,0,1,0,14.68,35.46A50,50,0,0,0,96.9,26Z"
                />
            </symbol>
            <symbol id="msg-error" viewBox="0 0 122.88 122.88">
                <path
                    d="M61.44,0A61.44,61.44,0,1,1,0,61.44,61.44,61.44,0,0,1,61.44,0Zm12,39.15a7,7,0,0,1,10,0,7.19,7.19,0,0,1,0,10.09L71.4,61.44,83.48,73.69a7.13,7.13,0,0,1-.08,10,7,7,0,0,1-10,0l-12-12.16-12,12.19a7,7,0,0,1-10,0,7.18,7.18,0,0,1,0-10.08L51.48,61.43,39.4,49.19a7.12,7.12,0,0,1,.09-10,7,7,0,0,1,9.95,0l12,12.16,12-12.19Z"
                    style="fill-rule: evenodd"
                />
            </symbol>
            <symbol id="msg-info" viewBox="0 0 122.9 122.9">
                <path
                    d="M61.4,0a61.45,61.45,0,1,0,61.5,61.4A61.39,61.39,0,0,0,61.4,0ZM59.7,32.8a6.77,6.77,0,0,1,1.8-2.6,6.77,6.77,0,0,1,2.6-1.8,8.05,8.05,0,0,1,6.1,0,6.77,6.77,0,0,1,2.6,1.8,6.77,6.77,0,0,1,1.8,2.6,8.66,8.66,0,0,1,.6,3.2,8.15,8.15,0,0,1-.6,3.1,8,8,0,0,1-1.8,2.7,6.77,6.77,0,0,1-2.6,1.8,8.31,8.31,0,0,1-6.2,0,6.77,6.77,0,0,1-2.6-1.8,7.61,7.61,0,0,1-1.8-2.6,11.27,11.27,0,0,1-.5-3.2A8.66,8.66,0,0,1,59.7,32.8ZM76,79.3a63.65,63.65,0,0,1-4.6,6.9,36.31,36.31,0,0,1-4.7,4.9A18.64,18.64,0,0,1,61.8,94a13,13,0,0,1-5.2,1,14,14,0,0,1-4.1-.6,6.91,6.91,0,0,1-3-1.7A8.3,8.3,0,0,1,47.6,90a11.33,11.33,0,0,1-.6-3.6,6.6,6.6,0,0,1,.1-1.4c.1-.5.1-1,.2-1.6a11.63,11.63,0,0,1,.4-1.8c.2-.6.4-1.4.7-2.3l5.7-17.8.5-1.7.3-1.2c.1-.3.1-.6.2-.9a2.2,2.2,0,0,0,.1-.8,3.59,3.59,0,0,0-.2-1.1,1.56,1.56,0,0,0-.6-.8,4.05,4.05,0,0,0-.9-.5,5.85,5.85,0,0,0-1.3-.2H47.6a.43.43,0,0,1-.4-.4v-.1l1.2-4.4c0-.2.2-.3.4-.3l23.7-.8a.43.43,0,0,1,.4.4v.1l-10.7,35-.2.6-.1.5v.6a1.27,1.27,0,0,0,.1.6.52.52,0,0,0,.2.4c.1.1.2.2.3.2a.9.9,0,0,0,.5.1,4.71,4.71,0,0,0,1.5-.6,14.46,14.46,0,0,0,2.2-2.1c.9-1.1,1.8-2.2,2.6-3.3.9-1.3,1.8-2.7,2.8-4.3.1-.2.3-.2.5-.1l3.3,2.4C76.1,78.9,76.1,79.1,76,79.3Z"
                />
            </symbol>
            <symbol id="msg-success" viewBox="0 0 96 96">
                <path
                    d="M48,0A48,48,0,1,1,0,48,48,48,0,0,1,48,0ZM26.76,49.28A5.52,5.52,0,0,1,35,45.49a4.87,4.87,0,0,1,.87.64l0,0c1.51,1.44,3.2,3,4.87,4.44l1.44,1.29L59.3,34a6,6,0,0,1,3.3-2.1,5.53,5.53,0,0,1,5.2,9.16L46.54,63.37a5.58,5.58,0,0,1-7.74.29c-1.23-1.15-2.58-2.31-3.93-3.49-2.35-2-4.75-4.13-6.7-6.19a5.58,5.58,0,0,1-1.41-4.7Z"
                    style="fill-rule: evenodd"
                />
            </symbol>
            <symbol id="msg-warning" viewBox="0 0 122.9 122.9">
                <path
                    d="M61.4,0a61.45,61.45,0,1,0,61.5,61.4A61.39,61.39,0,0,0,61.4,0Zm7.3,98.2a1.11,1.11,0,0,1-1.1,1.1H55.3a1.19,1.19,0,0,1-1-1.2V85.6a1.41,1.41,0,0,1,1-1.1H67.7a1,1,0,0,1,1,.8Zm2.2-73.7L68.8,79.8a1.38,1.38,0,0,1-1.1,1.3H55.4A1.27,1.27,0,0,1,54.3,80L52.1,24.5a.81.81,0,0,1,.7-.9H69.9a1,1,0,0,1,1,.9Z"
                />
            </symbol>
            <symbol id="compare" viewBox="0 0 122.87 98.12">
                <path
                    d="M37.21,15.38v.17H70.74V42.09H37V52a1.93,1.93,0,0,1,0,.24c-.09,2.07-.77,3.54-2.06,4.39s-3,.94-5.08.23a2.11,2.11,0,0,1-.61-.33C19.1,48.57,12.14,40.65,2,32.72L1.9,32.6A4.71,4.71,0,0,1,.11,27.9a6.64,6.64,0,0,1,2.6-3.63l24.76-22a11.72,11.72,0,0,1,3.67-2,4.81,4.81,0,0,1,3.07,0,4.15,4.15,0,0,1,2.42,2.39,8.83,8.83,0,0,1,.59,3.46v9.05a1.62,1.62,0,0,1,0,.23ZM85.67,82.73v-.17H52.14V56H85.93V46.16a1.85,1.85,0,0,1,0-.24c.09-2.07.77-3.54,2.06-4.39s3-.94,5.08-.23a2.11,2.11,0,0,1,.61.33c10.1,7.92,17.06,15.85,27.15,23.78l.14.12a4.71,4.71,0,0,1,1.79,4.7,6.64,6.64,0,0,1-2.6,3.63l-24.75,22a11.72,11.72,0,0,1-3.67,2.05,4.81,4.81,0,0,1-3.07,0,4.15,4.15,0,0,1-2.42-2.39A8.83,8.83,0,0,1,85.66,92V83a1.77,1.77,0,0,1,0-.23Z"
                />
            </symbol>
            <symbol id="signature" viewBox="0 0 157.27 93.06">
                <path
                    d="M156.27,23a3.37,3.37,0,0,0-4.76,0l-3,3-4-4.05,4.85-4.84A10,10,0,0,0,135.2,2.93L87.1,51l14.14,14.14c11.54-11.54,28.11-28.1,38.49-38.49l4,4.05L120,54.54a3.41,3.41,0,0,0,0,4.79c1.32,1.31,17.59-12.83,36.33-31.56A3.37,3.37,0,0,0,156.27,23Z"
                />
                <path
                    d="M83.22,54.92,78.64,59.5C66.14,72,58.88,84.2,60.05,89.58l-.08.08.31.34a4.2,4.2,0,0,0,2.43,2.22c5.37,1.17,17.57-6.09,30.07-18.58l4.58-4.59Z"
                />
                <path
                    d="M51.5,93.06H34.61c-14.54,0-22.38-11.12-22.38-21.58a20.46,20.46,0,0,1,5.89-14.56C21,54,26.34,50.5,35.05,50.5c10.12,0,15.85-2.72,18.87-5s4.91-5.5,4.91-8.74c0-6.92-7.86-13.92-22.89-13.92H6.5a6.5,6.5,0,0,1,0-13H35.94c23.57,0,35.89,13.55,35.89,26.92,0,12.88-11.51,26.75-36.78,26.75-3.36,0-6,.9-7.71,2.59a7.55,7.55,0,0,0-2.11,5.39c0,3.19,2,8.58,9.38,8.58H51.5a6.5,6.5,0,0,1,0,13Z"
                />
            </symbol>
            <symbol id="cash-check" viewBox="0 0 254.08 199.41">
                <rect x="36.54" y="128.5" width="8.88" height="7.01" />
                <path
                    d="M91.14,114.12h-7V119a8.7,8.7,0,0,0-5.7,8,8.87,8.87,0,0,0,8,8.58v.11h1.17a1.74,1.74,0,1,1-2.2,1.68v-1.17h-7v1.17a8.72,8.72,0,0,0,5.7,8v4.87h7v-4.87a8.72,8.72,0,0,0,5.7-8,8.87,8.87,0,0,0-8-8.58v-.11H87.64A1.74,1.74,0,1,1,89.83,127v1.17h7V127a8.7,8.7,0,0,0-5.7-8Z"
                />
                <path
                    d="M111.45.77,110.57,0,46.68,73.11l-.77.88,10.58,9.25H0v97.92H168.54l20.88,18.25,63.9-73.1.76-.88ZM244.2,126.09l-55.44,63.44L55.79,73.32,111.24,9.89Zm-97.94,36H29a8.93,8.93,0,0,1-8.92-8.92V111A8.93,8.93,0,0,1,29,102.12H78.1l3.51,3.07a27.68,27.68,0,1,0,33.6,29.36l17.4,15.22,14,12.25C146.51,162,146.39,162.07,146.26,162.07ZM108.32,132.2a20.68,20.68,0,1,1-20.68-20.68c.44,0,.9.08,1.35.12l18.85,16.48A19.43,19.43,0,0,1,108.32,132.2ZM70.08,95.11H29A16,16,0,0,0,13.08,111v42.11A16,16,0,0,0,29,169.08H146.26a15.4,15.4,0,0,0,6.67-1.56l7.59,6.63H7V90.25h57.5Z"
                />
                <rect
                    x="159.64"
                    y="77.81"
                    width="7.01"
                    height="101.07"
                    transform="translate(-40.86 166.73) rotate(-48.85)"
                />
                <rect
                    x="168.21"
                    y="68.01"
                    width="7.01"
                    height="101.07"
                    transform="translate(-30.55 169.82) rotate(-48.85)"
                />
                <rect
                    x="176.77"
                    y="58.21"
                    width="7.01"
                    height="101.07"
                    transform="translate(-20.24 172.93) rotate(-48.85)"
                />
                <path
                    d="M103.52,48.37c-4.09,4.67-3.34,12,1.66,16.38,2.27,2,2.74,5.19,1,7.14s-4.93,1.91-7.21-.08-2.74-5.19-1-7.13L93,60.36a11.37,11.37,0,0,0-.49,13.87L88.35,79l4.93,4.31,4.19-4.8a11.37,11.37,0,0,0,13.68-2.34c4.08-4.67,3.33-12-1.66-16.38-2.28-2-2.74-5.19-1-7.14s4.94-1.92,7.21.07,2.74,5.19,1,7.14l4.93,4.31a11.38,11.38,0,0,0,.5-13.87l4.19-4.79-4.93-4.31L117.19,46A11.36,11.36,0,0,0,103.52,48.37Z"
                />
                <rect
                    x="119.66"
                    y="71.68"
                    width="7.01"
                    height="8.88"
                    transform="translate(-15.2 118.76) rotate(-48.84)"
                />
                <rect x="88" y="44.01" width="7.01" height="8.88" transform="translate(-5.21 85.42) rotate(-48.83)" />
            </symbol>
            <symbol id="finance-options" viewBox="0 0 203.43 168.35">
                <path
                    d="M157.83,77.16V14a3.51,3.51,0,0,0-3.51-3.51H126.26v-7A3.5,3.5,0,0,0,122.76,0H105.22a3.51,3.51,0,0,0-3.51,3.51v7.12a3.23,3.23,0,0,0-.54-.11H56.12v-7A3.51,3.51,0,0,0,52.61,0H35.07a3.5,3.5,0,0,0-3.5,3.51v7H3.51A3.51,3.51,0,0,0,0,14V143.8a3.51,3.51,0,0,0,3.51,3.51H119.25c.07,0,.13,0,.2,0a45.57,45.57,0,1,0,38.38-70.11ZM108.73,7h10.52V17.54H108.73ZM38.58,7H49.1V17.54H38.58ZM7,17.54H31.57V21a3.5,3.5,0,0,0,3.5,3.51H52.61A3.51,3.51,0,0,0,56.12,21v-3.5h45.05a3.23,3.23,0,0,0,.54-.11V21a3.51,3.51,0,0,0,3.51,3.51h17.54a3.5,3.5,0,0,0,3.5-3.51v-3.5h24.56v14H7ZM7,140.29V38.58H150.82V77.76a45.51,45.51,0,0,0-35.07,62.53Zm150.82,21.05a38.58,38.58,0,1,1,38.58-38.58A38.63,38.63,0,0,1,157.83,161.34Z"
                />
                <path
                    d="M160.76,119.25H154.9a6.75,6.75,0,0,1,0-13.49h13.18a3.51,3.51,0,1,0,0-7h-8.21V93.47a3.51,3.51,0,1,0-7,0V99a13.73,13.73,0,0,0,2,27.31h5.86a6.75,6.75,0,0,1,0,13.49H147.58a3.51,3.51,0,1,0,0,7h5.28v5.28a3.51,3.51,0,0,0,7,0v-5.28h.89a13.76,13.76,0,1,0,0-27.52Z"
                />
                <path
                    d="M35.07,45.6H17.54A3.5,3.5,0,0,0,14,49.1V66.64a3.51,3.51,0,0,0,3.51,3.51H35.07a3.51,3.51,0,0,0,3.51-3.51V49.1A3.5,3.5,0,0,0,35.07,45.6Zm-3.5,17.53H21V52.61H31.57Z"
                />
                <path
                    d="M70.15,45.6H52.61a3.5,3.5,0,0,0-3.51,3.5V66.64a3.51,3.51,0,0,0,3.51,3.51H70.15a3.5,3.5,0,0,0,3.5-3.51V49.1A3.49,3.49,0,0,0,70.15,45.6ZM66.64,63.13H56.12V52.61H66.64Z"
                />
                <path
                    d="M105.22,45.6H87.68a3.49,3.49,0,0,0-3.5,3.5V66.64a3.5,3.5,0,0,0,3.5,3.51h17.54a3.51,3.51,0,0,0,3.51-3.51V49.1A3.5,3.5,0,0,0,105.22,45.6Zm-3.51,17.53H91.19V52.61h10.52Z"
                />
                <path
                    d="M35.07,77.16H17.54A3.51,3.51,0,0,0,14,80.67V98.21a3.51,3.51,0,0,0,3.51,3.5H35.07a3.51,3.51,0,0,0,3.51-3.5V80.67A3.51,3.51,0,0,0,35.07,77.16ZM31.57,94.7H21V84.18H31.57Z"
                />
                <path
                    d="M70.15,77.16H52.61a3.51,3.51,0,0,0-3.51,3.51V98.21a3.51,3.51,0,0,0,3.51,3.5H70.15a3.5,3.5,0,0,0,3.5-3.5V80.67A3.5,3.5,0,0,0,70.15,77.16ZM66.64,94.7H56.12V84.18H66.64Z"
                />
                <path
                    d="M105.22,77.16H87.68a3.5,3.5,0,0,0-3.5,3.51V98.21a3.5,3.5,0,0,0,3.5,3.5h17.54a3.51,3.51,0,0,0,3.51-3.5V80.67A3.51,3.51,0,0,0,105.22,77.16ZM101.71,94.7H91.19V84.18h10.52Z"
                />
                <path
                    d="M35.07,108.73H17.54a3.51,3.51,0,0,0-3.51,3.5v17.54a3.51,3.51,0,0,0,3.51,3.51H35.07a3.51,3.51,0,0,0,3.51-3.51V112.23A3.51,3.51,0,0,0,35.07,108.73Zm-3.5,17.53H21V115.74H31.57Z"
                />
                <path
                    d="M70.15,108.73H52.61a3.51,3.51,0,0,0-3.51,3.5v17.54a3.51,3.51,0,0,0,3.51,3.51H70.15a3.5,3.5,0,0,0,3.5-3.51V112.23A3.5,3.5,0,0,0,70.15,108.73Zm-3.51,17.53H56.12V115.74H66.64Z"
                />
                <path
                    d="M105.22,108.73H87.68a3.5,3.5,0,0,0-3.5,3.5v17.54a3.5,3.5,0,0,0,3.5,3.51h17.54a3.51,3.51,0,0,0,3.51-3.51V112.23A3.51,3.51,0,0,0,105.22,108.73Zm-3.51,17.53H91.19V115.74h10.52Z"
                />
                <path
                    d="M122.76,70.15h17.53a3.51,3.51,0,0,0,3.51-3.51V49.1a3.5,3.5,0,0,0-3.51-3.5H122.76a3.5,3.5,0,0,0-3.51,3.5V66.64A3.51,3.51,0,0,0,122.76,70.15Zm3.5-17.54h10.53V63.13H126.26Z"
                />
            </symbol>
            <symbol id="list" viewBox="0 0 25 22">
                <rect width="4" height="4" rx="0.55" />
                <rect y="6" width="4" height="4" rx="0.55" />
                <rect y="12" width="4" height="4" rx="0.55" />
                <rect y="18" width="4" height="4" rx="0.55" />
                <rect x="6" y="1" width="19" height="2" rx="0.56" />
                <rect x="6" y="7" width="19" height="2" rx="0.56" />
                <rect x="6" y="13" width="19" height="2" rx="0.56" />
                <rect x="6" y="19" width="19" height="2" rx="0.56" />
            </symbol>
            <symbol id="copy" viewBox="0 0 24.97 24.89">
                <rect style="stroke: none" x="13.69" y="9.61" width="2" height="10" />
                <g>
                    <path
                        d="M5.44,19.53v1.31a3,3,0,0,0,3,3H20.92a3,3,0,0,0,3-3V8.39a3,3,0,0,0-3-3H19.53"
                        style="fill: none; stroke-miterlimit: 10; stroke-width: 2.055555555555452px"
                    />
                    <path
                        d="M8.47,5.36H19.53V4.05a3,3,0,0,0-3-3H4.05a3,3,0,0,0-3,3V16.5a3,3,0,0,0,3,3H5.44V8.39A3,3,0,0,1,8.47,5.36Z"
                        style="fill: none; stroke-miterlimit: 10; stroke-width: 2.055555555555452px"
                    />
                </g>
                <rect style="stroke: none" x="9.69" y="13.61" width="10" height="2" />
            </symbol>
            <symbol id="window-types" viewBox="0 0 19 19">
                <rect x="1" y="1" width="7" height="7" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px" />
                <rect x="11" y="1" width="7" height="7" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px" />
                <rect x="11" y="11" width="7" height="7" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px" />
                <rect x="1" y="11" width="7" height="7" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px" />
            </symbol>
            <symbol id="slider" viewBox="0 0 18 15">
                <path
                    style="stroke: none"
                    d="M16,8a2.5,2.5,0,0,1-4.9,0H.5a.5.5,0,0,1,0-1H11.05A2.5,2.5,0,0,1,16,7H17.5a.5.5,0,0,1,0,1ZM7,3a2.5,2.5,0,0,1-4.9,0H.5a.5.5,0,0,1,0-1H2.05A2.5,2.5,0,0,1,7,2H17.5a.5.5,0,0,1,0,1ZM4.5,4A1.5,1.5,0,1,0,3,2.5,1.5,1.5,0,0,0,4.5,4Zm9,5A1.5,1.5,0,1,0,12,7.5,1.5,1.5,0,0,0,13.5,9ZM7,13a2.5,2.5,0,0,1-4.9,0H.5a.5.5,0,0,1,0-1H2.05A2.5,2.5,0,0,1,7,12H17.5a.5.5,0,0,1,0,1ZM4.5,14A1.5,1.5,0,1,0,3,12.5,1.5,1.5,0,0,0,4.5,14Z"
                />
            </symbol>
        </g>

        <!-- WYSIWYG Editor icons -->
        <g>
            <symbol id="wysiwyg-ordered" viewBox="0 0 21.15 19.2">
                <line
                    x1="6.65"
                    y1="3.27"
                    x2="19.65"
                    y2="3.27"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <line
                    x1="6.65"
                    y1="9.27"
                    x2="19.65"
                    y2="9.27"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <line
                    x1="6.65"
                    y1="15.27"
                    x2="19.65"
                    y2="15.27"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <text
                    transform="translate(0 5.14)"
                    style="font-size: 6px; font-family: OpenSans-ExtraBold, Open Sans; font-weight: 800; color: #333"
                >
                    1
                </text>
                <text
                    transform="translate(0 11.33)"
                    style="font-size: 6px; font-family: OpenSans-ExtraBold, Open Sans; font-weight: 800; color: #333"
                >
                    2
                </text>
                <text
                    transform="translate(0 17.45)"
                    style="font-size: 6px; font-family: OpenSans-ExtraBold, Open Sans; font-weight: 800; color: #333"
                >
                    3
                </text>
            </symbol>
            <symbol id="wysiwyg-bullet" viewBox="0 0 21 15">
                <line
                    x1="6.5"
                    y1="1.5"
                    x2="19.5"
                    y2="1.5"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <line
                    x1="6.5"
                    y1="7.5"
                    x2="19.5"
                    y2="7.5"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <line
                    x1="6.5"
                    y1="13.5"
                    x2="19.5"
                    y2="13.5"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <line
                    x1="1.5"
                    y1="1.5"
                    x2="1.51"
                    y2="1.5"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <line
                    x1="1.5"
                    y1="7.5"
                    x2="1.51"
                    y2="7.5"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <line
                    x1="1.5"
                    y1="13.5"
                    x2="1.51"
                    y2="13.5"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
            </symbol>
            <symbol id="wysiwyg-redo" viewBox="0 0 23 21">
                <polyline
                    points="21.5 2.5 21.5 8.5 15.5 8.5"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <path
                    d="M19,13.5A9,9,0,1,1,13.5,2a8.89,8.89,0,0,1,3.37,2.12L21.5,8.5"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
            </symbol>
            <symbol id="wysiwyg-undo" viewBox="0 0 23 21">
                <polyline
                    points="1.5 2.49 1.5 8.49 7.5 8.49"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <path
                    d="M4,13.49A9,9,0,1,0,6.14,4.13L1.5,8.49"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
            </symbol>
            <symbol id="wysiwyg-italic" viewBox="0 0 17 19">
                <line
                    x1="15.5"
                    y1="1.5"
                    x2="6.5"
                    y2="1.5"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <line
                    x1="10.5"
                    y1="17.5"
                    x2="1.5"
                    y2="17.5"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <line
                    x1="11.5"
                    y1="1.5"
                    x2="5.5"
                    y2="17.5"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
            </symbol>
            <symbol id="wysiwyg-bold" viewBox="0 0 16 19">
                <path
                    d="M1.5,1.5h8a4,4,0,0,1,0,8h-8Z"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <path
                    d="M1.5,9.5h9a4,4,0,0,1,0,8h-9Z"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
            </symbol>
            <symbol id="wysiwyg-check" viewBox="0 0 22 21">
                <polyline
                    points="7.5 9.5 10.5 12.5 20.5 2.5"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <path
                    d="M19.5,10.5v7a2,2,0,0,1-2,2H3.5a2,2,0,0,1-2-2V3.5a2,2,0,0,1,2-2h11"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
            </symbol>
            <symbol id="wysiwyg-underline" viewBox="0 0 19 21">
                <path
                    d="M3.5,1.5v7a6,6,0,0,0,12,0v-7"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <line
                    x1="1.5"
                    y1="19.5"
                    x2="17.5"
                    y2="19.5"
                    style="fill: none; stroke: #333; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
            </symbol>
        </g>

        <!-- Estimate icons - 6 main categories -->
        <g>
            <symbol id="estimate-insulation" viewBox="0 0 105.99 129.05">
                <path
                    d="M104.73,16.8a3,3,0,0,0-3.23-.15L77.8,30.27V11a2.1,2.1,0,0,0-1.31-1.94L67.12,5.24a2.73,2.73,0,0,0-2.38.17L40,19.72V3A3,3,0,0,0,35.54.4L2,19.7a3.91,3.91,0,0,0-2,3.38V110a2.87,2.87,0,0,0,4.31,2.49L27.62,98.92v18.45A1.7,1.7,0,0,0,28.81,119l10.36,3.3a3,3,0,0,0,2.37-.25l.5-.29h0L66,108.05v18.08a2.93,2.93,0,0,0,4.38,2.53L104.62,109a2.73,2.73,0,0,0,1.37-2.37V19.25A3,3,0,0,0,104.73,16.8ZM66.25,10,70,11.56l-5.79,3.33-4.12-1.31ZM32.37,114.77v-6l5.39,1.71v6Zm0-28.1,5.39,1.72v6l-5.39-1.71ZM37.76,55.3v6l-5.39-1.71v-6Zm-5.39-6.7v-6l5.39,1.71v6Zm5.39,17.73v6l-5.39-1.71v-6Zm0,11v6l-5.39-1.71v-6Zm0-38.07-5.39-1.72v-6l5.39,1.71Zm0,60.13v6l-5.39-1.72v-6Zm2.07-70.51-4-1.27L42.21,24l4,1.28Zm12-6.89-4.06-1.29,6.8-3.93,4.09,1.3ZM4.75,106.72V23.58L35.29,6V22.47l-6.71,3.88a1.94,1.94,0,0,0-1,1.67V93.43ZM67.91,36a3.89,3.89,0,0,0-2,3.38v63.24L42.51,116V32.85L73.05,15.3V33Zm33.33,69.47L70.71,123V39.82l30.53-17.54Z"
                ></path>
            </symbol>
            <symbol id="estimate-repairs" viewBox="0 0 131.83 121.04">
                <path
                    d="M28.35,98.5A2.29,2.29,0,0,0,30,97.83L56.25,71.55a2.29,2.29,0,0,0,0-3.25h0a2.31,2.31,0,0,0-3.25,0L26.73,94.58a2.3,2.3,0,0,0,1.62,3.92Z"
                ></path>
                <path
                    d="M34,105.11a2.33,2.33,0,0,0,1.63.67,2.29,2.29,0,0,0,1.62-.67L63.53,78.83a2.3,2.3,0,0,0-3.25-3.25L34,101.86A2.31,2.31,0,0,0,34,105.11Z"
                ></path>
                <path
                    d="M122.25,24.72h0a2.31,2.31,0,0,0,1.25-1l8-14.06a2.29,2.29,0,0,0-.37-2.76L125,.67A2.32,2.32,0,0,0,122.2.3l-14,8a2.31,2.31,0,0,0-1,1.26L104.23,18l-31,31-21-21,.11-.1A2.29,2.29,0,0,0,53,26.31a2.24,2.24,0,0,0-.67-1.62l-7.06-7.06c2.14-3.26,6.55-6.95,15.54-6.95.61,0,1.24,0,1.87.05a2.47,2.47,0,0,0,1.7-.55,2.38,2.38,0,0,0,.85-1.83c0-2.07-3.11-4-5-4.94A24.48,24.48,0,0,0,49.07.77a27.9,27.9,0,0,0-6.37.75A30.77,30.77,0,0,0,27.93,9.81L14.42,23.32a2.29,2.29,0,0,0-.65,1.89l.46,4.12a1.52,1.52,0,0,1-.39,1.24,1.61,1.61,0,0,1-1.37.52l-4.12-.47a2.3,2.3,0,0,0-1.89.66L1.81,35.94a6.19,6.19,0,0,0,0,8.74L12.47,55.34a6.18,6.18,0,0,0,8.74,0l4.66-4.66a2.33,2.33,0,0,0,.66-1.88l-.38-3.33a1.59,1.59,0,0,1,2-1.72l5.3,1.38a2.3,2.3,0,0,0,2.2-.59l.29-.29L49.61,58,15,92.61a14.18,14.18,0,0,0,0,20.07l4.21,4.21a14.2,14.2,0,0,0,20.06,0L73.88,82.23l35.38,35.37a11.22,11.22,0,0,0,8,3.3,11.36,11.36,0,0,0,8.09-3.35l.16-.16a11.36,11.36,0,0,0,0-16L82.79,58.61l31-31ZM70.64,79,36,113.64a9.61,9.61,0,0,1-13.58,0l-4.2-4.21a9.6,9.6,0,0,1,0-13.57L52.86,61.2Zm40.28-55L79.54,55.36l-3.06-3.07,31.38-31.38a2.19,2.19,0,0,0,.55-.88l2.77-8.14L123,5.16l3.71,3.72-6.73,11.77-8.14,2.78A2.26,2.26,0,0,0,110.92,24Zm11.32,90.17-.16.16a6.78,6.78,0,0,1-9.58,0L39.18,41,49,31.28l73.32,73.32a6.67,6.67,0,0,1,1.95,4.76A6.78,6.78,0,0,1,122.24,114.15ZM21.58,46l.26,2.24L18,52.09a1.62,1.62,0,0,1-2.24,0L5.06,41.43a1.58,1.58,0,0,1-.47-1.12,1.57,1.57,0,0,1,.47-1.12l3.87-3.88,3,.35a6.19,6.19,0,0,0,6.85-6.85l-.34-3L31.18,13.06A26.2,26.2,0,0,1,43.74,6a23.91,23.91,0,0,1,5.33-.62,20.49,20.49,0,0,1,6.7,1.09C46.21,8,42,13.6,40.36,17a2.29,2.29,0,0,0,.43,2.64l6.67,6.67L33.32,40.36l-4-1.06A6.19,6.19,0,0,0,21.58,46Z"
                ></path>
            </symbol>
            <symbol id="estimate-roofing" viewBox="0 0 140.17 130.86">
                <path
                    d="M140.17,73.9c0-.12,0-.22-.06-.34a2.13,2.13,0,0,0-.11-.5,1.76,1.76,0,0,0-.26-.44,1.65,1.65,0,0,0-.18-.31L77.13,3a9.46,9.46,0,0,0-7-3h0A9.43,9.43,0,0,0,63,3L.61,72.31c-.08.1-.11.21-.18.31a2.13,2.13,0,0,0-.26.44,2.1,2.1,0,0,0-.1.51A1.76,1.76,0,0,0,0,73.9V119s0,0,0,.06,0,0,0,.07a2.88,2.88,0,0,0,.11.42,3.39,3.39,0,0,0,.11.43,2.37,2.37,0,0,0,.22.33,2.45,2.45,0,0,0,.31.41l0,0,10.57,9.52a2.33,2.33,0,0,0,1.71.61,2.43,2.43,0,0,0,1.63-.78l12-13.36h86.69l12,13.36a2.38,2.38,0,0,0,3.35.17l10.57-9.52a.1.1,0,0,1,0,0,3.08,3.08,0,0,0,.3-.41,2.1,2.1,0,0,0,.22-.33,1.7,1.7,0,0,0,.11-.43,2.17,2.17,0,0,0,.11-.42s0,0,0-.07,0,0,0-.06ZM30.29,63.09l-9.93,11V57.49l9.94-11ZM35,41.23,46.3,28.7V45.33L35,57.83V41.34S35,41.26,35,41.23ZM15.61,79.38,4.74,91.44V74.81L15.61,62.75ZM4.74,98.53,15.61,86.47v14.06a1.24,1.24,0,0,0,0,.16L4.74,112.79ZM20.36,81.2l9.93-11V84.35s0,.05,0,.07l-9.94,11ZM35,64.92,46.3,52.42V66.61a.43.43,0,0,0,0,0L35,79.18ZM51,47.15,66.56,29.92a4.71,4.71,0,0,1,3.53-1.46h0a4.71,4.71,0,0,1,3.52,1.46L89.13,47.15V61.41l-12-13.32a9.71,9.71,0,0,0-14.09,0L51,61.41ZM93.88,66.61V52.42l11.26,12.5V79.18L93.87,66.66A.43.43,0,0,0,93.88,66.61Zm41.55,24.83L124.56,79.38V62.75l10.87,12.06ZM119.82,57.51V74.12l-9.93-11V46.47l9.93,11ZM105.14,41.34V57.83L93.88,45.33V28.7l11.29,12.53A.45.45,0,0,0,105.14,41.34Zm4.75,43V70.18l9.93,11V95.46l-9.95-11S109.89,84.38,109.89,84.35Zm14.67,16.18V86.47l10.87,12.06v14.26l-10.9-12.1C124.53,100.63,124.56,100.58,124.56,100.53Zm-58-94.32a4.72,4.72,0,0,1,3.53-1.47h0a4.71,4.71,0,0,1,3.52,1.47L89.16,23.47s0,.08,0,.13V40.07l-12-13.32a9.42,9.42,0,0,0-7-3h0a9.43,9.43,0,0,0-7.05,3L51,40.06V23.6c0-.05,0-.09,0-.14Zm60.85,118.93-11.16-12.38a2.4,2.4,0,0,0-1.77-.79H25.69a2.38,2.38,0,0,0-1.77.79L12.77,125.14l-7-6.35L66.56,51.27a5.15,5.15,0,0,1,7,0l60.84,67.52Z"
                ></path>
                <path
                    d="M103.42,98.53,71.85,63.48a2.47,2.47,0,0,0-3.53,0L36.75,98.53a2.37,2.37,0,0,0,1.76,4h63.15a2.37,2.37,0,0,0,1.76-4Zm-59.58-.79L70.08,68.59,96.33,97.74Z"
                ></path>
            </symbol>
            <symbol id="estimate-siding" viewBox="0 0 120.14 117.2">
                <path
                    d="M119.21,1.26A3.45,3.45,0,0,0,116.56,0H7.75A3.83,3.83,0,0,0,4.11,3.29l-4,22.83a4.13,4.13,0,0,0,.86,3.4,3.51,3.51,0,0,0,2.15,1.2l-3,17A4.11,4.11,0,0,0,.93,51.1a3.44,3.44,0,0,0,2.15,1.2l-3,17a4.11,4.11,0,0,0,.86,3.39,3.42,3.42,0,0,0,2.14,1.2l-3,17a4.11,4.11,0,0,0,.86,3.39,3.5,3.5,0,0,0,2.15,1.21l-3,17a4.11,4.11,0,0,0,.86,3.39,3.45,3.45,0,0,0,2.65,1.26H116.35a3.83,3.83,0,0,0,3.64-3.29l0-.2.1-109.55A4,4,0,0,0,119.21,1.26ZM8.68,4.75H115.23L111.46,26H4.91Zm-.79,26H114.44l-3,16.84H4.91Zm0,21.59H114.45l-3,16.88H4.91ZM7.89,74H114.44l-3,16.83H4.91Zm107.39,38.46H4.91l3-16.88H115.34Z"
                ></path>
            </symbol>
            <symbol id="estimate-windows" viewBox="0 0 124.39 119.53">
                <path
                    d="M122,0H2.43A2.43,2.43,0,0,0,0,2.43V117.1a2.43,2.43,0,0,0,2.43,2.43H122a2.43,2.43,0,0,0,2.43-2.43V2.43A2.43,2.43,0,0,0,122,0Zm-2.43,114.67H4.86V4.86H119.53Z"
                ></path>
                <path
                    d="M27.05,58.89l21.27-34a2.43,2.43,0,0,0-4.13-2.58l-21.27,34a2.44,2.44,0,0,0,.78,3.35A2.4,2.4,0,0,0,25,60,2.45,2.45,0,0,0,27.05,58.89Z"
                ></path>
                <path
                    d="M49.17,41.36a2.43,2.43,0,0,0-3.35.78l-21.28,34a2.43,2.43,0,0,0,.78,3.35,2.4,2.4,0,0,0,1.28.37,2.43,2.43,0,0,0,2.07-1.14l21.27-34A2.43,2.43,0,0,0,49.17,41.36Z"
                ></path>
                <path d="M98.49,61.18l-21.27,34a2.43,2.43,0,0,0,4.12,2.58l21.27-34a2.43,2.43,0,1,0-4.12-2.57Z"></path>
                <path
                    d="M77.18,80.53a2.43,2.43,0,0,0,3.35-.77l21.27-34a2.43,2.43,0,1,0-4.12-2.57l-21.27,34A2.43,2.43,0,0,0,77.18,80.53Z"
                ></path>
                <path
                    d="M15,109.81H109.4a2.43,2.43,0,0,0,2.43-2.44V12.16a2.43,2.43,0,0,0-2.43-2.44H15a2.43,2.43,0,0,0-2.43,2.44v95.21A2.43,2.43,0,0,0,15,109.81Zm92-4.87H64.55a2.57,2.57,0,0,0,.08-.4V15a2.57,2.57,0,0,0-.08-.4H107ZM17.42,14.59H59.85a1.77,1.77,0,0,0-.08.4v89.55a1.77,1.77,0,0,0,.08.4H17.42Z"
                ></path>
            </symbol>
            <symbol id="estimate-gutters" viewBox="0 0 131.82 112.83">
                <path
                    d="M111.64,24.94a18.92,18.92,0,0,0,7.91-1.71A21.54,21.54,0,0,0,131.82,3.47,2.44,2.44,0,0,0,129.38,1H37.93a2.44,2.44,0,0,0-2.44,2.44A17.18,17.18,0,0,1,31,15.26a15.2,15.2,0,0,1-4.87,3.52,14.27,14.27,0,0,1-11.79,0A16.47,16.47,0,0,1,5,5.31l0-.43H28.16a2.43,2.43,0,0,0,2.27-1.55,2.47,2.47,0,0,0,.17-.89A2.44,2.44,0,0,0,28.16,0H2.44A2.45,2.45,0,0,0,0,2.44a3.13,3.13,0,0,0,0,.44L.06,3,0,3a3.13,3.13,0,0,0,0,.44A22.06,22.06,0,0,0,5.85,18.59a20.2,20.2,0,0,0,6.42,4.64,18.92,18.92,0,0,0,7.91,1.71h57.2V43.11l-14,8a11.13,11.13,0,0,0-5.63,9.67v45.84a4.23,4.23,0,0,0,.41,1.8,4.8,4.8,0,0,0,.82,1.23,7.43,7.43,0,0,0,1.93,1.47,12.93,12.93,0,0,0,3.62,1.29,20.39,20.39,0,0,0,4.36.45,21.46,21.46,0,0,0,3.82-.34,16.5,16.5,0,0,0,2.54-.67,9.57,9.57,0,0,0,3.12-1.77,5.4,5.4,0,0,0,1.15-1.46,4.28,4.28,0,0,0,.51-2V67.23l14-8a11.14,11.14,0,0,0,5.62-9.68V24.94h12ZM94.77,49.58A6.23,6.23,0,0,1,91.61,55h0L76.39,63.68a2.46,2.46,0,0,0-1.23,2.13v40.58l-.14.11-.36.25a8.6,8.6,0,0,1-2.32.84,16.2,16.2,0,0,1-3.43.35,17.31,17.31,0,0,1-2.94-.25,11.36,11.36,0,0,1-1.77-.47,5.5,5.5,0,0,1-1.4-.71l-.15-.12V60.75a6.23,6.23,0,0,1,3.16-5.43L81,46.65a2.43,2.43,0,0,0,1.23-2.12V33.39l.5.16c.52.16,1,.28,1.4.37a21.63,21.63,0,0,0,8.18.1,15.94,15.94,0,0,0,1.93-.48l.5-.15Zm2.44-29.52a2.42,2.42,0,0,0-2.44,2.44v5.42l-.15.12a2.21,2.21,0,0,1-.36.24,8.08,8.08,0,0,1-2.31.84,15.59,15.59,0,0,1-3.44.36,16.33,16.33,0,0,1-2.94-.26,12.84,12.84,0,0,1-1.76-.46,5.13,5.13,0,0,1-1.4-.72l-.15-.11V22.5a2.42,2.42,0,0,0-2.44-2.44H33l.69-.67A21.87,21.87,0,0,0,40.2,6.25l0-.34h86.53l-.07.45a16.94,16.94,0,0,1-4.31,8.9,15.17,15.17,0,0,1-4.86,3.52,14.15,14.15,0,0,1-5.9,1.28Z"
                ></path>
            </symbol>
            <symbol id="estimate-trim" viewBox="0 0 148.67 109.16">
                <path
                    d="m148.51,83.85c.02-.06.05-.12.07-.18.06-.2.09-.41.09-.62,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0l-.28-80.8c0-.76-.39-1.46-1.02-1.88-.63-.41-1.43-.48-2.13-.18l-62.49,27.12-15.42-4.14s-.04,0-.06-.01c-.03,0-.06,0-.08-.02-.19-.04-.37-.05-.55-.04-.02,0-.03,0-.05,0-.18.01-.36.06-.54.11-.03,0-.06,0-.08.02L1.46,47.09c-.71.26-1.23.87-1.41,1.6-.17.74.04,1.51.56,2.06.02.02,2.25,2.42,2.25,5.69,0,4.77,2.71,8.04,2.89,8.26,0,0,0,0,0,0,0,0,0,.01,0,.01,0,0,.02.01.02.02.09.1.19.19.29.27.03.03.07.05.1.08.09.06.19.12.29.17.03.02.06.03.09.05.13.05.26.1.39.13l9.2,2.14v16.3s0,0,0,0c0,0,0,0,0,0,0,0,0,.02,0,.02,0,.2.04.4.09.59.02.06.05.12.07.18.05.13.11.26.19.38.04.06.08.12.12.17.09.12.19.22.31.32.05.04.08.08.13.12.02.01.03.03.05.04.08.06.18.09.27.13.08.04.16.1.25.14l63.49,23.01c.25.09.51.13.77.13s.53-.05.78-.14l64.51-23.86c.1-.04.17-.1.26-.14.08-.04.18-.07.25-.13.02-.01.03-.03.05-.04.05-.04.09-.08.14-.12.11-.1.21-.2.3-.32.04-.06.08-.11.12-.17.08-.12.14-.25.19-.39Zm-45.42,12.83l-56.94-20.64,15.29-5.66,56.94,20.64-15.29,5.66ZM143.91,6.42l.03,9.41c-.15.03-.3.07-.44.13l-5.59,2.33,6-11.88Zm-10.58,13.79l-6.39,2.67,6.37-12.61,6.46-2.8-6.44,12.74Zm-4.61-7.94l-6.31,12.5-6.39,2.67,6.25-12.38,6.46-2.8s0,0,0,.01Zm-17.23,17.06l-6.39,2.67,6.14-12.14,6.46-2.8-6.2,12.28Zm-11.02,4.6l-5.42,2.26c-.84.35-1.38,1.17-1.38,2.08v9.09l-6.06,11.99s0,0,0,0l-2.43-.88v-4.28l9.28-18.37c.03-.05.07-.1.1-.15l5.54-10.97,6.46-2.8-6.09,12.05Zm-63.04,27.25l4.65-1.72c-.02.05-.03.11-.06.16l-8.17,16.18-6.2,2.29,8.26-16.35,1.52-.56Zm56.24.36l-2.75-1,2.75-5.45v6.44Zm-33.74,4.61l-.34.13c.03-.07.04-.15.08-.22l8.14-16.11,6.2-2.29-8.26,16.35-4.57,1.69c-.45.02-.89.19-1.25.46Zm-15.37,5.69l-5.45,2.02c-.21.04-.42.12-.61.22l-.22.08s.02-.06.03-.09l8.21-16.25,6.3-2.33-8.26,16.35Zm12.65-17.97l6.2-2.29s0,.02-.01.03l-8.24,16.31-6.2,2.29,8.26-16.35Zm21.24-7.86l2.23-.83v6.38l-4.29,8.5-6.2,2.29,8.26-16.35Zm7.54-.46c-.19.38-.48.67-.81.88v-9.26l3.89-7.69,6.46-2.8-9.54,18.88Zm-65.32,29.32l4.65-9.21,6.2-2.29s0,0,0,0l-8.25,16.34-2.59.96v-5.8Zm77.48-11.7c0-.08.02-.15.02-.23v-23.17l45.78-19.11.2,59.19-46.01-16.68Zm-17.47-31.76v7.71l-7.34-1.71s-.01-.02-.02-.03c-.09-.15-.2-.32-.3-.52-.02-.04-.04-.09-.07-.13-.09-.17-.17-.35-.26-.54-.04-.08-.07-.16-.1-.24-.08-.19-.15-.39-.22-.59-.03-.09-.06-.18-.09-.27-.09-.3-.18-.62-.24-.96-.09-.52-.14-1.03-.14-1.52,0-.33-.02-.66-.04-.97,0-.11-.03-.21-.04-.32-.02-.21-.04-.41-.08-.61-.02-.13-.05-.25-.07-.37-.03-.17-.07-.35-.11-.51-.03-.13-.07-.25-.1-.38-.04-.15-.08-.31-.13-.46,0-.03-.02-.06-.02-.09l9.38,2.52Zm-14.72-3.38c.09.15.19.29.28.47.02.03.03.06.05.1.12.22.24.46.36.72.01.02.02.04.03.07.12.26.22.55.32.85.02.06.04.12.06.18.09.3.16.61.22.94,0,.06.02.12.03.18.05.35.09.71.09,1.08,0,.77.07,1.55.22,2.34.07.39.16.76.26,1.12.03.11.06.21.09.31.08.26.16.51.25.75.03.09.06.18.1.27.12.3.24.59.36.85L8.4,60.53c-.49-.95-1.02-2.38-1.02-4.07,0-2.49-.8-4.61-1.63-6.15l60.22-22.27Zm5.39,14.02l.8-.3,2.96.69-41.06,15.19-15.78,5.83-2.98-.69,56.05-20.72Zm10.55,62.46l-56.94-20.64,14.65-5.42,56.94,20.64-14.65,5.42Zm43.02-15.91l-56.94-20.64,14.96-5.53,56.94,20.64-14.96,5.53Z"
                />
            </symbol>
            <symbol id="estimate-decking" viewBox="0 0 131.82 112.83">
                <rect x="8" y="10" width="115.82" height="18" rx="3"></rect>
                <rect x="8" y="35" width="115.82" height="18" rx="3"></rect>
                <rect x="8" y="60" width="115.82" height="18" rx="3"></rect>
                <rect x="8" y="85" width="115.82" height="18" rx="3"></rect>

                <circle cx="20" cy="19" r="1.8"></circle>
                <circle cx="111" cy="19" r="1.8"></circle>

                <circle cx="20" cy="44" r="1.8"></circle>
                <circle cx="111" cy="44" r="1.8"></circle>

                <circle cx="20" cy="69" r="1.8"></circle>
                <circle cx="111" cy="69" r="1.8"></circle>

                <circle cx="20" cy="94" r="1.8"></circle>
                <circle cx="111" cy="94" r="1.8"></circle>
            </symbol>
        </g>

        <!-- Roofing estimate icons -->
        <g>
            <symbol id="decking-new" viewBox="0 0 112.12 130.86">
                <path
                    d="M109.43,66.72,57.23,8.08a.08.08,0,0,0-.14.05V53a.77.77,0,0,0,.18.48l52.21,58.64a.08.08,0,0,0,.14-.05V67.21A.75.75,0,0,0,109.43,66.72Z"
                    style="fill: #fff"
                />
                <path
                    d="M109.53,114.65a2.55,2.55,0,0,1-1.91-.85L55.42,55.15A3.18,3.18,0,0,1,54.59,53V8.21a2.7,2.7,0,0,1,1.65-2.49h0a2.5,2.5,0,0,1,2.8.63l52.25,58.7a3.24,3.24,0,0,1,.83,2.16V112a2.7,2.7,0,0,1-1.65,2.49h0A2.6,2.6,0,0,1,109.53,114.65ZM59.59,52.31l47.53,53.47V67.89L59.59,14.42Zm48,16.09Z"
                    style=""
                />
                <path
                    d="M49.59,43.92,26.22,18a9.45,9.45,0,0,0-7-3h0a9.49,9.49,0,0,0-7.05,3L.73,30.62a2.39,2.39,0,0,0-.61,1.59h0A2.38,2.38,0,0,0,4.26,33.8L15.65,21.16a4.69,4.69,0,0,1,3.52-1.46h0a4.71,4.71,0,0,1,3.52,1.46L49.59,51Z"
                    style=""
                />
                <path
                    d="M4.13,18.85,15.52,6.21a4.72,4.72,0,0,1,3.53-1.47h0a4.71,4.71,0,0,1,3.52,1.47l27,30V29.11L26.09,3a9.46,9.46,0,0,0-7-3h0a9.43,9.43,0,0,0-7,3L.61,15.67A2.39,2.39,0,0,0,0,17.26H0A2.37,2.37,0,0,0,4.13,18.85Z"
                    style=""
                />
                <path
                    d="M89.13,103.06l-4.74-5.27v15l-58.3-64.7a9.46,9.46,0,0,0-7-3,9.46,9.46,0,0,0-7,3L.61,60.73a2.37,2.37,0,0,0,3.52,3.18L15.52,51.27a5.15,5.15,0,0,1,7.05,0l60.84,67.52-7,6.35L65.21,112.76a2.38,2.38,0,0,0-1.77-.79h-42a2.38,2.38,0,0,0,0,4.75h41l12,13.36a2.38,2.38,0,0,0,3.35.17l10.57-9.52s0,0,0,0a3.08,3.08,0,0,0,.3-.41,2.1,2.1,0,0,0,.22-.33,2.3,2.3,0,0,0,.12-.43,3.2,3.2,0,0,0,.1-.42s0,0,0-.07,0,0,0-.06Z"
                    style=""
                />
                <path
                    d="M26.09,33.05a9.42,9.42,0,0,0-7-3h0a9.43,9.43,0,0,0-7,3L.61,45.69A2.37,2.37,0,0,0,0,47.27H0a2.37,2.37,0,0,0,4.13,1.58L15.52,36.22a4.71,4.71,0,0,1,3.53-1.46h0a4.71,4.71,0,0,1,3.52,1.46l61.82,68.61v-7Z"
                    style=""
                />
            </symbol>
            <symbol id="decking-re-deck" viewBox="0 0 112.12 130.86">
                <path
                    d="M109.43,66.72,57.23,8.08a.08.08,0,0,0-.14.05V53a.77.77,0,0,0,.18.48l52.21,58.64a.08.08,0,0,0,.14-.05V67.21A.75.75,0,0,0,109.43,66.72Z"
                    style="fill: #fff"
                />
                <path
                    d="M109.53,114.65a2.55,2.55,0,0,1-1.91-.85L55.42,55.15A3.18,3.18,0,0,1,54.59,53V8.21a2.7,2.7,0,0,1,1.65-2.49h0a2.5,2.5,0,0,1,2.8.63l52.25,58.7a3.24,3.24,0,0,1,.83,2.16V112a2.7,2.7,0,0,1-1.65,2.49h0A2.6,2.6,0,0,1,109.53,114.65ZM59.59,52.31l47.53,53.47V67.89L59.59,14.42Zm48,16.09Z"
                    style=""
                />
                <path
                    d="M49.59,43.92,26.22,18a9.45,9.45,0,0,0-7-3h0a9.49,9.49,0,0,0-7.05,3L.73,30.62a2.39,2.39,0,0,0-.61,1.59h0A2.38,2.38,0,0,0,4.26,33.8L15.65,21.16a4.69,4.69,0,0,1,3.52-1.46h0a4.71,4.71,0,0,1,3.52,1.46L49.59,51Z"
                    style=""
                />
                <path
                    d="M4.13,18.85,15.52,6.21a4.72,4.72,0,0,1,3.53-1.47h0a4.71,4.71,0,0,1,3.52,1.47l27,30V29.11L26.09,3a9.46,9.46,0,0,0-7-3h0a9.43,9.43,0,0,0-7,3L.61,15.67A2.39,2.39,0,0,0,0,17.26H0A2.37,2.37,0,0,0,4.13,18.85Z"
                    style=""
                />
                <path
                    d="M89.13,103.06l-4.74-5.27v15l-58.3-64.7a9.46,9.46,0,0,0-7-3,9.46,9.46,0,0,0-7,3L.61,60.73a2.37,2.37,0,0,0,3.52,3.18L15.52,51.27a5.15,5.15,0,0,1,7.05,0l60.84,67.52-7,6.35L65.21,112.76a2.38,2.38,0,0,0-1.77-.79h-42a2.38,2.38,0,0,0,0,4.75h41l12,13.36a2.38,2.38,0,0,0,3.35.17l10.57-9.52s0,0,0,0a3.08,3.08,0,0,0,.3-.41,2.1,2.1,0,0,0,.22-.33,2.3,2.3,0,0,0,.12-.43,3.2,3.2,0,0,0,.1-.42s0,0,0-.07,0,0,0-.06Z"
                    style=""
                />
                <path
                    d="M26.09,33.05a9.42,9.42,0,0,0-7-3h0a9.43,9.43,0,0,0-7,3L.61,45.69A2.37,2.37,0,0,0,0,47.27H0a2.37,2.37,0,0,0,4.13,1.58L15.52,36.22a4.71,4.71,0,0,1,3.53-1.46h0a4.71,4.71,0,0,1,3.52,1.46l61.82,68.61v-7Z"
                    style=""
                />
                <path
                    d="M49.59,43.92,26.22,18a9.45,9.45,0,0,0-7-3h0a9.49,9.49,0,0,0-7.05,3L.73,30.62a2.39,2.39,0,0,0-.61,1.59h0A2.38,2.38,0,0,0,4.26,33.8L15.65,21.16a4.69,4.69,0,0,1,3.52-1.46h0a4.71,4.71,0,0,1,3.52,1.46L49.59,51Z"
                    style=""
                />
                <path
                    d="M26.09,33.05a9.42,9.42,0,0,0-7-3h0a9.43,9.43,0,0,0-7,3L.61,45.69A2.37,2.37,0,0,0,0,47.27H0a2.37,2.37,0,0,0,4.13,1.58L15.52,36.22a4.71,4.71,0,0,1,3.53-1.46h0a4.71,4.71,0,0,1,3.52,1.46l61.82,68.61v-7Z"
                    style=""
                />
                <rect x="16.54" y="2.11" width="5" height="43.77" style="" />
                <rect x="56.51" y="72.78" width="5" height="14.96" style="" />
                <rect x="32.38" y="15.75" width="5" height="14.96" style="" />
                <rect x="44.58" y="44.03" width="5" height="15.39" style="" />
            </symbol>
            <symbol id="underlayment-hip-ridge" viewBox="0 0 118.78 100.68">
                <path
                    d="M110.28,66.21l-6-12.84-6-12.85-4-8.58a5.31,5.31,0,0,0-6.47-2.79L82.22,31l-10,3.33-10,3.32L52.14,41h0l-3.69,1.22L29.12,48.6A5.28,5.28,0,0,1,34,51.71L49.83,85.55l5.91,12.63L65.82,95,75.91,91.8,86,88.61l10.1-3.18,10.08-3.19L116.26,79h0Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M55.73,98.18H2.5L19.3,62.27l4.93-10.56a5.38,5.38,0,0,1,9.76,0Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M39.8,31.47h0l-3.6-7.68a7.76,7.76,0,0,0-7.1-4.55c-.34,0-.67,0-1,.06l0,0A7.75,7.75,0,0,0,22,23.78l-3.59,7.69"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="116.28 79.04 106.17 82.24 96.08 85.43 92.3 86.62 75.91 91.8 65.81 94.99 55.73 98.18"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M92.78,14.72h0l-7.46,2.35L75.13,20.3,57.48,25.89,39.82,31.47l-3.59-7.68a7.76,7.76,0,0,0-7.11-4.55c-.33,0-.66,0-1,.06l17.4-5.53h0L63.06,8.21,80.61,2.64a8,8,0,0,1,1.47-.14,7.76,7.76,0,0,1,7.11,4.55Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="28.13"
                    y1="19.3"
                    x2="28.09"
                    y2="19.32"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="39.82"
                    y1="31.47"
                    x2="39.8"
                    y2="31.47"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="39.82"
                    y1="31.47"
                    x2="39.8"
                    y2="31.47"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="18.42"
                    y1="31.47"
                    x2="36.96"
                    y2="25.36"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M92.78,14.73h0L89.19,7.05A7.76,7.76,0,0,0,82.08,2.5a8,8,0,0,0-1.47.14l-.17,0L79,3.14"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M61.31,8.72l1.48-.46a8,8,0,0,1,1.63-.18,7.75,7.75,0,0,1,7.11,4.56l3.59,7.67"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M43.66,14.31l1.47-.47a8.15,8.15,0,0,1,1.64-.17,7.74,7.74,0,0,1,7.11,4.55l3.59,7.67"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <polygon
                        points="104.27 53.37 104.25 53.37 94.19 56.63 88.2 43.82 98.25 40.52 104.27 53.37"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="69.96 79.1 59.89 82.33 49.83 85.55 43.91 72.9 53.96 69.64 64.02 66.39 69.96 79.1"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="43.91"
                        y1="72.9"
                        x2="38"
                        y2="60.26"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="55.73"
                        y1="98.18"
                        x2="49.83"
                        y2="85.55"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <polygon
                        points="85.99 88.61 75.9 91.8 65.82 94.99 59.89 82.33 69.96 79.1 69.97 79.1 80.03 75.88 85.99 88.61"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="65.82"
                        y1="94.99"
                        x2="55.73"
                        y2="98.18"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="106.17 82.23 106.17 82.24 96.08 85.42 85.99 88.61 80.03 75.88 90.12 72.66 100.18 69.44 106.17 82.23"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="116.28 79.03 116.28 79.04 116.25 79.04 106.17 82.23 100.19 69.44 110.25 66.21 110.28 66.21 116.28 79.03"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="110.25 66.21 100.18 69.44 90.12 72.66 84.14 59.88 94.19 56.63 104.25 53.37 110.25 66.21"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="90.12 72.66 80.03 75.88 69.97 79.1 69.96 79.1 64.02 66.39 74.08 63.14 84.14 59.88 90.12 72.66"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="74.08 63.14 64.02 66.39 53.96 69.64 48.04 56.98 58.08 53.68 68.13 50.4 74.08 63.14"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="58.08 53.68 48.04 56.98 38 60.26 32.09 47.62 42.12 44.3 52.14 40.96 58.08 53.68"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="78.17 47.1 68.13 50.4 58.08 53.68 52.14 40.96 62.16 37.64 72.19 34.32 78.17 47.1"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="94.19 56.63 84.14 59.88 74.08 63.14 68.13 50.4 78.17 47.1 88.2 43.82 94.19 56.63"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M98.25,40.52l-10,3.3-10,3.28-6-12.78,10-3.33,5.54-1.84a5.31,5.31,0,0,1,6.47,2.79Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
            </symbol>
            <symbol id="underlayment-ice" viewBox="0 0 147.72 114.7">
                <g>
                    <polyline
                        points="70.54 108.4 84.14 104.1 70.21 74.31 113.9 60.2 110.66 53.27"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="145.22 93.78 87.93 112.2 84.14 104.1 70.21 74.31 113.9 60.2 127.5 55.89 145.22 93.78"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <line
                            x1="88.25"
                            y1="2.5"
                            x2="88.25"
                            y2="29.19"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="94.86 7.25 88.25 13.86 81.64 7.25"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="65.14"
                            y1="15.85"
                            x2="88.25"
                            y2="29.19"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="72.56 12.5 74.98 21.53 65.95 23.95"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="65.14"
                            y1="42.54"
                            x2="88.25"
                            y2="29.19"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="65.95 34.44 74.98 36.86 72.56 45.89"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="88.25"
                            y1="55.89"
                            x2="88.25"
                            y2="29.19"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="81.64 51.13 88.25 44.52 94.86 51.13"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="111.37"
                            y1="42.54"
                            x2="88.25"
                            y2="29.19"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="103.95 45.89 101.53 36.86 110.56 34.44"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="111.37"
                            y1="15.85"
                            x2="88.25"
                            y2="29.19"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="110.56 23.95 101.53 21.53 103.95 12.5"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                </g>
                <path
                    d="M70.54,108.4H55.07L50.34,98.28H22.7L18,108.4H2.5L32.55,44.15a4.38,4.38,0,0,1,7.94,0Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="55.52"
                    y1="35.33"
                    x2="36.52"
                    y2="41.63"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="underlayment-synthetic" viewBox="0 0 131.04 91.5">
                <path
                    d="M128,70.85,70.54,89,40.48,24.75a4.3,4.3,0,0,0-4-2.53L96,2.5l3.71,7.94c-4.9,2-8,5.49-7.13,8.27l.32.7L95,24h0l13.14,28.1c1,3,6.29,3.94,11.87,2.13l.11,0Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M120,54.2,80.56,67.29,65,33.93,95,24h0l13.14,28.1C109.14,55.05,114.46,56,120,54.2Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M70.54,89H55.07L50.34,78.88H22.7L18,89H2.5L32.55,24.75a4.37,4.37,0,0,1,7.93,0Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M120.15,54.16l-.11,0c-5.58,1.81-10.9.85-11.87-2.13-.89-2.75,2.19-6.27,7-8.22l.1,0c.39-.16.8-.31,1.21-.45,5.12-1.66,10-1,11.55,1.43l.32.71C129.35,48.47,125.67,52.33,120.15,54.16Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M128.07,44.79c-1.54-2.43-6.43-3.09-11.55-1.43-.41.14-.82.29-1.21.45l-.1,0c-4.85,1.95-7.93,5.47-7,8.22L95,24h0l-2.13-4.56-.32-.7c-.9-2.78,2.23-6.31,7.13-8.27.39-.16.8-.3,1.22-.44,5.58-1.81,10.89-.86,11.87,2.14Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="108.17 52.07 95.02 23.97 95.03 23.97 108.17 52.07"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="71.1 47.06 71.1 47.05 76.78 30.01"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="76 57.54 76 57.53 86.21 26.89"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="81.21 67.08 81.21 67.07 95.35 24.65 95.35 24.64"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="90.64 63.95 100.25 35.13 100.25 35.12"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="105.14"
                    y1="45.6"
                    x2="100.07"
                    y2="60.82"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="underlayment-starters" viewBox="0 0 118.17 116.92">
                <g>
                    <path
                        d="M115.67,72.47h0q-5.7,2-11.4,4L77.16,86.17,51.41,95.33,24.16,105,2.5,68.67l13.33-4.74,15,25.14,13.92-4.95,13.06-4.64L70.48,75l13.07-4.64,14-5,11.4-4Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M109,61.27l-11.4,4-14,5L70.48,75,57.79,79.48,44.73,84.12,30.81,89.07l-15-25.14q-3.35-5.59-6.68-11.21L22.48,48l15,25.14,13.65-4.85,12.48-4.44,13.28-4.72,12.47-4.44,13-4.61Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M102.31,50.06l-13,4.61L76.87,59.11,63.59,63.83,51.11,68.27,37.46,73.12,22.48,48q-3.35-5.59-6.68-11.21L29.14,32l15,25.14L70.19,47.9l12.48-4.43,13-4.62Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M95.64,38.85l-13,4.62L70.19,47.9,44.12,57.17,29.14,32l-6.68-11.2L74,2.51Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="115.67 72.48 115.67 72.47 108.99 61.27 102.31 50.06 95.64 38.85 73.97 2.51 73.97 2.5"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M89.35,54.67l-6.68-11.2"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M70.19,47.9,63.51,36.7"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M63.59,63.83l-6.68-11.2"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M83.55,70.32,76.87,59.11"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M57.79,79.48q-3.33-5.61-6.68-11.21"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M104.27,76.53q-3.33-5.61-6.68-11.21"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M77.17,86.17Q73.82,80.56,70.49,75"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M51.41,95.33,44.73,84.12"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <line
                    x1="24.16"
                    y1="114.42"
                    x2="24.16"
                    y2="105.02"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="68.67"
                    x2="2.5"
                    y2="78.07"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="78.07"
                    x2="24.16"
                    y2="114.42"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="115.67"
                    y1="81.87"
                    x2="24.16"
                    y2="114.42"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="115.67 72.47 115.67 72.48 115.67 81.87"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="flashing-apron" viewBox="0 0 105.35 111.32">
                <polygon
                    points="2.5 75.76 35.56 108.82 35.56 82.71 2.5 24.26 2.5 75.76"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="93.2 73.97 93.2 87.06 35.56 108.82"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="87.2 50.34 76.67 31.72 60.14 2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="24.26"
                    x2="60.14"
                    y2="2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="45.21"
                    y1="79.07"
                    x2="35.56"
                    y2="82.71"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="21.72 17.01 38.24 46.23 48.78 64.85"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="40.93 9.75 57.46 38.97 67.99 57.6"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="19.03"
                    y1="53.48"
                    x2="76.67"
                    y2="31.72"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="102.85 57.3 93.2 60.95 73.99 68.2 54.77 75.45 45.21 79.06 39.22 68.46 48.78 64.85 67.99 57.6 87.2 50.34 96.85 46.7 102.85 57.3"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="102.85 57.3 102.85 70.33 93.2 73.97 45.21 92.09 45.21 79.06 54.77 75.45 73.99 68.2 93.2 60.95 102.85 57.3"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="flashing-counter" viewBox="0 0 105.76 106.86">
                <polygon
                    points="72.34 92.29 72.34 104.36 2.5 104.36 2.5 47.54 16.46 56.49 30.43 65.44 44.4 74.39 58.37 83.34 72.34 92.29"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="31.92 44.42 24.19 50.46 16.46 56.49 2.5 47.54 10.23 41.51 17.96 35.47 31.92 44.42"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="47.39 32.36 39.65 38.4 31.92 44.42 17.96 35.47 25.69 29.45 33.42 23.41 47.39 32.36"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="53.62 47.35 45.89 53.37 38.16 59.41 24.19 50.46 31.92 44.42 39.65 38.4 53.62 47.35"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="61.35 41.31 53.62 47.35 39.65 38.4 47.39 32.36 61.35 41.31"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="24.19 50.46 38.16 59.41 30.43 65.44 16.46 56.49 24.19 50.46"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="103.25 68.17 95.52 74.2 87.8 80.23 87.79 80.23 73.83 71.28 81.56 65.25 89.29 59.22 103.25 68.17"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="87.79 80.23 80.07 86.26 72.34 92.29 58.37 83.34 66.1 77.31 73.83 71.28 87.79 80.23"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="66.1 77.31 58.37 83.34 44.4 74.39 52.13 68.36 66.1 77.31"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="89.29 59.22 81.56 65.25 67.59 56.3 75.31 50.26 75.32 50.26 89.29 59.22"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="103.26"
                    y1="68.17"
                    x2="103.26"
                    y2="68.16"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="103.26 68.17 103.26 80.22 72.34 104.36 72.34 92.29 80.07 86.26 87.79 80.23 87.8 80.23 95.52 74.2 103.25 68.17 103.26 68.17"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="103.26"
                    y1="68.17"
                    x2="103.26"
                    y2="68.16"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="103.25 49.18 103.25 68.17 89.29 59.22 75.32 50.26 75.31 50.26 61.36 41.31 61.35 41.31 47.39 32.36 33.42 23.41 33.42 10.28 45.06 10.28 45.06 18.06 56.7 18.06 56.7 25.84 68.34 25.84 68.34 33.62 79.98 33.62 79.98 41.4 91.62 41.4 91.62 49.18 103.25 49.18"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="33.42"
                    y="2.5"
                    width="11.64"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="91.62 33.62 91.62 41.39 103.25 41.39 103.25 49.18 91.62 49.18 91.62 41.4 79.98 41.4 79.98 33.62 68.34 33.62 68.34 33.57 103.25 33.57 103.25 33.62 91.62 33.62"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="91.62"
                    y="2.5"
                    width="11.63"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="91.62 18.06 103.25 18.06 103.25 25.84 68.34 25.84 68.34 25.79 91.62 25.79 91.62 18.06"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="91.62"
                    y="33.61"
                    width="11.63"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="103.25"
                    y="49.18"
                    width="0.01"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <polygon
                        points="59.86 62.32 52.13 68.36 44.4 74.39 30.43 65.44 38.16 59.41 45.89 53.37 59.86 62.32"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="81.56 65.25 73.83 71.28 66.1 77.31 52.13 68.36 59.86 62.32 67.59 56.3 81.56 65.25"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <line
                        x1="30.43"
                        y1="65.44"
                        x2="16.46"
                        y2="56.49"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="58.37"
                        y1="83.34"
                        x2="44.4"
                        y2="74.39"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="75.31 50.26 67.59 56.3 59.86 62.32 45.89 53.37 53.62 47.35 61.35 41.31 61.36 41.31 75.31 50.26"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <rect
                    x="45.06"
                    y="10.28"
                    width="11.64"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="45.06"
                    y="2.5"
                    width="23.28"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="68.34"
                    y="2.5"
                    width="23.28"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="91.62"
                    y="2.5"
                    width="11.64"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="56.7"
                    y="10.28"
                    width="23.28"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="79.98"
                    y="10.28"
                    width="23.27"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="103.25"
                    y="10.28"
                    width="0.01"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="56.7"
                    y="18.06"
                    width="11.64"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="68.34"
                    y="18.06"
                    width="23.28"
                    height="7.74"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="68.34"
                    y="25.79"
                    width="11.64"
                    height="0.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="79.98"
                    y="25.79"
                    width="11.64"
                    height="0.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="91.62"
                    y="18.06"
                    width="11.64"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="68.34"
                    y="25.84"
                    width="11.64"
                    height="7.74"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="68.34"
                    y="25.79"
                    width="11.64"
                    height="0.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="79.98"
                    y="25.84"
                    width="23.27"
                    height="7.74"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="79.98"
                    y="25.79"
                    width="11.64"
                    height="0.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="103.26 25.79 103.26 33.57 103.25 33.57 103.25 25.84 91.62 25.84 91.62 25.79 103.26 25.79"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="91.62"
                    y="33.61"
                    width="11.64"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="flashing-counter-straight" viewBox="0 0 105.76 106.86">
                <polygon
                    points="72.34 92.29 72.34 104.36 2.5 104.36 2.5 47.54 16.46 56.49 30.43 65.44 44.4 74.39 58.37 83.34 72.34 92.29"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="31.92 44.43 24.19 50.46 16.46 56.49 2.5 47.54 10.23 41.51 17.96 35.48 31.92 44.43"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="47.39 32.36 39.65 38.4 31.92 44.43 17.96 35.48 25.69 29.45 33.42 23.41 47.39 32.36"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="53.62 47.35 45.89 53.38 38.16 59.41 24.19 50.46 31.92 44.43 39.65 38.4 53.62 47.35"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="61.35 41.31 53.62 47.35 39.65 38.4 47.39 32.36 61.35 41.31"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="24.19 50.46 38.16 59.41 30.43 65.44 16.46 56.49 24.19 50.46"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="103.25 68.17 95.52 74.2 87.8 80.24 87.79 80.24 73.83 71.29 81.56 65.25 89.29 59.22 103.25 68.17"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="87.79 80.24 80.07 86.26 72.34 92.29 58.37 83.34 66.1 77.31 73.83 71.29 87.79 80.24"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="66.1 77.31 58.37 83.34 44.4 74.39 52.13 68.36 66.1 77.31"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="89.29 59.22 81.56 65.25 67.59 56.3 75.31 50.26 75.32 50.26 89.29 59.22"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="103.26"
                    y1="68.17"
                    x2="103.26"
                    y2="68.16"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="103.26 68.17 103.26 80.22 72.34 104.36 72.34 92.29 80.07 86.26 87.79 80.24 87.8 80.24 95.52 74.2 103.25 68.17 103.26 68.17"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="103.26"
                    y1="68.17"
                    x2="103.26"
                    y2="68.16"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="103.25 56.23 103.25 68.17 89.29 59.22 75.32 50.26 75.31 50.26 61.36 41.31 61.35 41.31 47.39 32.36 33.42 23.41 33.42 8.48 36.05 10.28 45.06 16.44 47.43 18.06 56.7 24.4 58.81 25.84 68.34 32.36 70.12 33.58 70.18 33.62 79.98 40.32 81.57 41.41 91.62 48.28 92.95 49.19 103.25 56.23"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="45.06 10.28 45.06 16.44 36.05 10.28 45.06 10.28"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="56.7 18.06 56.7 24.4 47.43 18.06 56.7 18.06"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="68.34 25.84 68.34 32.36 58.81 25.84 68.34 25.84"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="79.98 33.62 79.98 40.32 70.18 33.62 79.98 33.62"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="91.62 41.41 91.62 48.28 81.57 41.41 91.62 41.41"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="103.25 49.19 103.25 56.23 92.95 49.19 103.25 49.19"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="45.06 2.5 45.06 10.28 36.05 10.28 33.42 8.48 33.42 2.5 45.06 2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="91.62 33.62 91.62 41.4 103.25 41.4 103.25 49.19 92.95 49.19 91.62 48.28 91.62 41.41 81.57 41.41 79.98 40.32 79.98 33.62 70.18 33.62 70.12 33.58 103.25 33.58 103.25 33.62 91.62 33.62"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="91.62"
                    y="2.5"
                    width="11.63"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="91.62 18.06 103.25 18.06 103.25 25.84 68.34 25.84 68.34 25.8 91.62 25.8 91.62 18.06"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="91.62"
                    y="33.62"
                    width="11.63"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="103.25"
                    y="49.19"
                    width="0.01"
                    height="7.77"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <polygon
                        points="59.86 62.33 52.13 68.36 44.4 74.39 30.43 65.44 38.16 59.41 45.89 53.38 59.86 62.33"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="81.56 65.25 73.83 71.29 66.1 77.31 52.13 68.36 59.86 62.33 67.59 56.3 81.56 65.25"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <line
                        x1="30.43"
                        y1="65.44"
                        x2="16.46"
                        y2="56.49"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="58.37"
                        y1="83.34"
                        x2="44.4"
                        y2="74.39"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="75.31 50.26 67.59 56.3 59.86 62.33 45.89 53.38 53.62 47.35 61.35 41.31 61.36 41.31 75.31 50.26"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <polygon
                    points="56.7 10.28 56.7 18.06 47.43 18.06 45.06 16.44 45.06 10.28 56.7 10.28"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="45.06"
                    y="2.5"
                    width="23.28"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="68.34"
                    y="2.5"
                    width="23.28"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="91.62"
                    y="2.5"
                    width="11.64"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="56.7"
                    y="10.28"
                    width="23.28"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="79.98"
                    y="10.28"
                    width="23.27"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="103.25"
                    y="10.28"
                    width="0.01"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="68.34 18.06 68.34 25.84 58.81 25.84 56.7 24.4 56.7 18.06 68.34 18.06"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="68.34"
                    y="18.06"
                    width="23.28"
                    height="7.74"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="68.34"
                    y="25.8"
                    width="11.64"
                    height="0.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="79.98"
                    y="25.8"
                    width="11.64"
                    height="0.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="91.62"
                    y="18.06"
                    width="11.64"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="79.98 25.84 79.98 33.58 70.12 33.58 68.34 32.36 68.34 25.84 79.98 25.84"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="68.34"
                    y="25.8"
                    width="11.64"
                    height="0.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="79.98"
                    y="25.84"
                    width="23.27"
                    height="7.74"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="79.98"
                    y="25.8"
                    width="11.64"
                    height="0.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="103.26 25.8 103.26 33.58 103.25 33.58 103.25 25.84 91.62 25.84 91.62 25.8 103.26 25.8"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="91.62"
                    y="33.62"
                    width="11.64"
                    height="7.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="103.26"
                    y1="56.24"
                    x2="103.25"
                    y2="56.23"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="flashing-drip" viewBox="0 0 116.72 89.36">
                <polygon
                    points="60.43 52.91 60.43 86.86 2.5 86.86 2.5 34.86 37.13 45.65 60.43 52.91"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="52.87 39.28 68.11 44.02 68.11 45.73 60.43 52.91 37.12 45.65 31.46 43.89 2.5 34.86 37.12 2.5 66.09 11.53 78.44 15.38 61.13 31.56 52.87 39.28"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="95.05 42.19 95.05 54.5 60.43 86.86 60.43 52.91 68.11 45.73 68.11 67.37 95.05 42.19"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="114.22 15.24 102.73 25.98 95.05 33.16 79.6 47.6 69.48 44.45 68.11 44.02 52.87 39.28 61.13 31.56 78.44 15.38 87.49 6.92 92.15 8.36 102.73 11.66 114.22 15.24"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="102.73 25.98 102.73 35.01 95.05 42.19 68.11 67.37 68.11 44.02 69.48 44.45 79.6 47.6 95.05 33.16 102.73 25.98"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="31.47"
                    y1="43.89"
                    x2="66.09"
                    y2="11.53"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="flashing-head" viewBox="0 0 118.02 103.7">
                <rect
                    x="2.5"
                    y="88.39"
                    width="78.33"
                    height="12.81"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="50.57 77.49 41.67 88.39 2.5 88.39 11.42 77.49 50.57 77.49"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="20.32 66.59 39.91 66.59 30.99 77.49 11.42 77.49 20.32 66.59"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="89.75 77.49 80.83 88.39 41.67 88.39 50.57 77.49 89.75 77.49"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="98.65 66.59 89.75 77.49 70.15 77.49 79.07 66.59 98.65 66.59"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="115.51 45.98 107.57 55.68 29.24 55.68 37.18 45.97 115.51 45.98"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="115.52"
                    y1="45.98"
                    x2="115.52"
                    y2="45.98"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="115.51 45.98 115.51 78.33 80.83 101.2 80.83 88.39 89.75 77.49 98.65 66.59 107.57 55.68 115.51 45.98"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="115.52"
                    y1="45.98"
                    x2="115.52"
                    y2="45.98"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="37.18"
                    y="2.5"
                    width="78.32"
                    height="43.48"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="37.18"
                    y1="34.04"
                    x2="115.51"
                    y2="34.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <polygon
                        points="68.4 55.68 59.49 66.59 20.32 66.59 29.24 55.68 68.4 55.68"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="79.07 66.59 70.15 77.49 30.99 77.49 39.91 66.59 79.07 66.59"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="107.57 55.68 98.65 66.59 59.49 66.59 68.4 55.68 107.57 55.68"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
            </symbol>
            <symbol id="flashing-roof-to-wall" viewBox="0 0 105.76 106.85">
                <polygon
                    points="72.34 92.28 72.34 104.35 2.5 104.35 2.5 47.53 16.46 56.48 30.43 65.43 44.4 74.38 58.37 83.33 72.34 92.28"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="31.92 44.42 24.19 50.46 16.46 56.48 2.5 47.53 10.23 41.51 17.96 35.47 31.92 44.42"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="39.65 38.39 31.92 44.42 17.96 35.47 25.69 29.44 39.65 38.39"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="38.16 59.41 30.43 65.43 16.46 56.48 24.19 50.46 38.16 59.41"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="103.25 68.17 95.52 74.19 95.51 74.2 81.55 65.25 81.56 65.24 67.59 56.29 67.58 56.3 53.62 47.34 39.65 38.39 25.69 29.44 33.42 23.41 47.39 32.36 61.35 41.31 61.36 41.31 75.31 50.26 75.32 50.26 89.29 59.22 103.25 68.17"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="95.51 74.2 87.8 80.23 87.79 80.23 73.83 71.28 81.55 65.25 95.51 74.2"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="87.79 80.23 80.07 86.26 72.34 92.28 58.37 83.33 66.1 77.31 73.83 71.28 87.79 80.23"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="66.1 77.31 58.37 83.33 44.4 74.38 52.13 68.36 66.1 77.31"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="103.26"
                    y1="68.17"
                    x2="103.26"
                    y2="68.16"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="103.26"
                    y1="68.17"
                    x2="103.26"
                    y2="68.16"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <polygon
                        points="59.85 62.32 52.13 68.36 44.4 74.38 30.43 65.43 38.16 59.41 45.89 53.37 59.85 62.32"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="81.56 65.24 81.55 65.25 67.58 56.3 67.59 56.29 81.56 65.24"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <line
                        x1="30.43"
                        y1="65.43"
                        x2="16.46"
                        y2="56.48"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="58.37"
                        y1="83.33"
                        x2="44.4"
                        y2="74.38"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="67.58 56.3 59.86 62.32 59.85 62.32 45.89 53.37 53.62 47.34 67.58 56.3"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <polygon
                    points="103.25 47.27 103.25 68.17 89.29 59.22 75.32 50.26 75.31 50.26 61.36 41.31 61.35 41.31 47.39 32.36 33.42 23.41 33.42 2.5 103.25 47.27"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="33.42 10.16 33.42 2.5 103.25 2.5 103.26 2.5 103.25 54.93"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="103.26 68.17 103.26 80.22 72.34 104.35 72.34 92.28 80.07 86.26 87.79 80.23 87.8 80.23 95.51 74.2 95.52 74.19 103.25 68.17 103.26 68.17"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="53.62 47.34 45.89 53.37 38.16 59.41 24.19 50.46 31.92 44.42 39.65 38.39 53.62 47.34"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="81.55 65.25 73.83 71.28 66.1 77.31 52.13 68.36 59.85 62.32 59.86 62.32 67.58 56.3 81.55 65.25"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="59.85"
                    y1="62.32"
                    x2="45.89"
                    y2="53.37"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="87.79"
                    y1="80.23"
                    x2="73.83"
                    y2="71.28"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="31.92"
                    y1="44.42"
                    x2="17.96"
                    y2="35.47"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="flashing-valleys" viewBox="0 0 131.26 84.57">
                <path
                    d="M45.25,82.07,2.5,66.66l15.79-44a3.11,3.11,0,0,1,2.82-2.34,3.09,3.09,0,0,1,2.81,2.34Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="65.63"
                    y1="71.24"
                    x2="65.63"
                    y2="2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M86,82.07l42.75-15.41L113,22.62a2.86,2.86,0,0,0-5.63,0Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="21.11"
                    y1="20.28"
                    x2="65.63"
                    y2="2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="45.25"
                    y1="82.07"
                    x2="65.63"
                    y2="71.24"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="110.15"
                    y1="20.28"
                    x2="65.63"
                    y2="2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="86.01"
                    y1="82.07"
                    x2="65.63"
                    y2="71.24"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <line
                        x1="57.66"
                        y1="5.68"
                        x2="57.66"
                        y2="10.68"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="57.66"
                        y1="19.23"
                        x2="57.66"
                        y2="66.24"
                        style="
                            fill: none;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                            stroke-width: 5px;
                            stroke-dasharray: 8.547545433044434, 8.547545433044434;
                        "
                    />
                    <line
                        x1="57.66"
                        y1="70.52"
                        x2="57.66"
                        y2="75.52"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <line
                        x1="73.6"
                        y1="5.68"
                        x2="73.6"
                        y2="10.68"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="73.6"
                        y1="19.23"
                        x2="73.6"
                        y2="66.24"
                        style="
                            fill: none;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                            stroke-width: 5px;
                            stroke-dasharray: 8.547545433044434, 8.547545433044434;
                        "
                    />
                    <line
                        x1="73.6"
                        y1="70.52"
                        x2="73.6"
                        y2="75.52"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
            </symbol>
            <symbol id="pipe-lead" viewBox="0 0 146.09 117.48">
                <path
                    d="M88,9.14V65.25c0,3.68-6.67,6.65-14.9,6.65s-14.9-3-14.9-6.65V9.14c0,3.68,6.66,6.65,14.9,6.65S88,12.82,88,9.14Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <ellipse
                    cx="73.05"
                    cy="9.14"
                    rx="14.9"
                    ry="6.64"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M143.59,78.91,73.05,115,2.5,78.91,58.15,50.45V76.5a3.12,3.12,0,0,0,.15,1c1,3.22,7.24,5.7,14.75,5.7.61,0,1.23,0,1.83,0,4.59-.25,8.57-1.45,10.87-3.13A4.47,4.47,0,0,0,88,76.5v-26Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M88,65.25V76.5A4.47,4.47,0,0,1,85.75,80c-2.3,1.68-6.28,2.88-10.87,3.13-.6,0-1.22,0-1.83,0-7.51,0-13.71-2.48-14.75-5.7a3.12,3.12,0,0,1-.15-1V65.25c0,3.68,6.66,6.65,14.9,6.65S88,68.93,88,65.25Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="pipe-pvc" viewBox="0 0 85.64 118.19">
                <path
                    d="M38.94,6.5V47.06a2.7,2.7,0,0,1-1.32,2.1A12.87,12.87,0,0,1,31.07,51c-.36,0-.73,0-1.1,0-4.52,0-8.25-1.49-8.88-3.43a1.9,1.9,0,0,1-.09-.58V6.5c0,2.21,4,4,9,4S38.94,8.71,38.94,6.5Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <ellipse
                    cx="29.97"
                    cy="6.5"
                    rx="8.97"
                    ry="4"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M48.7,60.73a6.17,6.17,0,0,1-.12,1.35,6.35,6.35,0,0,1-.88,2.2c-2.88,4.64-11.63,6.83-21.23,5-11-2.16-19-8.87-17.76-15,.67-3.4,4-5.9,8.77-7.07A24.79,24.79,0,0,1,21,46.58v.48a1.9,1.9,0,0,0,.09.58c.63,1.94,4.36,3.43,8.88,3.43.37,0,.74,0,1.1,0a12.87,12.87,0,0,0,6.55-1.88,2.7,2.7,0,0,0,1.32-2.1s9.52,5.27,9.75,13.36C48.7,60.52,48.7,60.63,48.7,60.73Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M83.14,94.55,33.05,115.69l-28-30.27L16,82.06c.68.56,1.37,1.11,2.09,1.65,13.18,9.89,28.53,11.69,34.29,4a10.63,10.63,0,0,0,1-1.56,10,10,0,0,0,.6-1.48,12.77,12.77,0,0,0,.62-4.05v0c0-5-.21-7.94-.74-10.14L60,68.57Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M54.6,80.6v0A12.77,12.77,0,0,1,54,84.68a10,10,0,0,1-.6,1.48,10.63,10.63,0,0,1-1,1.56c-5.76,7.68-21.11,5.88-34.29-4-.72-.54-1.41-1.09-2.09-1.65C4.32,72.29-.76,59.16,4.69,51.9c2.63-3.51,7.27-5,12.79-4.71-4.74,1.17-8.1,3.67-8.77,7.07-1.2,6.11,6.76,12.82,17.76,15,9.6,1.87,18.35-.32,21.23-5a6.35,6.35,0,0,0,.88-2.2,6.17,6.17,0,0,0,.12-1.35c2.78,4.74,4.35,6.37,5.16,9.73.53,2.2.74,5.12.74,10.14a14.3,14.3,0,0,0-.16-2.14A17.55,17.55,0,0,1,54.6,80.6Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="pipe-zipper" viewBox="0 0 124.66 115.08">
                <path
                    d="M58.06,76.8c-16.35-.67-30.37-5.22-38.15-11.71a25,25,0,0,1-2.1-2c-2.85-3-4.44-6.33-4.44-9.84,0-7.07,6.43-13.41,16.63-17.72a7.88,7.88,0,0,0-1,3.77,5.86,5.86,0,0,0,.08.94c-2.73,2.43-4.29,5.2-4.29,8.13a4.61,4.61,0,0,0,0,.52c-2.71,2.57-4.22,5.47-4.22,8.53a9.54,9.54,0,0,0,.81,3.85,11.76,11.76,0,0,0,1,1.9C27.28,70.54,41.17,76,58.06,76.8Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M111.29,53.28c0,3.51-1.6,6.86-4.45,9.85a24.87,24.87,0,0,1-2.1,2c-7.8,6.49-21.84,11-38.15,11.71,16.86-.8,30.76-6.26,35.63-13.6a11,11,0,0,0,1-1.9,9.39,9.39,0,0,0,.83-3.85c0-3.05-1.52-6-4.23-8.52a4.7,4.7,0,0,0,0-.53c0-2.92-1.54-5.69-4.27-8.12a5.9,5.9,0,0,0,.07-1,7.83,7.83,0,0,0-1-3.76C104.87,39.9,111.29,46.22,111.29,53.28Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <path
                        d="M83,12.14a4.86,4.86,0,0,1-.56,2.24,10.66,10.66,0,0,1-4.94,4.32,34.86,34.86,0,0,1-15.22,3.1A34.86,34.86,0,0,1,47.1,18.7a10.71,10.71,0,0,1-4.92-4.32,4.86,4.86,0,0,1-.56-2.24c0-5.32,9.26-9.64,20.7-9.64S83,6.82,83,12.14Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M87.25,21.21A5.27,5.27,0,0,1,87,23a9.21,9.21,0,0,1-3.46,4.33,23.71,23.71,0,0,1-6.84,3.36h0c-1.08.36-2.21.67-3.41.95h0a50,50,0,0,1-10.89,1.17,49.87,49.87,0,0,1-10.89-1.17h0c-1.2-.28-2.33-.59-3.42-.95h0a23.58,23.58,0,0,1-6.82-3.36A9.27,9.27,0,0,1,37.71,23a5.27,5.27,0,0,1-.3-1.8c0-2.56,1.77-4.93,4.77-6.83A10.71,10.71,0,0,0,47.1,18.7a34.86,34.86,0,0,0,15.22,3.1,34.86,34.86,0,0,0,15.22-3.1,10.66,10.66,0,0,0,4.94-4.32C85.48,16.28,87.25,18.65,87.25,21.21Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M91.46,30.27a6,6,0,0,1-.16,1.39,7.24,7.24,0,0,1-.92,2.27,10.13,10.13,0,0,1-1.62,2A21.21,21.21,0,0,1,82,40.29a51.13,51.13,0,0,1-19.64,3.55,51.21,51.21,0,0,1-19.64-3.55A21.17,21.17,0,0,1,35.89,36a10.09,10.09,0,0,1-1.61-2,7.81,7.81,0,0,1-.94-2.27,7.28,7.28,0,0,1-.14-1.39c0-2.67,1.65-5.16,4.51-7.26a9.27,9.27,0,0,0,3.46,4.33A23.58,23.58,0,0,0,48,30.7h0c1.09.36,2.22.67,3.42.95h0a49.87,49.87,0,0,0,10.89,1.17,50,50,0,0,0,10.89-1.17h0c1.2-.28,2.33-.59,3.41-.95h0a23.71,23.71,0,0,0,6.84-3.36A9.21,9.21,0,0,0,87,23C89.81,25.11,91.46,27.6,91.46,30.27Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M95.67,39.33a5.9,5.9,0,0,1-.07,1,8.85,8.85,0,0,1-1.93,4.34c-3.3,4.26-10.49,7.64-19.57,9.24l-.4.07a68.54,68.54,0,0,1-11.38.93,68.45,68.45,0,0,1-11.38-.93l-.4-.07h0c-9.08-1.6-16.25-5-19.54-9.25a8.72,8.72,0,0,1-1.91-4.34,5.86,5.86,0,0,1-.08-.94,7.88,7.88,0,0,1,1-3.77,12.92,12.92,0,0,1,3.34-3.9,7.81,7.81,0,0,0,.94,2.27,10.09,10.09,0,0,0,1.61,2,21.17,21.17,0,0,0,6.79,4.32,51.21,51.21,0,0,0,19.64,3.55A51.13,51.13,0,0,0,82,40.29,21.21,21.21,0,0,0,88.76,36a10.13,10.13,0,0,0,1.62-2,7.24,7.24,0,0,0,.92-2.27,12.72,12.72,0,0,1,3.38,3.91A7.83,7.83,0,0,1,95.67,39.33Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M99.87,48.4a4.7,4.7,0,0,1,0,.53c-.21,3.25-2.33,6.28-5.84,8.85-.34.24-.67.48-1,.71C86.18,63,75,65.88,62.32,65.88S38.44,63,31.65,58.49l-1-.71c-3.51-2.59-5.62-5.62-5.82-8.86a4.61,4.61,0,0,1,0-.52c0-2.93,1.56-5.7,4.29-8.13A8.72,8.72,0,0,0,31,44.61c3.29,4.26,10.46,7.65,19.54,9.25h0l.4.07a68.45,68.45,0,0,0,11.38.93,68.54,68.54,0,0,0,11.38-.93l.4-.07c9.08-1.6,16.27-5,19.57-9.24a8.85,8.85,0,0,0,1.93-4.34C98.33,42.71,99.87,45.48,99.87,48.4Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M104.08,57.45a9.39,9.39,0,0,1-.83,3.85,11,11,0,0,1-1,1.9C97.35,70.54,83.45,76,66.59,76.8c-.59,0-1.17,0-1.76.06-.83,0-1.66,0-2.51,0s-1.65,0-2.48,0c-.61,0-1.2,0-1.78-.06C41.17,76,27.28,70.54,22.44,63.2a11.76,11.76,0,0,1-1-1.9,9.54,9.54,0,0,1-.81-3.85c0-3.06,1.51-6,4.22-8.53.2,3.24,2.31,6.27,5.82,8.86l1,.71c6.79,4.47,18,7.39,30.67,7.39S86.18,63,93,58.49c.35-.23.68-.47,1-.71,3.51-2.57,5.63-5.6,5.84-8.85C102.56,51.5,104.08,54.4,104.08,57.45Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <path
                    d="M111.29,53.28V76.9c0,13-22,23.62-49,23.62S13.37,90,13.37,76.9V53.28c0,3.51,1.59,6.84,4.44,9.84a25,25,0,0,0,2.1,2c7.78,6.49,21.8,11,38.15,11.71.58,0,1.17,0,1.78.06.83,0,1.65,0,2.48,0s1.68,0,2.51,0c.59,0,1.17,0,1.76-.06,16.31-.67,30.35-5.22,38.15-11.71a24.87,24.87,0,0,0,2.1-2C109.69,60.14,111.29,56.79,111.29,53.28Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M122.16,82.94c0,16.37-26.81,29.64-59.84,29.64S2.5,99.31,2.5,82.94c0-6.35,4-12.23,10.87-17.07v11c0,13,21.89,23.62,49,23.62s49-10.57,49-23.62v-11C118.13,70.72,122.16,76.6,122.16,82.94Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="chimney-standard" viewBox="0 0 130.21 107.51">
                <polygon
                    points="91.21 25.25 91.21 95.22 49.44 84.03 38.99 81.23 38.99 25.25 91.21 25.25"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="32.47"
                    y="2.5"
                    width="65.27"
                    height="22.75"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="38.99"
                    y1="25.25"
                    x2="91.21"
                    y2="25.25"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="38.99"
                    y1="43.49"
                    x2="80.77"
                    y2="43.49"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="38.99"
                    y1="61.74"
                    x2="91.21"
                    y2="61.74"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="38.99"
                    y1="79.99"
                    x2="80.77"
                    y2="79.99"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="70.33"
                    y1="79.99"
                    x2="70.33"
                    y2="89.11"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="70.33"
                    y1="43.49"
                    x2="70.33"
                    y2="52.62"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="80.77"
                    y1="61.74"
                    x2="80.77"
                    y2="70.87"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="59.88"
                    y1="61.74"
                    x2="59.88"
                    y2="70.87"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="80.77"
                    y1="25.25"
                    x2="80.77"
                    y2="34.37"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="59.88"
                    y1="25.25"
                    x2="59.88"
                    y2="34.37"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="49.44"
                    y1="43.49"
                    x2="49.44"
                    y2="52.62"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="49.44"
                    y1="84.04"
                    x2="49.44"
                    y2="79.99"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="127.71 105 91.21 95.22 49.44 84.03 38.99 81.23 2.5 71.45"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="chimney-special" viewBox="0 0 130.21 100.43">
                <polygon
                    points="101.34 25.25 101.34 78.52 65.11 88.23 28.87 78.52 28.87 25.25 101.34 25.25"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="104.73 2.5 25.48 2.5 19.81 25.25 110.4 25.25 104.73 2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="28.87"
                    y1="25.25"
                    x2="101.34"
                    y2="25.25"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="28.87"
                    y1="43.49"
                    x2="86.85"
                    y2="43.49"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="28.87"
                    y1="61.74"
                    x2="101.34"
                    y2="61.74"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="72.35"
                    y1="43.49"
                    x2="72.35"
                    y2="52.62"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="86.85"
                    y1="61.74"
                    x2="86.85"
                    y2="70.87"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="57.86"
                    y1="61.74"
                    x2="57.86"
                    y2="70.87"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="86.85"
                    y1="25.25"
                    x2="86.85"
                    y2="34.37"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="57.86"
                    y1="25.25"
                    x2="57.86"
                    y2="34.37"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="43.36"
                    y1="43.49"
                    x2="43.36"
                    y2="52.62"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="2.5 71.45 28.87 78.52 65.11 88.23"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="127.71 71.45 101.34 78.52 65.11 88.23 28.87 97.93"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="chimney-large" viewBox="0 0 130.21 107.5">
                <polygon
                    points="101.34 25.25 101.34 97.93 43.36 82.4 34.37 79.99 28.87 78.52 28.87 25.25 101.34 25.25"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="19.81"
                    y="2.5"
                    width="90.59"
                    height="22.75"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="28.87"
                    y1="25.25"
                    x2="101.34"
                    y2="25.25"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="28.87"
                    y1="43.49"
                    x2="86.85"
                    y2="43.49"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="28.87"
                    y1="61.74"
                    x2="101.34"
                    y2="61.74"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="86.85 79.99 72.35 79.99 43.36 79.99 34.37 79.99"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="72.35"
                    y1="79.99"
                    x2="72.35"
                    y2="89.11"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="72.35"
                    y1="43.49"
                    x2="72.35"
                    y2="52.62"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="86.85"
                    y1="61.74"
                    x2="86.85"
                    y2="70.87"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="57.86"
                    y1="61.74"
                    x2="57.86"
                    y2="70.87"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="86.85"
                    y1="25.25"
                    x2="86.85"
                    y2="34.37"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="57.86"
                    y1="25.25"
                    x2="57.86"
                    y2="34.37"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="43.36"
                    y1="43.49"
                    x2="43.36"
                    y2="52.62"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="43.36"
                    y1="82.4"
                    x2="43.36"
                    y2="79.99"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="127.71 105 101.34 97.93 43.36 82.4 34.37 79.99 28.87 78.52 2.5 71.45"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="chimney-cap" viewBox="0 0 149.12 126.88">
                <polygon
                    points="126 23.18 118.88 26.03 74.56 43.84 30.25 26.03 23.12 23.18 74.56 2.5 126 23.18"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="126 86.81 126 103.72 74.56 124.38 23.12 103.72 23.12 86.81 44.17 95.25 74.56 107.47 104.95 95.25 126 86.81"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="74.56 66.13 74.56 107.47 44.17 95.25 23.12 86.81 23.12 45.46 74.56 66.13"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="126 45.46 126 86.81 104.95 95.25 74.56 107.47 74.56 66.13 126 45.46"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="74.56 43.84 74.56 66.13 23.12 45.46 2.5 37.18 23.12 23.18 30.25 26.03 74.56 43.84"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="146.62 37.18 126 45.46 74.56 66.13 74.56 43.84 118.88 26.03 126 23.18 146.62 37.18"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="74.56"
                    y1="107.47"
                    x2="74.56"
                    y2="124.38"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <path
                        d="M56.25,98.79l16-32.1"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M56.25,59.89l16,45.7"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M24.25,85.2l16-32.12"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M56.25,98.79l-16-45.71"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M24.25,46.28,40.25,92"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M56.25,59.89,40.25,92"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <path
                        d="M92.87,98.79l-16-32.1"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M92.87,59.89l-16,45.7"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M124.87,85.2l-16-32.12"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M92.87,98.79l16-45.71"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M124.87,46.28,108.87,92"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M92.87,59.89l16,32.1"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
            </symbol>
            <symbol id="chimney-chase-cap" viewBox="0 0 128.87 74.27">
                <path
                    d="M126.37,28.81,64.44,53.68h0L2.5,28.81,46.88,11V26.39c0,3,7.86,5.44,17.56,5.44S82,29.4,82,26.39V11Z"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="5"
                />
                <polygon
                    points="126.37 28.81 126.37 46.88 64.44 71.77 64.43 53.68 64.44 53.68 126.37 28.81"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="5"
                />
                <polygon
                    points="64.44 53.68 64.44 71.77 2.5 46.88 2.5 28.81 64.43 53.68 64.44 53.68"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="5"
                />
                <path
                    d="M82,7.94c0,.84-.61,1.63-1.71,2.35-2.83,1.82-8.86,3.09-15.84,3.09s-13-1.27-15.85-3.09c-1.09-.72-1.71-1.51-1.71-2.35,0-3,7.86-5.44,17.56-5.44S82,4.93,82,7.94Z"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="5"
                />
                <path
                    d="M82,7.94V26.39c0,3-7.86,5.44-17.55,5.44S46.88,29.4,46.88,26.39V7.94c0,.84.62,1.63,1.71,2.35,2.83,1.82,8.86,3.09,15.85,3.09s13-1.27,15.84-3.09C81.38,9.57,82,8.78,82,7.94Z"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="5"
                />
            </symbol>
            <symbol id="chimney-tuck" viewBox="0 0 120.12 121.71">
                <rect
                    x="2.5"
                    y="90.15"
                    width="38.37"
                    height="29.06"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M79.24,90.15v29.06H40.87V90.15h9.88l3.77,8.25a6.09,6.09,0,0,0,11.08,0l3.78-8.25Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="79.24"
                    y="90.15"
                    width="38.38"
                    height="29.06"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="2.5"
                    y="61.1"
                    width="19.18"
                    height="29.05"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="50.75 90.15 21.68 90.15 21.68 61.1 39.86 61.1 38.64 63.69 50.75 90.15"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="98.43 61.1 98.43 90.15 69.38 90.15 81.49 63.69 80.27 61.1 98.43 61.1"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="98.43"
                    y="61.1"
                    width="19.19"
                    height="29.05"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="40.87 32.04 40.87 58.96 39.86 61.1 2.5 61.1 2.5 32.04 40.87 32.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="55.77 36.39 55.77 47.6 46.22 47.6 40.87 58.96 40.87 32.04 53.92 32.04 53.92 36.39 55.77 36.39"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="79.24 32.04 79.24 58.91 73.91 47.6 64.35 47.6 64.35 36.39 66.19 36.39 66.19 32.04 79.24 32.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="117.62 32.04 117.62 61.1 80.27 61.1 79.24 58.91 79.24 32.04 117.62 32.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M66.19,8.64V36.39H53.92V8.64A6.14,6.14,0,0,1,60.05,2.5h0A6.14,6.14,0,0,1,66.19,8.64Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M81.49,63.69,69.38,90.15,65.6,98.4a6.09,6.09,0,0,1-11.08,0l-3.77-8.25L38.64,63.69l1.22-2.59,1-2.14L46.22,47.6h9.55v9.21a4.29,4.29,0,0,0,4.29,4.29,4.3,4.3,0,0,0,4.29-4.29V47.6h9.56l5.33,11.31,1,2.19Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M64.35,36.39V56.81a4.3,4.3,0,0,1-4.29,4.29,4.29,4.29,0,0,1-4.29-4.29V36.39Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="chimney-sealer" viewBox="0 0 127.4 127.88">
                <rect
                    x="2.5"
                    y="96.6"
                    width="38.37"
                    height="28.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="40.87"
                    y="96.6"
                    width="38.37"
                    height="28.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="79.24"
                    y="96.6"
                    width="38.37"
                    height="28.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="2.5"
                    y="10.27"
                    width="19.05"
                    height="28.77"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="21.55"
                    y="10.27"
                    width="38.37"
                    height="28.77"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="59.92 39.04 59.92 10.27 91.66 10.27"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="2.5"
                    y="39.04"
                    width="38.37"
                    height="28.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="2.5"
                    y="67.82"
                    width="19.05"
                    height="28.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="117.61"
                    y1="10.27"
                    x2="117.61"
                    y2="16.59"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="109.81 39.04 117.61 39.04 117.61 67.82 79.24 67.82"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="79.24"
                    y1="39.04"
                    x2="91.66"
                    y2="39.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="59.92"
                    y="67.82"
                    width="38.37"
                    height="28.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="21.55"
                    y="67.82"
                    width="38.37"
                    height="28.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="79.24 57.47 79.24 67.82 40.87 67.82 40.87 39.04 62.22 39.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="98.29"
                    y="67.82"
                    width="19.32"
                    height="28.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M124.9,26.33c-2.76.28-5.18.56-7.29.88-9.77,1.46-13.16,3.8-15,11.83a99.8,99.8,0,0,0-1.57,11.13A99.8,99.8,0,0,0,99.5,39a23.2,23.2,0,0,0-1.21-3.93c-2.65-6.26-7.92-7.43-21.05-8.78,13.13-1.34,18.4-2.52,21.05-8.77a31.92,31.92,0,0,0,1.84-7.29c.34-2.23.64-4.8.94-7.77.3,3,.6,5.54.94,7.77,1.68,10.77,4.59,13.54,15.6,15.18C119.72,25.77,122.14,26.05,124.9,26.33Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M82.7,48.68c-1.29.13-2.44.26-3.46.41-7.2,1-8,2.81-8.91,12C69.26,50.61,68.4,49.75,58,48.68,67.4,47.72,69,46.92,70,39c.11-.83.21-1.73.31-2.73.1,1,.2,1.9.31,2.73.87,6.8,2.19,8.33,8.6,9.23C80.26,48.42,81.41,48.55,82.7,48.68Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="117.61"
                    y1="10.27"
                    x2="109.27"
                    y2="10.27"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="117.61"
                    y1="39.04"
                    x2="117.61"
                    y2="34.44"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="skylights-curb" viewBox="0 0 129.94 144.67">
                <polygon
                    points="49.44 118.2 49.44 142.17 49.43 142.17 2.5 95.24 2.5 35.22 49.44 118.2"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="127.44 87.2 127.44 111.17 49.44 142.17 49.44 118.2 127.44 87.2"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M127.36,87.05l-11.7-20.68L104,45.67,80.55,4.29h0l0-.07L72,7.6l0,.1L83.71,28.39l11.7,20.68,10.17,18-.52,3.54-2.2,15.1-.1,0L63.61,101.27l0,0-6.5-11.54h0L45.35,69l.06,0L33.74,48.3l-.1,0L27.08,36.73,28.8,24.91l0-.16L2.5,35.22l.08.15L26,76.74,37.7,97.44l11.69,20.68,0,.08,78-31Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="45.41 69 45.35 69.03 33.64 48.34 33.74 48.3 45.41 69"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="63.61 101.27 63.59 101.28 57.05 89.72 57.09 89.71 63.59 101.25 63.61 101.27"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <polygon
                        points="33.64 48.34 14.29 56.05 14.18 56.1 2.5 35.4 2.58 35.37 28.8 24.91 27.08 36.73 33.64 48.34"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="92.42 24.91 92.25 24.98 83.71 28.39 72 7.7 80.55 4.29 80.55 4.28 80.74 4.21 92.42 24.91"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="57.05 89.72 37.7 97.44 37.52 97.51 25.85 76.8 25.99 76.74 45.35 69.03 57.05 89.72"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="45.41 69 45.35 69.03 25.99 76.74 25.85 76.8 14.18 56.1 14.29 56.05 33.64 48.34 33.74 48.3 45.41 69"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="105.58 67.04 105.06 70.58 102.86 85.68 102.76 85.72 63.61 101.27 63.59 101.25 65.77 86.25 66.3 82.65 94.76 71.34 105.58 67.04"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="107.88 94.81 68.76 110.4 63.61 101.27 102.76 85.72 107.88 94.81"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="68.76 110.4 49.39 118.11 49.2 118.2 37.52 97.51 37.7 97.44 57.05 89.72 57.09 89.71 63.59 101.25 63.61 101.27 68.76 110.4"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="127.44 87.02 127.36 87.05 107.88 94.81 102.76 85.72 102.86 85.68 105.06 70.58 115.66 66.37 115.77 66.32 127.44 87.02"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="104.1 45.61 103.96 45.67 95.41 49.07 83.71 28.39 92.25 24.98 92.42 24.91 104.1 45.61"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="115.77 66.32 115.66 66.37 105.06 70.58 105.58 67.04 95.41 49.07 103.96 45.67 104.1 45.61 115.77 66.32"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <polygon
                    points="66.3 82.65 65.77 86.25 63.59 101.25 57.09 89.71 57.05 89.72 45.35 69.03 45.41 69 33.74 48.3 33.64 48.34 27.08 36.73 28.8 24.91 28.82 24.75 29.8 18.11 37.89 32.43 66.3 82.65"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="63.59"
                    y1="101.29"
                    x2="63.59"
                    y2="101.25"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M95.41,49.07,83.71,28.39,72,7.7l0-.1-2.9-5.1L29.8,18.11l8.09,14.32L66.3,82.65,94.76,71.34,105.58,67ZM70,72.25,45.69,29.34l-4-7L65.39,12.9l1.71,3L93.65,62.84l-3,1.2Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M67.1,15.92l-1.71-3L41.71,22.31l4,7L70,72.25,90.63,64l3-1.2Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="67.1"
                    y1="15.92"
                    x2="61.15"
                    y2="56.68"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="skylights-deck" viewBox="0 0 129.94 142.96">
                <polygon
                    points="49.44 116.48 49.44 140.46 49.43 140.46 2.5 93.53 2.5 33.51 49.44 116.48"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="127.44 85.48 127.44 109.46 49.44 140.46 49.44 116.48 127.44 85.48"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M127.36,85.35l-11.7-20.7L104,44,92.25,23.27,80.55,2.58l0-.08-78,31,.08.15L26,75l11.7,20.69,11.7,20.69,0,.08,78-31Zm-82-18,.06,0L33.74,46.59l-.1,0L27.08,35,46.76,27.2l19.58-7.79L72.89,31h0L84.54,51.7l.06,0L96.3,72.36l-.09,0L102.76,84,63.61,99.55,57.09,88h0Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="33.74 46.59 45.41 67.29 45.35 67.32 33.64 46.63 33.74 46.59"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="57.09 87.99 63.61 99.55 63.59 99.56 57.05 88 57.09 87.99"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="72.89 30.98 84.6 51.67 84.54 51.7 72.86 31 72.89 30.98"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="102.86 83.96 102.76 84 96.2 72.4 96.3 72.36 102.86 83.96"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <polygon
                        points="27.08 35.02 33.64 46.63 14.29 54.34 14.18 54.39 2.5 33.69 2.58 33.66 41.62 18.1 46.76 27.2 27.08 35.02"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="92.42 23.2 92.25 23.27 72.89 30.98 66.34 19.41 46.76 27.2 41.62 18.1 80.55 2.58 80.74 2.5 92.42 23.2"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="57.05 88 37.69 95.72 37.52 95.79 25.85 75.09 25.99 75.03 45.35 67.32 57.05 88"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="45.41 67.29 45.35 67.32 25.99 75.03 25.85 75.09 14.18 54.39 14.29 54.34 33.64 46.63 33.74 46.59 45.41 67.29"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="107.88 93.09 68.76 108.69 63.61 99.55 102.76 84 107.88 93.09"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="68.76 108.69 49.39 116.41 49.2 116.49 37.52 95.79 37.69 95.72 57.05 88 57.09 87.99 63.61 99.55 68.76 108.69"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="127.44 85.31 127.36 85.34 107.88 93.09 102.76 84 96.2 72.4 96.3 72.36 115.66 64.65 115.77 64.6 127.44 85.31"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="104.1 43.9 103.96 43.96 84.6 51.67 84.54 51.7 72.86 31 72.89 30.98 92.25 23.27 92.42 23.2 104.1 43.9"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="102.76 84 63.61 99.55 57.09 87.99 57.05 88 45.35 67.32 45.41 67.29 33.74 46.59 33.64 46.63 27.08 35.02 46.76 27.2 66.34 19.41 72.89 30.98 72.86 31 84.54 51.7 84.6 51.67 96.3 72.36 96.2 72.4 102.76 84"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="115.77 64.6 115.66 64.65 96.3 72.36 84.6 51.67 103.96 43.96 104.1 43.9 115.77 64.6"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <line
                    x1="62.67"
                    y1="29.81"
                    x2="56.72"
                    y2="70.57"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="27.08 35.02 66.34 19.41 102.76 84 63.61 99.55 27.08 35.02"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="39.01 39.22 62.67 29.81 90.85 79.8 67.28 89.16 39.01 39.22"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="skylights-sun" viewBox="0 0 123.68 132.94">
                <rect
                    x="2.5"
                    y="98.65"
                    width="41.16"
                    height="22.31"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="80.02"
                    y="98.65"
                    width="41.16"
                    height="22.31"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="43.66 21.93 43.66 35.3 2.5 17.26 2.5 3.89 43.66 21.93"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="121.18 55.93 121.18 69.3 80.01 51.24 80.01 37.87 88.14 41.44 121.18 55.93"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M80,13.09c0-1.95-8.13-3.53-18.17-3.53s-18.18,1.58-18.18,3.53c0-5.84,8.13-10.59,18.17-10.59S80,7.25,80,13.09Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M80,37.88v89c0-1.94-8.13-3.52-18.17-3.52S43.66,125,43.66,126.91v-105Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="88.14 41.44 80.01 37.88 80.01 37.87 88.14 41.44"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="17.26"
                    x2="2.5"
                    y2="98.65"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="121.18"
                    y1="69.3"
                    x2="121.18"
                    y2="98.65"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M80,126.91c0,2-8.13,3.53-18.17,3.53s-18.18-1.58-18.18-3.53,8.14-3.52,18.18-3.52S80,125,80,126.91Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M88.14,41.44,80,37.87h0l-36.35-16V13.09c0-1.95,8.14-3.53,18.18-3.53S80,11.14,80,13.09Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="intake-edge" viewBox="0 0 145.69 119.14">
                <path
                    d="M47.35,76.69l-6.62,5h0v34.89H143.19V2.5l-68.55,53L59.53,67.19"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="27.5"
                    y1="91.98"
                    x2="40.73"
                    y2="81.75"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="13.46 81.46 19.6 85.52 15.96 92.09"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M2.5,97.1c2.05-5.79,9.09-11,17.1-11.58"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="103.17 89.11 104.1 75.17 91.69 74.39"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M64.48,81.23s21.26,16.53,39.62-6.06"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="27.5 71.33 27.5 76.45 56.46 57.94 27.5 71.33"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="56.32 52.91 56.32 58.03 85.28 39.52 56.32 52.91"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="85.28 34.4 85.28 39.52 114.23 21.01 85.28 34.4"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="114.23 15.89 114.23 21.01 143.19 2.5 114.23 15.89"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="intake-fascia" viewBox="0 0 151.95 149.36">
                <g>
                    <polygon
                        points="149.45 2.5 149.45 110.03 35.93 110.03 35.93 60.87 65.77 45.53 149.45 2.5"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <rect
                        x="70.45"
                        y="110.03"
                        width="79"
                        height="36.83"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="65.76"
                        y1="45.53"
                        x2="21.28"
                        y2="68.41"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="35.93"
                        y1="110.03"
                        x2="35.93"
                        y2="80.91"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="47.44"
                        y1="110.03"
                        x2="47.44"
                        y2="80.91"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="58.95"
                        y1="110.03"
                        x2="58.95"
                        y2="80.91"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="70.45"
                        y1="110.03"
                        x2="70.45"
                        y2="80.91"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M2.5,127.32s24.34,36.78,48.77-1.78"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="37.48 127.77 51.27 125.54 53.24 139.17"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="111.25 44.44 116.8 57.26 104.08 62.52"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M73.36,66s16.8-23.36,43.44-8.73"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <polygon
                    points="21.28 62.81 21.28 68.41 53.36 51.91 21.28 62.81"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="53.21 46.4 53.21 51.99 85.29 35.49 53.21 46.4"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="85.29 29.9 85.29 35.49 117.37 19 85.29 29.9"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="117.37 13.4 117.37 19 149.45 2.5 117.37 13.4"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <svg viewBox="0 0 145.3 133.68" id="intake-louvered-4-16">
                <polyline
                    points="2.5 52.81 2.5 73.2 2.5 93.57 2.5 113.95"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M47.48,2.5A38.19,38.19,0,0,1,44,17.67L2.5,52.82V39.73Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="6.83 73.2 2.5 73.2 2.5 52.81 6.83 73.2"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="6.83 93.57 2.5 93.57 2.5 73.2 6.83 93.57"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="6.83 113.95 2.5 113.95 2.5 93.57 6.83 113.95"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="139.31 34.9 97.83 70.04 2.5 52.81 43.99 17.67 127.13 32.7 139.31 34.9"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="32.91 43.62 46.27 32.07 108.93 43.39 95.58 54.95 32.91 43.62"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M142.8,19.73a38.28,38.28,0,0,1-3.48,15.17l-12.19-2.2L44,17.67A38.19,38.19,0,0,0,47.48,2.5Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="102.15 90.42 97.83 89.64 6.83 73.2 2.5 52.81 97.83 70.04 102.15 90.42"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="102.15 110.8 97.83 110.02 6.83 93.57 2.5 73.2 6.83 73.2 97.83 89.64 97.83 90.42 102.15 110.8"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="102.15 131.18 97.83 130.4 6.83 113.95 2.5 93.57 6.83 93.57 97.83 110.02 97.83 110.8 102.15 131.18"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="54.11"
                    y1="33.48"
                    x2="40.75"
                    y2="45.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="61.94"
                    y1="34.9"
                    x2="48.58"
                    y2="46.46"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="69.77"
                    y1="36.31"
                    x2="56.41"
                    y2="47.87"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="85.44"
                    y1="39.15"
                    x2="72.08"
                    y2="50.7"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="93.27"
                    y1="40.56"
                    x2="79.91"
                    y2="52.12"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="101.1"
                    y1="41.98"
                    x2="87.74"
                    y2="53.53"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="39.33 9.24 2.5 39.72 2.5 27.66 28.37 7.23 39.33 9.24"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="28.37 7.23 2.5 27.66 2.5 15.51 15.88 4.95 28.37 7.23"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="15.88 4.95 2.5 15.51 2.5 2.5 15.88 4.95"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="110.32 83.95 114.45 70.6 127.54 74.89"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M137.36,94.46s-14.77-4-22.9-23.86"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </svg>
            <symbol id="intake-louvered-8-16" viewBox="0 0 145.3 133.68">
                <polyline
                    points="2.5 52.81 2.5 73.2 2.5 93.57 2.5 113.95"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M47.48,2.5A38.19,38.19,0,0,1,44,17.67L2.5,52.82V39.73Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="6.83 73.2 2.5 73.2 2.5 52.81 6.83 73.2"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="6.83 93.57 2.5 93.57 2.5 73.2 6.83 93.57"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="6.83 113.95 2.5 113.95 2.5 93.57 6.83 113.95"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="139.31 34.9 97.83 70.04 2.5 52.81 43.99 17.67 127.13 32.7 139.31 34.9"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="28.5 48.04 51.63 28.66 114.29 39.99 91.16 59.36 28.5 48.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M142.8,19.73a38.28,38.28,0,0,1-3.48,15.17l-12.19-2.2L44,17.67A38.19,38.19,0,0,0,47.48,2.5Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="102.15 90.42 97.83 89.64 6.83 73.2 2.5 52.81 97.83 70.04 102.15 90.42"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="102.15 110.8 97.83 110.02 6.83 93.57 2.5 73.2 6.83 73.2 97.83 89.64 97.83 90.42 102.15 110.8"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="102.15 131.18 97.83 130.4 6.83 113.95 2.5 93.57 6.83 93.57 97.83 110.02 97.83 110.8 102.15 131.18"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="59.46"
                    y1="30.08"
                    x2="36.33"
                    y2="49.45"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="67.3"
                    y1="31.5"
                    x2="44.16"
                    y2="50.87"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="75.13"
                    y1="32.91"
                    x2="52"
                    y2="52.29"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="90.79"
                    y1="35.74"
                    x2="67.66"
                    y2="55.12"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="98.63"
                    y1="37.16"
                    x2="75.5"
                    y2="56.53"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="106.46"
                    y1="38.57"
                    x2="83.33"
                    y2="57.95"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="39.33 9.24 2.5 39.72 2.5 27.66 28.37 7.23 39.33 9.24"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="28.37 7.23 2.5 27.66 2.5 15.51 15.88 4.95 28.37 7.23"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="15.88 4.95 2.5 15.51 2.5 2.5 15.88 4.95"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="110.32 83.95 114.45 70.6 127.54 74.89"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M137.36,94.46s-14.77-4-22.9-23.86"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="exhaust-ridge" viewBox="0 0 164.83 113.05">
                <g>
                    <polygon
                        points="31.19 79.01 25.59 85.16 2.5 110.55 2.5 99.85 22.73 85.16 31.19 79.01"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="54.07 51.66 54.07 53.83 49.66 58.68 45.33 63.44 31.19 79.01 31.19 68.31 44.77 58.44 49.27 55.16 49.27 55.15 54.07 51.66"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="18.57 49.77 17.39 44.2 22.94 43.3"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M39,49c-5.66,1.61-13.5,1.72-21.59-4.8"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="47.57"
                        y1="40.05"
                        x2="43.11"
                        y2="43.61"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="117.25 99.85 117.25 110.55 94.15 85.16 90.55 81.2 88.56 79.01 91.58 81.2 97.03 85.16 117.25 99.85"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="47.57"
                        y1="40.05"
                        x2="43.11"
                        y2="43.61"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M56,33.34l-.68.54,2.42-1.57A6.69,6.69,0,0,0,56,33.34Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M49.27,55.15l4.8-3.49v2.17l-4.41,4.85-4.33,4.76L31.19,79l-5.6,6.15L2.5,110.55H117.25L94.15,85.16l-3.6-4-2-2.19L74.42,63.44l-4.33-4.76-1-1.12L67.6,55.94l-1.92-2.11V51.66l3.91,2.83.89.66m1.69-15.1-8.41-6.71a5.74,5.74,0,0,0-6-1l-2.42,1.57,0,0-7.71,6.15.84,7.46"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="88.56 68.31 88.56 79.01 74.42 63.44 70.09 58.68 69.07 57.56 67.6 55.94 65.68 53.83 65.68 51.66 69.59 54.49 70.48 55.15 70.48 55.16 70.94 55.5 74.98 58.44 88.56 68.31"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="59.88"
                        y1="99.46"
                        x2="59.88"
                        y2="68.31"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <polygon
                        points="162.32 70.5 156.21 74.47 145.9 81.2 117.25 99.85 97.03 85.16 91.58 81.2 88.56 79.01 133.63 49.63 142.1 55.8 162.32 70.5"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="71.42 46.72 72.17 40.05 76.26 43.3 76.64 43.61 106 24.48 108.19 23.05 112.41 20.31 116.46 17.67 115.55 25.79 113.3 27.27 70.48 55.15"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="133.63 38.93 127.52 42.92 88.56 68.31 74.98 58.44 70.94 55.5 70.48 55.16 70.48 55.15 113.3 27.27 115.55 25.79 115.55 25.8 120.05 29.07 133.63 38.93"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="146.26 20.55 147.43 14.73 141.89 13.79"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M147.43,14.74c-8.09,6.81-15.92,6.7-21.58,5"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <polygon
                    points="133.63 38.93 133.63 49.63 88.56 79.01 88.56 68.31 127.52 42.92 133.63 38.93"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="162.32 70.5 162.32 81.2 117.25 110.55 117.25 99.85 145.9 81.2 156.21 74.47 162.32 70.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M121.72,14.24l-5.26,3.43-4.06,2.64-4.21,2.74L106,24.48,76.64,43.61l-.38-.31-4.09-3.25-8.41-6.71a5.74,5.74,0,0,0-6-1L100.27,4.62l2.62-1.71h0A5.74,5.74,0,0,1,108.82,4l2.77,2.21,5.66,4.5h0Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="52.2 78.49 59.88 68.39 67.55 78.49"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <path
                        d="M102.91,2.9A5.74,5.74,0,0,1,108.82,4l12.9,10.26"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M87.88,12.69a5.74,5.74,0,0,1,5.91,1.08L106.69,24"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M72.85,22.47a5.78,5.78,0,0,1,5.92,1.09l12.9,10.26"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M57.83,32.26a5.76,5.76,0,0,1,5.91,1.08l12.9,10.27"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <line
                        x1="115.55"
                        y1="25.79"
                        x2="133.63"
                        y2="38.93"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="100.53"
                        y1="35.58"
                        x2="118.61"
                        y2="48.73"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="85.51"
                        y1="45.36"
                        x2="103.58"
                        y2="58.52"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="70.48"
                        y1="55.15"
                        x2="88.56"
                        y2="68.31"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <line
                        x1="133.63"
                        y1="49.64"
                        x2="162.33"
                        y2="70.5"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="118.61"
                        y1="59.43"
                        x2="147.3"
                        y2="80.28"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="103.58"
                        y1="69.22"
                        x2="132.27"
                        y2="90.07"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="88.56"
                        y1="79.01"
                        x2="117.25"
                        y2="99.85"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <line
                    x1="103.58"
                    y1="58.52"
                    x2="103.58"
                    y2="69.22"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="118.61"
                    y1="48.73"
                    x2="118.61"
                    y2="59.43"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="147.3"
                    y1="80.28"
                    x2="147.3"
                    y2="90.98"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="132.27"
                    y1="90.07"
                    x2="132.27"
                    y2="100.77"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="exhaust-box" viewBox="0 0 141.56 103.9">
                <g>
                    <polygon
                        points="139.06 58.33 58.66 101.4 26.09 76.52 37.76 70.72 58.44 87.41 116.73 57.51 116.73 44.75 139.06 58.33"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M58.44,69.72V87.41L37.75,70.72,2.5,42.26,17.16,27.6,47.69,49A25.4,25.4,0,0,1,58.44,69.72Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M116.73,41.25V57.51L58.44,87.41V69.72A25.4,25.4,0,0,0,47.69,49L17.16,27.6,73.77,2.5,106,20.56A25.27,25.27,0,0,1,116.73,41.25Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="58.44"
                        y1="78.76"
                        x2="58.44"
                        y2="68.88"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="49.83"
                        y1="72.08"
                        x2="49.83"
                        y2="62.2"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="43.4"
                        y1="66.97"
                        x2="43.4"
                        y2="57.09"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="36.97"
                        y1="61.86"
                        x2="36.97"
                        y2="51.97"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="30.54"
                        y1="56.75"
                        x2="30.54"
                        y2="46.86"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="24.11"
                        y1="51.63"
                        x2="24.11"
                        y2="41.75"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="17.68"
                        y1="46.52"
                        x2="17.68"
                        y2="36.64"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="66.77"
                        y1="75.72"
                        x2="66.77"
                        y2="66.48"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="75.1"
                        y1="71.42"
                        x2="75.1"
                        y2="62.41"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="83.42"
                        y1="67.14"
                        x2="83.42"
                        y2="58.33"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="91.75"
                        y1="62.85"
                        x2="91.75"
                        y2="54.26"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="100.08"
                        y1="58.55"
                        x2="100.08"
                        y2="50.18"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="108.41"
                        y1="54.26"
                        x2="108.41"
                        y2="46.11"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <line
                    x1="104.82"
                    y1="35.52"
                    x2="64.77"
                    y2="53.98"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="98.32"
                    y1="29.21"
                    x2="83.7"
                    y2="35.94"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="exhaust-power" viewBox="0 0 131.99 102.22">
                <polyline
                    points="2.5 51.42 32.51 62.83 99.48 88.31 129.49 99.72"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="99.48 27.78 99.48 88.31 32.51 62.83 32.51 27.78 99.48 27.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M44.55,2.5H87.43a25.28,25.28,0,0,1,25.28,25.28v0a0,0,0,0,1,0,0H19.27a0,0,0,0,1,0,0v0A25.28,25.28,0,0,1,44.55,2.5Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="exhaust-bath" viewBox="0 0 132.23 167.08">
                <g>
                    <path
                        d="M117.13,123.88a10.14,10.14,0,0,1-6,9,75.23,75.23,0,0,1-62.84,0L22.56,121l-7.17-3.29a10.16,10.16,0,0,1-6-9.34v0a10.17,10.17,0,0,1,6-9.33h0a75.32,75.32,0,0,1,62.84,0l32.92,15.12A10.14,10.14,0,0,1,117.13,123.88Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M79.74,132.74a67.87,67.87,0,0,1-28.5-6.23L18.31,111.39a3.28,3.28,0,0,1,0-6l1-.46a68.34,68.34,0,0,1,56,.46l32.92,15.12a3.29,3.29,0,0,1,0,6c-2.1,1-4.29,1.84-6.51,2.6A68.09,68.09,0,0,1,79.74,132.74Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M117.14,148.37v0a10.18,10.18,0,0,1-6,9.32,75.28,75.28,0,0,1-62.84,0L15.39,142.59a10.14,10.14,0,0,1-6-9.35V108.41a10.16,10.16,0,0,0,6,9.34L22.56,121l25.75,11.83a75.23,75.23,0,0,0,62.84,0,10.14,10.14,0,0,0,6-9Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="117.13"
                        y1="123.88"
                        x2="117.13"
                        y2="123.68"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M19.58,97.28v-24c0-19.91,16.57-18.27,17.22-7.39"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M43.75,68.63c0,1.5-3.1,2.71-6.93,2.71s-6.92-1.21-6.92-2.71,3.09-2.7,6.9-2.7h0C40.65,65.93,43.75,67.14,43.75,68.63Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M47.5,81.69c0,2.65-4.78,4.79-10.68,4.79s-10.68-2.14-10.68-4.79c0-1.56,1.66-2.94,4.24-3.8,1,1,3.51,1.72,6.44,1.72s5.45-.71,6.45-1.72C45.84,78.75,47.5,80.13,47.5,81.69Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M43.75,68.63v8.28a1.39,1.39,0,0,1-.48,1c-1,1-3.51,1.72-6.45,1.72s-5.44-.71-6.44-1.72a1.39,1.39,0,0,1-.48-1V68.63c0,1.5,3.1,2.71,6.92,2.71S43.75,70.13,43.75,68.63Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <polygon
                        points="107.41 12.63 64.69 20.48 54.15 9.81 96.22 2.5 107.41 12.63"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M64.69,20.48c0,.86,0,1.66-.1,2.41a18.79,18.79,0,0,1-.89,4.54c-1.3,3.84-3.6,5.12-4.94,5.54h0l-1,.2h0V47.92l-23.44-11V17.06L54.15,9.81Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M107.41,12.63c0,11.94-7.4,12.16-7.4,12.16L88.6,27.05l-.72.14L58.76,33c1.34-.42,3.64-1.7,4.94-5.54a18.79,18.79,0,0,0,.89-4.54c.07-.75.1-1.55.1-2.41Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M100,24.79V38.86L57.72,47.92V33.18h0a5.38,5.38,0,0,0,1-.2h0l29.12-5.78.72-.14Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M58.74,33a5.38,5.38,0,0,1-1,.2Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="129.73 42.41 60.28 59.12 2.5 34.41 34.28 28.51 34.28 36.91 57.72 47.92 100.01 38.86 100.01 31.61 129.73 42.41"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <path
                            d="M75.37,18.52c0,.87,0,1.69-.11,2.45a18.21,18.21,0,0,1-1,4.59c-1.51,4.06-4.22,5.05-5.23,5.36"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M86.05,16.55c0,.9,0,1.72-.11,2.49a16.86,16.86,0,0,1-1,4.65,8,8,0,0,1-5.5,5.19"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M96.73,14.59a24.83,24.83,0,0,1-.12,2.53,16.05,16.05,0,0,1-1.12,4.7,7.81,7.81,0,0,1-5.79,5"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                </g>
            </symbol>
            <symbol id="exhaust-kitchen" viewBox="0 0 132.23 169.56">
                <g>
                    <g>
                        <polygon
                            points="129.73 98.82 60.28 115.53 2.5 90.82 72.16 77.89 129.73 98.82"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <g>
                            <path
                                d="M48.46,92.11c4.84,1.94,4.94,4.31.22,5.3s-12.47.16-17.31-1.86-4.94-4.39-.22-5.3S43.62,90.17,48.46,92.11Z"
                                style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                            />
                            <path
                                d="M76.77,86.4c4.83,1.81,4.92,4.08.2,5.07s-12.46.27-17.29-1.62-4.93-4.16-.21-5.07S71.94,84.59,76.77,86.4Z"
                                style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                            />
                            <path
                                d="M72.67,101.81c4.83,1.94,4.94,4.41.23,5.5s-12.46.36-17.3-1.66-5-4.48-.23-5.5S67.83,99.87,72.67,101.81Z"
                                style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                            />
                            <path
                                d="M100.94,95.46c4.83,1.81,4.93,4.17.22,5.27s-12.45.46-17.29-1.43-4.93-4.25-.22-5.27S96.11,93.65,100.94,95.46Z"
                                style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                            />
                        </g>
                    </g>
                    <polyline
                        points="2.5 90.82 2.5 142.34 60.28 167.06 129.73 150.35 129.73 98.82"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="60.28"
                        y1="167.06"
                        x2="60.29"
                        y2="115.54"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="60.28"
                        y1="127.27"
                        x2="129.73"
                        y2="110.06"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="89.86"
                        y1="128.94"
                        x2="101.99"
                        y2="125.95"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="2.5"
                        y1="90.82"
                        x2="2.5"
                        y2="80.71"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="72.16"
                        y1="77.89"
                        x2="72.16"
                        y2="67.79"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="2.5"
                        y1="80.71"
                        x2="72.16"
                        y2="67.79"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <polygon
                        points="107.41 12.63 64.69 20.48 54.15 9.81 96.22 2.5 107.41 12.63"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M64.69,20.48c0,.86,0,1.66-.1,2.41a18.79,18.79,0,0,1-.89,4.54c-1.3,3.84-3.6,5.12-4.94,5.54h0l-1,.2h0V47.92l-23.44-11V17.06L54.15,9.81Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M107.41,12.63c0,11.94-7.4,12.16-7.4,12.16L88.6,27.05l-.72.14L58.76,33c1.34-.42,3.64-1.7,4.94-5.54a18.79,18.79,0,0,0,.89-4.54c.07-.75.1-1.55.1-2.41Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M100,24.79V38.86L57.72,47.92V33.18h0a5.38,5.38,0,0,0,1-.2h0l29.12-5.78.72-.14Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M58.74,33a5.38,5.38,0,0,1-1,.2Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="129.73 42.41 60.28 59.12 2.5 34.41 34.28 28.51 34.28 36.91 57.72 47.92 100.01 38.86 100.01 31.61 129.73 42.41"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <path
                            d="M75.37,18.52c0,.87,0,1.69-.11,2.45a18.21,18.21,0,0,1-1,4.59c-1.51,4.06-4.22,5.05-5.23,5.36"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M86.05,16.55c0,.9,0,1.72-.11,2.49a16.86,16.86,0,0,1-1,4.65,8,8,0,0,1-5.5,5.19"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M96.73,14.59a24.83,24.83,0,0,1-.12,2.53,15.74,15.74,0,0,1-1.12,4.7,7.81,7.81,0,0,1-5.79,5"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                </g>
            </symbol>
            <symbol id="roof-patch" viewBox="0 0 139.85 129.64">
                <path
                    d="M139.77,84.59a.88.88,0,0,0-.05-.15,3.25,3.25,0,0,0-.18-.43s0-.07,0-.1L125.66,60.69l0-.1a2.51,2.51,0,0,0-.57-.91l-6.3-10.56,6.8-2.42a2.5,2.5,0,0,0,1.31-3.64l-25-41.84a2.52,2.52,0,0,0-3-1.08l-59.3,21.1a2.47,2.47,0,0,0-1.52,1.51,2.5,2.5,0,0,0,.21,2.13q1.41,2.36,2.81,4.72L1.89,43.52h0a2.57,2.57,0,0,0-.41.19l0,0s0,0-.07.05a2.69,2.69,0,0,0-.27.2l-.1.09a3.65,3.65,0,0,0-.27.3l0,0a2.26,2.26,0,0,0-.22.37l0,.12c0,.1-.08.19-.11.29l0,.14a1.77,1.77,0,0,0,0,.32s0,.08,0,.12,0,0,0,0L0,54.48a2.51,2.51,0,0,0,.35,1.34l43.34,72.6s0,0,.05.06l.07.11.21.26.06.07,0,0,.31.25.08,0,.05,0,.11.07.14.07.14.05.22.08.1,0,.12,0a2.28,2.28,0,0,0,.45,0,2.49,2.49,0,0,0,.47,0l.13,0,.11,0,.13,0L138.19,97l.06,0a1.92,1.92,0,0,0,.25-.12l.2-.1.19-.15.19-.16a1.29,1.29,0,0,0,.16-.17l.15-.19a1.48,1.48,0,0,0,.13-.21c0-.07.08-.13.11-.2l.08-.23a2,2,0,0,0,.07-.23,2.07,2.07,0,0,0,0-.22c0-.1,0-.19,0-.28a.15.15,0,0,0,0-.07V85.2h0A2.41,2.41,0,0,0,139.77,84.59Zm-6.12-.73-6.6,2.35L123,79.38l6.6-2.34ZM127,72.65,107.68,79.5l-4.85-8.15,19.28-6.85Zm-18.85-8.49L100,67.06l-4.59-7.77,8.11-2.88ZM70.92,82.7l4.84,8.12-21,7.43L50,90.15Zm20.13,8,4.09,6.86-21,7.45-4.09-6.88ZM80.56,89.11,75.72,81,98,73.06l4.85,8.14Zm37.61-8,4.07,6.84-22.3,7.93L95.86,89Zm-5.25-18.62-4.61-7.75,6.57-2.33,4.62,7.74ZM98.67,5.54,121,43,109,47.3,94.58,52.41l-28.08,10L50.3,35.21l-3.84-6.45-2.29-3.83Zm-56.4,29,4.82,8.1L26.13,50,21.3,41.94Zm6,36.19-8.17,2.9-4.81-8.07,8.2-2.9ZM6.44,47.21,16.5,43.64l4.82,8.1-10,3.55Zm7.47,12.46L36.6,51.62c.73,1.24,1.44,2.45,2.13,3.66.6,1,1.19,2,1.8,3.09l-22.61,8Zm6.64,11.06,10-3.52,4.81,8.08L25.4,78.81Zm7.7,12.6-.17-.16,22.53-8L55.26,83,32.78,91Zm7.14,12,9.77-3.47L50,100l-9.77,3.46Zm7.44,12.47,22.45-8,4.1,6.88-22.44,8Zm92-15L48.34,123.6v-4.09l25.59-9.1,25.75-9.16,27.11-9.64,8.06-2.87Z"
                />
                <g>
                    <path
                        d="M81.09,46.09,68.24,51,64.58,27.59,77.44,22.7l.82,5.06L71.2,30.45l.59,3.67,6.58-2.5.72,5.1-6.57,2.5.71,4.41,7.06-2.69Z"
                    />
                    <path
                        d="M101.62,38.28,86.31,44.11l-.66-3.85L90.79,23l-7.09,2.7-.81-5.1,14.6-5.56L98.1,19,92.79,36.23l8-3Z"
                    />
                </g>
            </symbol>
            <symbol id="flat-ib-80" viewBox="0 0 143.71 126.77">
                <path
                    d="M82,57.81V68.69l-27.9-9.25-.16,0-.2-.07L2.5,42.36V31.48l51.19,17,.2.06.16.05Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="141.21 28.84 141.21 39.72 81.95 68.69 81.95 57.81 111.58 43.32 141.21 28.84"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M82,68.69v55.58L2.5,97.93V42.36l51.19,17,.2.07.16,0Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="141.21 39.72 141.21 95.3 81.95 124.27 81.95 68.69 141.21 39.72"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M141.21,28.84,111.58,43.32,89.89,36.13l.06,0,0,0c6.86-3.59,9.7-12,9.87-12.5L80.53,33h0L32.13,17,61.76,2.5l48.39,16,9.33,3.09Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M80.52,33l-4.6,2.25s-2.82,8.91-10,12.59l-.15.08a15.2,15.2,0,0,1-11.72.61l-.16-.05-.2-.06L2.5,31.48,32.13,17Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M111.58,43.32,82,57.81l-27.9-9.25A15.2,15.2,0,0,0,65.77,48l.15-.08,24-11.74h0Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M99.87,23.57c-.17.52-3,8.91-9.87,12.5l0,0-.06,0h0l-24,11.74c7.18-3.68,10-12.59,10-12.59L80.52,33h0Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M99.88,23.54a.08.08,0,0,1,0,0"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="flat-ma-tpo" viewBox="0 0 143.71 126.77">
                <path
                    d="M82,57.81V68.69l-27.9-9.25-.16,0-.2-.07L2.5,42.36V31.48l51.19,17,.2.06.16.05Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="141.21 28.84 141.21 39.73 81.95 68.69 81.95 57.81 141.21 28.84"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M82,68.69v55.58L2.5,97.93V42.36l51.19,17,.2.07.16,0Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="141.21 39.73 141.21 95.3 81.95 124.27 81.95 68.69 141.21 39.73"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M110.15,18.54,75.92,35.28s-2.82,8.91-10,12.59l-.15.08a15.2,15.2,0,0,1-11.72.61l-.16-.05-.2-.06L2.5,31.48l59.26-29Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M141.21,28.84,82,57.81l-27.9-9.25A15.2,15.2,0,0,0,65.77,48l.15-.08,53.56-26.24Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="135.18"
                    y1="6.31"
                    x2="135.17"
                    y2="6.32"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M126.07,18.41a14,14,0,0,1-2.23,1.09"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M135.17,6.32c-.1.32-2.72,8.26-9.1,12.09l-2.23,1.09-.06,0-4.3,2.1L65.92,47.87c7.18-3.68,10-12.59,10-12.59l34.23-16.74Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="135.18"
                    y1="6.31"
                    x2="135.17"
                    y2="6.32"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="flat-mod-bitumen" viewBox="0 0 143.72 147.54">
                <g>
                    <path
                        d="M82,78.57V89.45L54.05,80.2l-.16,0-.2-.07L2.5,63.12V52.24l51.19,17,.2.06.16,0Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="141.22 49.6 141.22 60.48 81.95 89.45 81.95 78.57 141.22 49.6"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M82,89.45V145L2.5,118.7V63.12l51.19,17,.2.07.16,0Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="141.22 60.48 141.22 116.07 81.95 145.04 81.95 89.45 141.22 60.48"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M141.22,49.6,82,78.57,57.46,70.45l-.07,0-2-.65,0,0-1.49-.49L2.5,52.24l59.26-29,15.08,5a15.83,15.83,0,0,0-.27,3,10.54,10.54,0,0,0,.08,1.38L50.75,45.3a11.3,11.3,0,0,1,6.71-.24c7,1.75,12.69,8.85,12.69,15.86a9.82,9.82,0,0,1-3.52,7.9l53.8-26.11Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M70.15,60.92a9.82,9.82,0,0,1-3.52,7.9,10.4,10.4,0,0,1-9.17,1.63l-.07,0a15.14,15.14,0,0,1-2-.65l0,0c-6-2.49-10.62-8.87-10.62-15.17,0-4.55,2.39-7.94,6-9.29a11.3,11.3,0,0,1,6.71-.24C64.47,46.81,70.15,53.91,70.15,60.92Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M116.72,16.09a11.16,11.16,0,0,0-7,.35l-.11.06-.86.41-7.94,3.89a41,41,0,0,1,1.29,10.45,12.77,12.77,0,0,1-25.46,1.38L50.75,45.3a11.3,11.3,0,0,1,6.71-.24c7,1.75,12.69,8.85,12.69,15.86a9.82,9.82,0,0,1-3.52,7.9l53.8-26.11,3.17-1.54h0l1.14-.56A9.55,9.55,0,0,0,129.42,32C129.42,24.94,123.73,17.84,116.72,16.09Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="124.88"
                        y1="40.55"
                        x2="124.77"
                        y2="40.6"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <path
                        d="M88.51,2.5c4.88,11.87-11.94,14.64-11.94,28.75a12.77,12.77,0,1,0,25.54,0C102.11,10.54,88.51,2.5,88.51,2.5Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M89.46,22c-.92,4.24-6.64,6.13-7.53,12.22-.56,3.87,1.47,7.58,4.92,8.49C91,43.8,95,40.47,95.28,35.94c.49-7.21-1.78-11.95-3.67-14.58A1.2,1.2,0,0,0,89.46,22Z"
                        style=""
                    />
                </g>
            </symbol>
            <symbol id="flat-rail-black-alum" viewBox="0 0 104.02 96.58">
                <rect
                    x="13.49"
                    y="2.5"
                    width="10.15"
                    height="91.58"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="80.38"
                    y="2.5"
                    width="10.15"
                    height="91.58"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="23.64"
                    y1="15.79"
                    x2="80.38"
                    y2="15.79"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="15.79"
                    x2="13.49"
                    y2="15.79"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="25.95"
                    x2="13.49"
                    y2="25.95"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="90.53"
                    y1="15.79"
                    x2="101.52"
                    y2="15.79"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="90.53"
                    y1="25.95"
                    x2="101.52"
                    y2="25.95"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="23.64"
                    y1="25.95"
                    x2="80.38"
                    y2="25.95"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="94.08"
                    x2="101.52"
                    y2="94.08"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="42.55"
                    y1="25.95"
                    x2="42.55"
                    y2="94.08"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="61.47"
                    y1="25.95"
                    x2="61.47"
                    y2="94.08"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="flat-rail-custom" viewBox="0 0 104.02 101.51">
                <rect
                    x="13.49"
                    y="11.6"
                    width="10.15"
                    height="87.41"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="80.38"
                    y="11.6"
                    width="10.15"
                    height="87.41"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="23.64"
                    y1="20.73"
                    x2="80.38"
                    y2="20.73"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="20.73"
                    x2="13.49"
                    y2="20.73"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="30.88"
                    x2="13.49"
                    y2="30.88"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="90.53"
                    y1="20.73"
                    x2="101.52"
                    y2="20.73"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="90.53"
                    y1="30.88"
                    x2="101.52"
                    y2="30.88"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="23.64"
                    y1="30.88"
                    x2="80.38"
                    y2="30.88"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="99.01"
                    x2="101.52"
                    y2="99.01"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M44.55,30.88c0,11.35-4,11.35-4,22.71s4,11.35,4,22.71-4,11.35-4,22.71"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M63.47,30.88c0,11.35-4,11.35-4,22.71s4,11.35,4,22.71-4,11.35-4,22.71"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M40.38,30.88h8.35a0,0,0,0,1,0,0v.68a4.17,4.17,0,0,1-4.17,4.17h0a4.17,4.17,0,0,1-4.17-4.17v-.68A0,0,0,0,1,40.38,30.88Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M59.29,30.88h8.35a0,0,0,0,1,0,0v.68a4.17,4.17,0,0,1-4.17,4.17h0a4.17,4.17,0,0,1-4.17-4.17v-.68A0,0,0,0,1,59.29,30.88Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M55.12,94.16h8.35a0,0,0,0,1,0,0v.68A4.17,4.17,0,0,1,59.29,99h0a4.17,4.17,0,0,1-4.17-4.17v-.68A0,0,0,0,1,55.12,94.16Z"
                    transform="translate(118.59 193.16) rotate(180)"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M36.21,94.16h8.35a0,0,0,0,1,0,0v.68A4.17,4.17,0,0,1,40.38,99h0a4.17,4.17,0,0,1-4.17-4.17v-.68A0,0,0,0,1,36.21,94.16Z"
                    transform="translate(80.76 193.16) rotate(-180)"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="30.03 2.5 7.1 2.5 13.49 11.6 23.64 11.6 30.03 2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="96.92 2.5 73.99 2.5 80.38 11.6 90.53 11.6 96.92 2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="flat-rail-timber" viewBox="0 0 104.02 106.03">
                <rect
                    x="77.87"
                    y="11.95"
                    width="15.17"
                    height="91.58"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="26.15"
                    y1="25.25"
                    x2="77.87"
                    y2="25.25"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="25.25"
                    x2="10.98"
                    y2="25.25"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="35.4"
                    x2="10.98"
                    y2="35.4"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="93.04"
                    y1="25.25"
                    x2="101.52"
                    y2="25.25"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="93.04"
                    y1="35.4"
                    x2="101.52"
                    y2="35.4"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="26.15"
                    y1="35.4"
                    x2="77.87"
                    y2="35.4"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="103.53"
                    x2="101.52"
                    y2="103.53"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="42.55"
                    y1="35.4"
                    x2="42.55"
                    y2="103.53"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="61.47"
                    y1="35.4"
                    x2="61.47"
                    y2="103.53"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="10.98"
                    y="11.95"
                    width="15.17"
                    height="91.58"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M12.24,35.77a14.83,14.83,0,0,0,6.7-6,15.11,15.11,0,0,0,1.77-10A2.51,2.51,0,0,0,17.64,18a2.57,2.57,0,0,0-1.75,3.07c0-.24,0-.23,0,0s0,.37,0,.56,0,.68,0,1,0,.6-.06.9c-.06.69.08-.28,0,.11,0,.15-.05.3-.08.45-.14.67-.37,1.29-.57,1.94-.11.37.16-.31,0,0-.08.17-.15.34-.24.51a8.6,8.6,0,0,1-.47.84c-.14.23-.29.46-.44.68s-.26.33,0,.06l-.26.31a12.18,12.18,0,0,1-1.29,1.3l-.31.27c-.36.3.19-.12-.06,0s-.45.31-.68.45a12.22,12.22,0,0,1-1.72.9,2.51,2.51,0,0,0-.89,3.42,2.57,2.57,0,0,0,3.42.9Z"
                    style=""
                />
                <path
                    d="M26.15,32.91c-3.31-.14-6.22,2.16-7.67,5a22.59,22.59,0,0,0-1.59,4.34c-.2.71-.39,1.41-.62,2.11-.12.38-.26.76-.41,1.13s.26-.51,0,.11l-.3.58a2.5,2.5,0,0,0,4.32,2.53,20.76,20.76,0,0,0,1.61-4.18c.19-.65.36-1.3.56-2,.08-.29.18-.58.27-.87s.12-.32.17-.48.23-.59.1-.27.06-.11.08-.16.14-.31.22-.46.3-.53.46-.78a3.93,3.93,0,0,1,.29-.42c-.12.14-.22.27,0,.07s.43-.44.65-.65-.07,0-.07,0a2.63,2.63,0,0,1,.39-.26l.4-.22c.36-.21-.06.07-.09,0s.87-.23.88-.25-.53,0-.12,0h.55a2.51,2.51,0,0,0,2.5-2.5,2.55,2.55,0,0,0-2.5-2.5Z"
                    style=""
                />
                <path
                    d="M12.74,64.47a17.2,17.2,0,0,0,6.2-9.78,2.5,2.5,0,1,0-4.82-1.33,15,15,0,0,1-.7,2.34c-.1.27.27-.61.07-.16a2.56,2.56,0,0,0-.11.24l-.27.55c-.2.38-.42.76-.65,1.12a10.54,10.54,0,0,1-.72,1c0-.07.34-.44.13-.18l-.22.28-.42.48a18,18,0,0,1-2,1.88,2.47,2.47,0,0,0-.73,1.76A2.49,2.49,0,0,0,11,65.2a2.83,2.83,0,0,0,1.76-.73Z"
                    style=""
                />
                <path
                    d="M14.5,75A29.29,29.29,0,0,0,28.56,55.09,2.56,2.56,0,0,0,26.81,52a2.51,2.51,0,0,0-3.07,1.75A24.39,24.39,0,0,1,12,70.63,2.5,2.5,0,0,0,14.5,75Z"
                    style=""
                />
                <path
                    d="M24,70.6,17.24,81.37a2.52,2.52,0,0,0,.89,3.42,2.55,2.55,0,0,0,3.42-.9l6.76-10.77A2.5,2.5,0,0,0,24,70.6Z"
                    style=""
                />
                <path
                    d="M13.14,104.75a10.09,10.09,0,0,1,1-1.77c.11-.16.29-.37.07-.1l.35-.42c.22-.26.44-.51.67-.75,1-1.07,2.09-2.07,3.07-3.16,2.33-2.62,4.12-5.88,3.28-9.48a2.5,2.5,0,0,0-4.82,1.33c0,.15.07.29.09.44-.09-.52,0,0,0,.09s0,.29,0,.43.1-.37,0,.09c-.08.29-.15.57-.24.85-.21.63.13-.21,0,.13-.08.13-.14.28-.21.41a8.24,8.24,0,0,1-.54.9c-.08.13-.17.26-.26.39-.43.61.16-.17-.11.16-.45.53-.91,1-1.4,1.55-1.9,2-4,3.86-5.19,6.38a2.5,2.5,0,0,0,4.32,2.53Z"
                    style=""
                />
                <path
                    d="M78.53,20.41l.18,0-.66.09a3.19,3.19,0,0,1,.69,0l-.66-.09a6.21,6.21,0,0,1,1.19.34l-.6-.25a6.08,6.08,0,0,1,1.26.73l-.51-.39a4.7,4.7,0,0,1,.69.72l-.4-.51c.72,1,1.17,2.1,1.83,3.1a8.8,8.8,0,0,0,1.34,1.65,6.74,6.74,0,0,0,2.28,1.38,2.44,2.44,0,0,0,1.92-.25,2.5,2.5,0,0,0,.9-3.42,2.85,2.85,0,0,0-1.49-1.15l-.12,0,.6.25a5.41,5.41,0,0,1-.74-.42l.51.39a5.75,5.75,0,0,1-.95-1l.39.5c-1.11-1.47-1.65-3.39-3.06-4.64a7.07,7.07,0,0,0-5.91-1.84,2.52,2.52,0,0,0-1.75,3.08,2.57,2.57,0,0,0,3.07,1.75Z"
                    style=""
                />
                <path
                    d="M93.71,34c-2.51-.56-5.43-.5-7.44,1.33A10,10,0,0,0,84,39.12c-.51,1.28-1,2.57-1.49,3.86a2.51,2.51,0,0,0,.25,1.93,2.48,2.48,0,0,0,3.42.89,2.85,2.85,0,0,0,1.15-1.49c.53-1.39,1-2.8,1.62-4.17l-.25.59a8.6,8.6,0,0,1,1-1.88l-.39.51a3.47,3.47,0,0,1,.62-.65l-.5.39a3.33,3.33,0,0,1,.61-.35l-.6.25a4.91,4.91,0,0,1,1.25-.33l-.67.09a8.44,8.44,0,0,1,2.13,0l-.67-.09c.28,0,.55.09.83.15A2.5,2.5,0,0,0,93.71,34Z"
                    style=""
                />
                <path
                    d="M80.28,61.81c.13-.44.27-.88.44-1.32,0-.06.27-.68.15-.4s.19-.42.23-.49a18.21,18.21,0,0,1,1.28-2.28c.25-.37.5-.73.77-1.09-.31.41.1-.11.16-.19l.52-.6q.19-.22.42-.45a1.8,1.8,0,0,1,.2-.19c-.26.18-.27.19,0,0,.49-.16-.47,0,.09-.06a1.18,1.18,0,0,1-.82-.11c.2.12.22.13,0,0a.61.61,0,0,1-.28-.31c.1.19.11.21,0,.06s-.07-.13,0,.11c0-.31,0-.32,0,0v.21c0,.25,0,.5,0,.75,0,1.09.06,2.17,0,3.26s-.09,2-.19,3c0,.25,0,.5-.08.75,0,.08-.1.76,0,.33-.08.58-.18,1.16-.28,1.73a2.56,2.56,0,0,0,1.75,3.08,2.52,2.52,0,0,0,3.07-1.75,48.37,48.37,0,0,0,.79-8.14c0-2.81.17-6.7-3.15-7.73-3.1-1-5.29,1.85-6.87,4a21,21,0,0,0-3.11,6.42,2.5,2.5,0,0,0,4.82,1.32Z"
                    style=""
                />
                <path
                    d="M80.28,87.38c.16-.45-.12.19,0-.07s.12-.25.19-.37a7.68,7.68,0,0,1,.47-.78c0-.06.38-.52.17-.25s.09-.11.13-.15c.2-.23.4-.47.61-.69.89-1,1.87-1.83,2.73-2.82,2.08-2.36,3.53-5.41,2.64-8.6A2.5,2.5,0,0,0,82.42,75s.13.37.1.4l0-.26a3,3,0,0,1,0,.31c0,.13,0,.27,0,.4s-.06.51,0,.18-.07.27-.07.28-.07.27-.12.4-.09.26-.14.39c.08-.21.12-.25,0,0s-.29.55-.46.81-.17.23-.24.35c-.19.32.24-.28,0,0-.41.49-.84,1-1.29,1.42-1.9,1.94-3.77,3.78-4.73,6.4a2.5,2.5,0,0,0,1.75,3.07,2.56,2.56,0,0,0,3.07-1.74Z"
                    style=""
                />
                <path
                    d="M93,95.61a1.39,1.39,0,0,0-.35,0c.1-.06.49.11.14,0a1.9,1.9,0,0,0-.34-.11c.05,0,.46.24.11,0a3.07,3.07,0,0,0-.31-.17c-.47-.27.24.23,0,0s-.35-.32-.51-.5-.31-.37-.09-.1,0-.05-.07-.11a6.18,6.18,0,0,1-.37-.61c-.27-.47-.49-1-.72-1.45-.11-.24-.08-.15,0,0a2.54,2.54,0,0,1-.16-.38c-.1-.25-.19-.5-.28-.75-.18-.51-.34-1-.48-1.55s-.28-1.11-.39-1.67c-.05-.26-.1-.52-.14-.79,0-.06-.08-.5,0-.16s0-.26,0-.27a2.71,2.71,0,0,0-.73-1.77,2.57,2.57,0,0,0-1.77-.73,2.53,2.53,0,0,0-2.5,2.5,26.34,26.34,0,0,0,2.34,8.43c1.26,2.71,3.43,5.06,6.63,5.09a2.52,2.52,0,0,0,2.5-2.5,2.55,2.55,0,0,0-2.5-2.5Z"
                    style=""
                />
                <path
                    d="M80,38.34a10.76,10.76,0,0,1,1.13-1.76l-.39.5a16.76,16.76,0,0,1,3-3l-.5.39a10.63,10.63,0,0,1,1.18-.8,2.52,2.52,0,0,0,1.15-1.49,2.5,2.5,0,0,0-3.67-2.82,15.37,15.37,0,0,0-3.5,2.82,21.41,21.41,0,0,0-1.68,2,10.17,10.17,0,0,0-1,1.59,2.7,2.7,0,0,0-.25,1.93,2.5,2.5,0,0,0,4.57.6Z"
                    style=""
                />
                <path
                    d="M33.4,27.66a9.18,9.18,0,0,1,.91.19l.48.16c.37.13.13.12,0,0a8.29,8.29,0,0,0,.84.43,7.9,7.9,0,0,0,.8.53c-.25-.19-.3-.23-.16-.11l.2.17.33.31c0,.05.68.72.67.73s-.32-.44,0,0a5.72,5.72,0,0,1,.32.48c.19.29.37.6.55.91,1.45,2.57,3,5.77,6.27,6.37A2.5,2.5,0,1,0,45.89,33l-.47-.11c-.42-.12.33.19.08,0l-.42-.25c-.25-.14.38.34,0,0s-.46-.44-.67-.68,0-.14,0,0a3,3,0,0,0-.31-.44c-.79-1.18-1.36-2.49-2.13-3.68a11.08,11.08,0,0,0-7.28-5.08,2.73,2.73,0,0,0-1.92.25,2.5,2.5,0,0,0,.59,4.57Z"
                    style=""
                />
                <path
                    d="M46.18,27l3.71,4.15a2.57,2.57,0,0,0,1.77.73,2.49,2.49,0,0,0,2.5-2.5,2.75,2.75,0,0,0-.73-1.77l-3.71-4.15a2.51,2.51,0,0,0-3.54,0,2.51,2.51,0,0,0-.73,1.77A2.75,2.75,0,0,0,46.18,27Z"
                    style=""
                />
                <path
                    d="M60.61,36.66a39.21,39.21,0,0,0,5-10.75,2.5,2.5,0,0,0-4.82-1.33c-.34,1-.7,2-1.09,3-.08.22-.17.44-.26.66l-.13.33c-.22.54.15-.35,0,0s-.38.87-.58,1.3a27,27,0,0,1-2.46,4.27,2.5,2.5,0,0,0,.9,3.42,2.57,2.57,0,0,0,3.42-.9Z"
                    style=""
                />
                <path
                    d="M67.18,27.41l.09.06-.5-.39a11.59,11.59,0,0,1,2,2l-.39-.51a11.5,11.5,0,0,1,1.4,2.4l-.25-.6A11.16,11.16,0,0,1,70.24,33a2.43,2.43,0,0,0,1.15,1.49,2.49,2.49,0,0,0,3.42-.89l.25-.6a2.5,2.5,0,0,0,0-1.33,12.39,12.39,0,0,0-1.67-4.59,14,14,0,0,0-3.68-4,2.46,2.46,0,0,0-1.93-.25A2.49,2.49,0,0,0,66.29,24,2.53,2.53,0,0,0,66,25.91l.26.6a2.64,2.64,0,0,0,.89.9Z"
                    style=""
                />
                <path
                    d="M26.81,37.81a14.06,14.06,0,0,0,4-2,16.19,16.19,0,0,0,1.91-1.6,16.06,16.06,0,0,0,1.62-2,2.6,2.6,0,0,0,.25-1.93,2.53,2.53,0,0,0-1.15-1.49,2.5,2.5,0,0,0-1.93-.25A2.83,2.83,0,0,0,30,29.71l-.28.38.39-.51A12.15,12.15,0,0,1,28,31.72l.51-.39a12.53,12.53,0,0,1-2.72,1.58l.6-.25c-.29.12-.59.23-.89.33A2.62,2.62,0,0,0,24,34.14a2.55,2.55,0,0,0-.25,1.93,2.5,2.5,0,0,0,3.07,1.74Z"
                    style=""
                />
                <path
                    d="M29.17,0H8a2.54,2.54,0,0,0-2.5,2.5V12A2.53,2.53,0,0,0,8,14.45H29.17a2.53,2.53,0,0,0,2.5-2.5V2.5c0-3.22-5-3.22-5,0V12l2.5-2.5H8l2.5,2.5V2.5L8,5H29.17C32.39,5,32.4,0,29.17,0Z"
                    style=""
                />
                <path
                    d="M96.07,0H74.85a2.53,2.53,0,0,0-2.5,2.5V12a2.53,2.53,0,0,0,2.5,2.5H96.07a2.53,2.53,0,0,0,2.5-2.5V2.5c0-3.22-5-3.22-5,0V12l2.5-2.5H74.85l2.5,2.5V2.5L74.85,5H96.07C99.28,5,99.29,0,96.07,0Z"
                    style=""
                />
            </symbol>
        </g>

        <!-- Siding estimate icons -->
        <g>
            <symbol id="inside-corner" viewBox="0 0 115.51 128.43">
                <g>
                    <polyline
                        points="113.01 125.93 107.93 123.64 77.67 110.02"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="113.01 95.08 108.28 94.01 77.67 87.12"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="113.01 64.22 108.11 64.22 77.67 64.22"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="113.01 33.36 107.93 34.5 77.67 41.32"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="77.67 18.41 77.67 110.02 57.76 101.06 57.76 27.38 77.67 18.41"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="113.01"
                        y1="2.5"
                        x2="77.67"
                        y2="18.41"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <polygon
                    points="113.01 33.36 113.01 2.5 107.93 34.51 113.01 33.36"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="113.01 64.22 113.01 33.36 108.11 64.22 113.01 64.22"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="113.01 95.08 113.01 64.22 108.28 94.01 113.01 95.08"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="113.01 125.93 113.01 95.08 107.93 123.64 113.01 125.93"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <polyline
                        points="2.5 125.93 7.58 123.64 37.85 110.02"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="2.5 95.08 7.23 94.01 37.85 87.12"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="2.5 64.22 7.4 64.22 37.85 64.22"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="2.5 33.36 2.51 33.36 7.59 34.5 37.85 41.32"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="57.76 27.38 57.76 101.06 37.85 110.02 37.85 18.41 57.76 27.38"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="2.5 2.5 2.51 2.5 37.85 18.41"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <polygon
                    points="2.51 33.36 2.51 2.5 7.59 34.51 2.51 33.36"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="2.5 64.22 2.5 33.36 7.4 64.22 2.5 64.22"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="2.5 95.08 2.5 64.22 7.23 94.01 2.5 95.08"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="2.5 125.93 2.5 95.08 7.58 123.64 2.5 125.93"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="outside-corner" viewBox="0 0 122.54 128.42">
                <polygon
                    points="61.27 2.5 61.27 125.92 41.36 116.96 41.36 11.46 61.27 2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="81.18 11.46 81.18 116.96 61.27 125.92 61.27 2.5 81.18 11.46"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="41.36 11.46 41.36 37.84 6.02 45.8 2.5 45.8 6.02 27.38 41.36 11.46"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="41.36 37.84 41.36 64.22 2.5 64.22 6.02 45.8 41.36 37.84"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="41.36 64.22 41.36 90.58 6.02 82.62 2.5 82.62 6.02 64.22 41.36 64.22"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="41.36 90.58 41.36 116.96 2.5 101.04 6.02 82.62 41.36 90.58"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="120.04 45.8 116.52 45.8 81.18 37.84 81.18 11.46 116.52 27.38 120.04 45.8"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="120.04 64.22 81.18 64.22 81.18 37.84 116.52 45.8 120.04 64.22"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="120.04 82.62 116.52 82.62 81.18 90.58 81.18 64.22 116.52 64.22 120.04 82.62"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="120.04 101.04 81.18 116.96 81.18 90.58 116.52 82.62 120.04 101.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="service-doors" viewBox="0 0 101.85 143.62">
                <rect
                    x="-12.67"
                    y="33.74"
                    width="127.18"
                    height="87.57"
                    transform="translate(128.45 26.6) rotate(90)"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="19.58"
                    y="25.99"
                    width="62.69"
                    height="115.13"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="2.5"
                    y="2.5"
                    width="96.85"
                    height="11.44"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <circle
                    cx="32.35"
                    cy="83.55"
                    r="4.15"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="37.43"
                    y="32.13"
                    width="26.99"
                    height="38.69"
                    transform="translate(102.4 0.55) rotate(90)"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="50.92"
                    y1="37.99"
                    x2="50.92"
                    y2="64.97"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="31.58"
                    y1="51.48"
                    x2="70.27"
                    y2="51.48"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="service-doors-casing" viewBox="0 0 101.85 143.62">
                <rect
                    x="-12.67"
                    y="33.74"
                    width="127.18"
                    height="87.57"
                    transform="translate(128.45 26.6) rotate(90)"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="19.58"
                    y="25.99"
                    width="62.69"
                    height="115.13"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="2.5"
                    y="2.5"
                    width="96.85"
                    height="11.44"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="siding-shutters" viewBox="0 0 153.75 108.04">
                <rect
                    x="2.5"
                    y="2.5"
                    width="37.19"
                    height="103.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="114.07"
                    y="2.5"
                    width="37.19"
                    height="103.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="91.14"
                    y="45.43"
                    width="83.04"
                    height="17.19"
                    transform="translate(186.68 -78.64) rotate(90)"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="39.69"
                    y="2.5"
                    width="74.37"
                    height="103.04"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="35.36"
                    y="26.84"
                    width="83.04"
                    height="54.37"
                    transform="translate(130.9 -22.86) rotate(90)"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="49.69"
                    y1="54.02"
                    x2="104.06"
                    y2="54.02"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="76.88"
                    y1="95.54"
                    x2="76.88"
                    y2="12.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="124.06"
                    y1="12.5"
                    x2="141.25"
                    y2="12.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="124.06"
                    y1="21.73"
                    x2="141.25"
                    y2="21.73"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="124.06"
                    y1="30.96"
                    x2="141.25"
                    y2="30.96"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="124.06"
                    y1="40.18"
                    x2="141.25"
                    y2="40.18"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="124.06"
                    y1="49.41"
                    x2="141.25"
                    y2="49.41"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="124.06"
                    y1="58.64"
                    x2="141.25"
                    y2="58.64"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="124.06"
                    y1="67.86"
                    x2="141.25"
                    y2="67.86"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="124.06"
                    y1="77.09"
                    x2="141.25"
                    y2="77.09"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="124.06"
                    y1="86.31"
                    x2="141.25"
                    y2="86.31"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="124.06"
                    y1="95.54"
                    x2="141.25"
                    y2="95.54"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="2.5"
                    y="12.53"
                    width="37.19"
                    height="10"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="2.5"
                    y="85.54"
                    width="37.19"
                    height="10"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="105.54"
                    x2="2.5"
                    y2="95.54"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="12.53"
                    x2="2.5"
                    y2="2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="85.54"
                    x2="2.5"
                    y2="22.53"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="14.9"
                    y1="105.54"
                    x2="14.9"
                    y2="95.54"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="14.9"
                    y1="12.53"
                    x2="14.9"
                    y2="2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="14.9"
                    y1="85.54"
                    x2="14.9"
                    y2="22.53"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="27.3"
                    y1="105.54"
                    x2="27.3"
                    y2="95.54"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="27.3"
                    y1="12.53"
                    x2="27.3"
                    y2="2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="27.3"
                    y1="85.54"
                    x2="27.3"
                    y2="22.53"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="39.69"
                    y1="105.54"
                    x2="39.69"
                    y2="95.54"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="39.69"
                    y1="12.53"
                    x2="39.69"
                    y2="2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="39.69"
                    y1="85.54"
                    x2="39.69"
                    y2="22.53"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="siding-trim" viewBox="0 0 132.24 126.96">
                <path
                    d="M16.07,16.07V110.9h100.1V16.07Zm45.1,84.83H26V26.06H61.17Zm45.12,0H71.06V26.06h35.23Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="25.95"
                    y1="63.48"
                    x2="61.17"
                    y2="63.48"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="71.06"
                    y1="63.48"
                    x2="106.28"
                    y2="63.48"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M2.5,2.5v122H129.74V2.5ZM116.17,110.9H16.07V16.07h100.1Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="16.07"
                    y="16.07"
                    width="100.1"
                    height="94.83"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <path
                        d="M2.5,2.5v122H129.74V2.5ZM116.17,110.9H16.07V16.07h100.1Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M129.74,119.93l-4.52,4.53m4.52-19.53L110.2,124.46m-1.44-13.56L95.2,124.46m34.54-34.55-13.57,13.57M93.74,110.9,80.18,124.46m49.56-49.55L116.17,88.48M78.74,110.9,65.18,124.46M129.74,59.9,116.17,73.47M63.74,110.9,50.18,124.46m79.56-79.57L116.17,58.46M48.72,110.9,35.16,124.46m94.58-94.58L116.17,43.45M33.72,110.9,20.16,124.46M129.74,14.87,116.17,28.44M18.7,110.9,5.14,124.46m122-122L113.54,16.07M112.09,2.5,98.52,16.07M16.07,98.53,2.5,112.1M16.07,83.51,2.5,97.08M97.09,2.5,83.52,16.07M16.07,68.51,2.5,82.08M82.07,2.5,68.5,16.07M16.07,53.49,2.5,67.06M67.07,2.5,53.5,16.07M16.07,38.49,2.5,52.06M52.06,2.5,38.49,16.07M16.07,23.49,2.5,37.06M37.05,2.5,23.48,16.07M22.05,2.5,2.5,22M7,2.5,2.5,7"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
            </symbol>
            <symbol id="window-casing" viewBox="0 0 132.23 140.55">
                <rect
                    x="2.5"
                    y="127.62"
                    width="127.23"
                    height="10.43"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="2.5"
                    y="2.5"
                    width="127.23"
                    height="10.43"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="12.93"
                    x2="10.77"
                    y2="22.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="129.73"
                    y1="12.93"
                    x2="121.46"
                    y2="22.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M10.77,22.78V127.62H121.46V22.78Zm10.93,93.8V33.83h39v82.75Zm88.83,0h-39V33.83h39Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="gable-accent" viewBox="0 0 161.74 103.04">
                <polygon
                    points="55.66 53.26 75.87 27.98 75.87 80.54 33.86 80.54 49.38 61.12 55.66 53.26"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="127.88 80.54 85.87 80.54 85.87 27.98 106.08 53.26 112.36 61.12 127.88 80.54"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="143.87 100.54 17.87 100.54 25.86 90.54 135.88 90.54 143.87 100.54"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="159.24 100.54 143.87 100.54 135.88 90.54 127.88 80.54 112.36 61.12 106.08 53.26 85.87 27.98 80.87 21.73 75.87 27.98 55.66 53.26 49.38 61.12 33.86 80.54 25.86 90.54 17.87 100.54 2.5 100.54 10.49 90.54 18.49 80.54 40.84 52.58 47.12 44.72 80.87 2.5 114.62 44.72 120.9 52.58 143.25 80.54 151.25 90.54 159.24 100.54"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="55.66 53.26 75.87 27.98 75.87 80.54 33.86 80.54 49.38 61.12 55.66 53.26"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="127.88 80.54 85.87 80.54 85.87 27.98 106.08 53.26 112.36 61.12 127.88 80.54"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="85.87 27.98 85.87 80.54 75.87 80.54 75.87 27.98 80.87 21.73 85.87 27.98"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="135.88 90.54 25.86 90.54 33.86 80.54 127.88 80.54 135.88 90.54"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="112.36 61.12 92.94 80.54 85.87 80.54 85.87 73.47 106.08 53.26 112.36 61.12"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="75.87 73.47 75.87 80.54 68.8 80.54 49.38 61.12 55.66 53.26 75.87 73.47"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="gable-vents" viewBox="0 0 161.74 103.04">
                <polygon
                    points="143.87 100.53 17.87 100.53 80.87 21.73 143.87 100.53"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="159.24 100.53 2.5 100.53 80.87 2.5 159.24 100.53"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <circle
                        cx="80.87"
                        cy="71.47"
                        r="20"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="96.88"
                        y1="83.46"
                        x2="64.86"
                        y2="83.46"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="100.48"
                        y1="75.46"
                        x2="61.26"
                        y2="75.46"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="100.46"
                        y1="67.47"
                        x2="61.28"
                        y2="67.47"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="96.86"
                        y1="59.47"
                        x2="64.88"
                        y2="59.47"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
            </symbol>
            <symbol id="garage-door" viewBox="0 0 156.95 120.95">
                <rect
                    x="8.79"
                    y="10.41"
                    width="139.37"
                    height="108.03"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="26.73"
                    y1="22.78"
                    x2="8.79"
                    y2="22.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="130.23"
                    y1="22.78"
                    x2="148.16"
                    y2="22.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="20.96"
                    y="22.78"
                    width="115.04"
                    height="95.67"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="20.96"
                    y1="54.67"
                    x2="136"
                    y2="54.67"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="20.96"
                    y1="86.56"
                    x2="136"
                    y2="86.56"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="2.5"
                    y="2.5"
                    width="151.95"
                    height="7.91"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="garage-door-casing" viewBox="0 0 156.95 120.95">
                <rect
                    x="8.79"
                    y="10.41"
                    width="139.37"
                    height="108.03"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="26.73"
                    y1="22.78"
                    x2="8.79"
                    y2="22.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="130.23"
                    y1="22.78"
                    x2="148.16"
                    y2="22.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="20.96"
                    y="22.78"
                    width="115.04"
                    height="95.67"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="2.5"
                    y="2.5"
                    width="151.95"
                    height="7.91"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="garage-door-jamb" viewBox="0 0 118.25 141.96">
                <polygon
                    points="108.23 35.27 108.23 139.46 91.48 139.46 91.48 50.06 108.23 35.27"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="108.23 35.27 91.48 50.06 2.5 31.52 2.5 10.52 108.23 35.27"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="2.5 42.3 82.26 57.27 82.26 139.46 2.5 139.46 2.5 42.3"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="91.48 50.06 2.5 31.52 2.5 31.51 91.48 50.06"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line x1="2.5" y1="31.51" x2="91.48" y2="50.06" style="fill: none; stroke-miterlimit: 10" />
                <polygon
                    points="91.48 50.06 91.48 139.46 82.26 139.46 82.26 57.27 2.5 42.3 2.5 31.52 91.48 50.06"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="82.26"
                    y1="93.8"
                    x2="2.5"
                    y2="85.49"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line x1="82.26" y1="139.46" x2="2.5" y2="139.46" style="fill: none; stroke-miterlimit: 10" />
                <polygon
                    points="115.75 29.02 115.75 139.46 108.23 139.46 108.23 35.27 2.5 10.52 2.5 2.5 108.23 27.26 115.75 29.02"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="108.23"
                    y1="35.27"
                    x2="115.75"
                    y2="29.02"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <polygon
                        points="91.48 50.06 91.48 139.46 82.26 139.46 82.26 57.27 2.5 42.3 2.5 31.52 91.48 50.06"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M14.9,34.09,6,43m16.89-7.2-8.73,8.73M6.88,32.42,2.51,36.79m28.43.65L22.35,46M39,39.11l-8.45,8.45M47,40.78l-8.31,8.31M55,42.45l-8.17,8.17M63,44.13l-8,8M71,45.8l-7.88,7.88m15.9-6.21-7.75,7.75m15.77-6.08-7.61,7.61m12-2.32-9.23,9.23m9.23.46-9.23,9.23m9.23.46L82.26,83m9.23.46-9.23,9.23m9.23.46-9.23,9.23m9.23.47-9.23,9.23m9.23.46-9.23,9.23m9.23.46-9.23,9.23m9.23.46-7.5,7.5"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
            </symbol>
            <symbol id="garage-door-opener" viewBox="0 0 156.95 120.95">
                <polygon
                    points="148.16 118.45 148.16 10.41 8.79 10.41 8.79 118.45 20.96 118.45 20.96 22.78 136 22.78 136 118.45 148.16 118.45"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="26.73"
                    y1="22.78"
                    x2="8.79"
                    y2="22.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="130.23"
                    y1="22.78"
                    x2="148.16"
                    y2="22.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="20.96"
                    y1="40.54"
                    x2="136"
                    y2="40.54"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="20.96"
                    y1="72.43"
                    x2="136"
                    y2="72.43"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="2.5"
                    y="2.5"
                    width="151.95"
                    height="7.91"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="78.48"
                    y1="118.45"
                    x2="78.48"
                    y2="86.4"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="66.92 97.97 78.48 86.4 90.04 97.97"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="house-wrap" viewBox="0 0 151.36 147.06">
                <polygon
                    points="148.86 67.53 133.09 67.53 133.09 144.56 18.28 144.56 18.28 67.53 2.5 67.53 18.28 53.51 39.09 35.02 40.38 33.87 75.69 2.5 110.99 33.87 112.27 35.01 112.28 35.02 133.09 53.51 148.86 67.53"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="18.28"
                    y="89.21"
                    width="20.81"
                    height="55.35"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="39.09"
                    y="89.22"
                    width="36.59"
                    height="55.34"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="75.68"
                    y="89.22"
                    width="36.59"
                    height="55.34"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="112.27"
                    y="89.21"
                    width="20.82"
                    height="55.35"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="39.09 35.02 39.09 89.21 18.28 89.21 18.28 67.53 2.5 67.53 18.28 53.51 39.09 35.02"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="75.69 33.87 75.69 89.21 39.09 89.21 39.09 35.02 40.38 33.87 75.69 33.87"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="112.27 35.01 112.27 89.21 75.69 89.21 75.69 33.87 110.99 33.87 112.27 35.01"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="148.86 67.53 133.09 67.53 133.09 89.21 112.27 89.21 112.27 35.01 112.28 35.02 133.09 53.51 148.86 67.53"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="75.69 2.5 75.69 33.87 40.38 33.87 75.69 2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="110.99 33.87 75.69 33.87 75.69 2.5 110.99 33.87"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="85.79"
                    y1="100.08"
                    x2="100.88"
                    y2="100.08"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="85.79"
                    y1="108.03"
                    x2="100.88"
                    y2="108.03"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="85.79"
                    y1="47.19"
                    x2="100.88"
                    y2="47.19"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="85.79"
                    y1="55.14"
                    x2="100.88"
                    y2="55.14"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="49.84"
                    y1="100.08"
                    x2="64.94"
                    y2="100.08"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="49.84"
                    y1="108.03"
                    x2="64.94"
                    y2="108.03"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="49.84"
                    y1="47.19"
                    x2="64.94"
                    y2="47.19"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="49.84"
                    y1="55.14"
                    x2="64.94"
                    y2="55.14"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="28.98"
                    y1="100.08"
                    x2="18.28"
                    y2="100.08"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="28.98"
                    y1="108.03"
                    x2="18.28"
                    y2="108.03"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="28.98"
                    y1="47.19"
                    x2="25.39"
                    y2="47.19"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="28.98"
                    y1="55.14"
                    x2="16.44"
                    y2="55.14"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="133.09"
                    y1="100.08"
                    x2="121.74"
                    y2="100.08"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="133.09"
                    y1="108.03"
                    x2="121.74"
                    y2="108.03"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="125.98"
                    y1="47.19"
                    x2="121.74"
                    y2="47.19"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="134.92"
                    y1="55.14"
                    x2="121.74"
                    y2="55.14"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="92.85"
                    y="69.79"
                    width="19.42"
                    height="19.42"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="112.27"
                    y1="69.79"
                    x2="92.85"
                    y2="89.21"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="wall-flashing" viewBox="0 0 111.68 141.85">
                <polygon
                    points="15.26 63.97 2.5 63.97 2.5 22.31 15.26 63.97"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="15.26 107.56 15.26 107.57 2.5 105.62 2.5 63.97 15.24 107.52 15.26 107.56"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="15.24"
                    y1="107.52"
                    x2="2.5"
                    y2="105.62"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="20.7 108.39 20.7 139.35 2.5 139.35 2.5 105.62 15.26 107.56 15.27 107.56 20.7 108.39"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="99.94 31.31 92.01 34.37 91.11 34.72 15.26 63.97 2.5 22.31 91.11 2.5 99.94 31.31"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="99.94 61.48 91.11 66.29 15.33 107.53 15.24 107.52 2.5 63.97 15.26 63.97 91.11 34.72 92.01 34.37 99.93 61.45 99.94 61.48"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="103.7 72.46 103.7 83.47 20.7 139.35 20.7 108.39 15.27 107.56 15.33 107.53 28.62 109.51 28.62 118.57 91.11 80.19 103.7 72.46"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="109.18 62.83 109.18 69.09 103.7 72.46 91.11 80.19 28.62 118.57 28.62 109.51 91.11 73.3 103.7 66.01 109.18 62.83"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="15.27"
                    y1="107.56"
                    x2="15.26"
                    y2="107.57"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="109.18 62.83 103.7 66.01 91.11 73.3 28.62 109.51 15.33 107.53 91.11 66.29 99.94 61.48 99.93 61.45 109.18 62.83"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
        </g>

        <!-- Trim estimate icons -->
        <g>
            <symbol id="fascia-frieze" viewBox="0 0 170.61 94.12">
                <g>
                    <path
                        d="M122.68,29.24s53.65,14.18,32.64,58.26"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="122.68"
                        y1="29.24"
                        x2="134.17"
                        y2="23.82"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="122.68"
                        y1="29.24"
                        x2="128.65"
                        y2="40.39"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <path
                        d="M14,62.86S-4.59,72,6.35,86.58"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="14"
                        y1="62.86"
                        x2="2.5"
                        y2="62.13"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="14"
                        y1="62.86"
                        x2="12.7"
                        y2="74.24"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <polygon
                    points="168.11 2.5 168.11 23.85 150.08 26.48 150.08 67.76 86.59 44.75 86.59 14.39 168.11 2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="86.59 26.66 86.59 44.75 22.08 68.61 22.08 50.52 86.59 26.66"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="150.08 67.76 85.57 91.62 22.08 68.61 86.59 44.75 150.08 67.76"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M86.59,14.39V26.66L75.66,24.12a11.33,11.33,0,0,1-2.18-4.88,10.72,10.72,0,0,1-.18-1.93,11.35,11.35,0,0,0-2.89-7.26Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="86.59 26.66 22.08 50.52 11.14 47.97 22.08 43.93 75.66 24.12 86.59 26.66"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M75.66,24.12,22.08,43.93,11.14,48a11.29,11.29,0,0,1-2.36-6.81A11.36,11.36,0,0,0,5.9,33.91L70.41,10.05a11.35,11.35,0,0,1,2.89,7.26,10.72,10.72,0,0,0,.18,1.93A11.33,11.33,0,0,0,75.66,24.12Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <line
                        x1="22.08"
                        y1="68.61"
                        x2="85.57"
                        y2="91.62"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="38.21"
                        y1="62.64"
                        x2="101.7"
                        y2="85.65"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="54.33"
                        y1="56.68"
                        x2="117.82"
                        y2="79.69"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="70.46"
                        y1="50.71"
                        x2="133.95"
                        y2="73.73"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="86.59"
                        y1="44.75"
                        x2="150.08"
                        y2="67.76"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
            </symbol>
            <symbol id="soffit" viewBox="0 0 167.21 110.25">
                <polygon
                    points="164.71 2.5 164.71 23.85 146.68 26.48 146.68 67.76 83.19 44.75 83.19 14.39 164.71 2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="83.19 26.66 83.19 44.75 18.68 68.61 18.68 50.52 83.19 26.66"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="146.68 67.76 82.17 91.62 18.68 68.61 83.19 44.75 146.68 67.76"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M83.19,14.39V26.66L72.26,24.12a11.33,11.33,0,0,1-2.18-4.88,10.72,10.72,0,0,1-.18-1.93A11.35,11.35,0,0,0,67,10.05Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="83.19 26.66 18.68 50.52 7.74 47.97 18.68 43.93 72.26 24.12 83.19 26.66"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M72.26,24.12,18.68,43.93,7.74,48a11.29,11.29,0,0,1-2.36-6.81A11.36,11.36,0,0,0,2.5,33.91L67,10.05a11.35,11.35,0,0,1,2.89,7.26,10.72,10.72,0,0,0,.18,1.93A11.33,11.33,0,0,0,72.26,24.12Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <line
                        x1="18.68"
                        y1="68.61"
                        x2="82.17"
                        y2="91.62"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="63.19"
                        y1="72.93"
                        x2="34.81"
                        y2="62.64"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="114.43"
                        y1="79.69"
                        x2="96.83"
                        y2="73.31"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="72.45"
                        y1="64.47"
                        x2="50.94"
                        y2="56.68"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="67.06"
                        y1="50.71"
                        x2="130.55"
                        y2="73.73"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="83.19"
                        y1="44.75"
                        x2="146.68"
                        y2="67.76"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <line
                    x1="82.17"
                    y1="107.75"
                    x2="82.17"
                    y2="69.9"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="91.07 78.8 82.17 69.9 73.27 78.8"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
        </g>

        <!-- Insulation estimate icons -->
        <g>
            <symbol id="energy-assessments" viewBox="0 0 167.43 147.06">
                <polyline
                    points="133.09 128.76 133.09 144.56 18.29 144.56 18.29 67.53 2.5 67.53 18.29 53.51 39.1 35.01 40.39 33.87 75.69 2.5 110.99 33.87 112.27 35.01 112.28 35.01 133.09 53.51 148.87 67.53 133.09 67.53 133.09 87.37"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <path
                        d="M81.05,78.3c-4.18-4.71-.24-8.21-4.43-12.92s-8.12-1.2-12.3-5.91-.24-8.21-4.43-12.92-8.13-1.21-12.31-5.92"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon points="85.19 71.7 88.2 86.35 74 81.63 85.19 71.7" style="" />
                </g>
                <g>
                    <path
                        d="M97.83,63.39c-4.18-4.71-.24-8.21-4.43-12.92s-8.12-1.2-12.3-5.91-.24-8.21-4.43-12.92-8.13-1.21-12.31-5.92"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon points="101.97 56.79 104.98 71.44 90.78 66.72 101.97 56.79" style="" />
                </g>
                <g>
                    <path
                        d="M64.27,93.21C60.09,88.5,64,85,59.84,80.29s-8.12-1.2-12.3-5.9-.24-8.22-4.43-12.92S35,60.26,30.8,55.55"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon points="68.41 86.61 71.42 101.26 57.23 96.54 68.41 86.61" style="" />
                </g>
                <g>
                    <path
                        d="M130.9,127.12a8.07,8.07,0,0,1-.16,1.64H113.52a8.07,8.07,0,0,1-.16-1.64,8.77,8.77,0,0,1,17.54,0Z"
                        style=""
                    />
                    <line
                        x1="122.13"
                        y1="127.12"
                        x2="137.21"
                        y2="104.26"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M164.93,128.76H79.32a42.81,42.81,0,1,1,85.61,0Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="79.32 128.76 113.52 128.76 130.74 128.76 164.93 128.76"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
            </symbol>
            <symbol id="knee-wall" viewBox="0 0 135.72 156.05">
                <polygon
                    points="133.22 2.5 133.22 27.82 115.52 42.1 101.9 53.09 27.75 112.92 20.5 112.92 20.5 118.77 2.5 118.77 2.5 107.99 133.22 2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="126.41 112.92 126.41 132 34.13 132 34.13 131.79 20.5 131.79 20.5 112.92 101.9 112.92 115.52 112.92 126.41 112.92"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="20.5"
                    y="131.79"
                    width="13.63"
                    height="0.2"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="20.5"
                    y="131.79"
                    width="13.63"
                    height="21.76"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="115.52 42.1 115.52 112.92 101.9 112.92 101.9 53.06 115.52 42.1"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="115.52"
                    y1="52.28"
                    x2="101.89"
                    y2="63.27"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="115.52"
                    y1="62.46"
                    x2="101.89"
                    y2="73.45"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="115.52"
                    y1="72.65"
                    x2="101.89"
                    y2="83.64"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="115.52"
                    y1="82.84"
                    x2="101.89"
                    y2="93.83"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="115.52"
                    y1="93.02"
                    x2="101.89"
                    y2="104.01"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="115.52"
                    y1="103.2"
                    x2="103.46"
                    y2="112.92"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="open-joist" viewBox="0 0 143.46 142.06">
                <polygon
                    points="140.96 114.24 140.96 126.9 8.56 126.9 24.25 114.24 140.96 114.24"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="140.96 20.06 140.96 114.24 128.3 114.24 128.3 30.28 140.96 20.06"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="82.02 76.95 82.02 114.24 69.36 114.24 69.36 77.84 76.86 71.79 82.02 76.95"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="128.3 105.34 128.3 114.24 119.3 114.24 82.02 76.95 76.86 71.79 82.02 67.62 86.76 63.8 128.3 105.34"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="140.96 2.5 140.96 20.06 128.3 30.28 86.76 63.8 82.02 67.62 76.86 71.79 69.36 77.84 24.25 114.24 8.56 126.9 2.5 126.9 2.5 114.24 67.14 62.07 69.36 60.28 77.05 54.08 82.02 50.07 128.3 12.72 140.96 2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="2.5"
                    y="126.9"
                    width="138.46"
                    height="12.66"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="open-wall" viewBox="0 0 123.73 129.37">
                <rect
                    x="2.5"
                    y="2.5"
                    width="9.6"
                    height="124.37"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="57.07"
                    y="2.5"
                    width="9.6"
                    height="124.37"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="20.47 114.43 12.1 126.87 12.1 2.5 20.47 14.94 20.47 114.43"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="111.63"
                    y="2.5"
                    width="9.6"
                    height="124.37"
                    transform="translate(232.86 129.37) rotate(-180)"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="103.25 114.43 111.63 126.87 111.63 2.5 103.25 14.94 103.25 114.43"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="20.47"
                    y1="14.94"
                    x2="57.07"
                    y2="14.94"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="66.66"
                    y1="14.94"
                    x2="103.26"
                    y2="14.94"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="20.47"
                    y1="31.52"
                    x2="57.07"
                    y2="31.52"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="66.66"
                    y1="31.52"
                    x2="103.26"
                    y2="31.52"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="20.47"
                    y1="48.1"
                    x2="57.07"
                    y2="48.1"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="66.66"
                    y1="48.1"
                    x2="103.26"
                    y2="48.1"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="20.47"
                    y1="64.68"
                    x2="57.07"
                    y2="64.68"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="66.66"
                    y1="64.68"
                    x2="103.26"
                    y2="64.68"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="20.47"
                    y1="81.27"
                    x2="57.07"
                    y2="81.27"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="66.66"
                    y1="81.27"
                    x2="103.26"
                    y2="81.27"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="20.47"
                    y1="97.85"
                    x2="57.07"
                    y2="97.85"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="66.66"
                    y1="97.85"
                    x2="103.26"
                    y2="97.85"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="20.47"
                    y1="114.43"
                    x2="57.07"
                    y2="114.43"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="66.66"
                    y1="114.43"
                    x2="103.26"
                    y2="114.43"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="pack-wall-exterior" viewBox="0 0 193.49 144.2">
                <g>
                    <rect
                        x="2.5"
                        y="2.5"
                        width="139.2"
                        height="139.2"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="141.7"
                        y1="2.5"
                        x2="141.7"
                        y2="141.7"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <line
                            x1="108.41"
                            y1="13.05"
                            x2="108.41"
                            y2="13.05"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="120.96"
                            y1="20.36"
                            x2="120.96"
                            y2="20.36"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="112.06"
                            y1="30.6"
                            x2="112.06"
                            y2="30.6"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="119.14"
                            y1="43.34"
                            x2="119.14"
                            y2="43.34"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="108.41"
                            y1="58.17"
                            x2="108.41"
                            y2="58.17"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="122.33"
                            y1="61.93"
                            x2="122.33"
                            y2="61.93"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="120.51"
                            y1="78.22"
                            x2="120.51"
                            y2="78.22"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="111.6"
                            y1="70.49"
                            x2="111.6"
                            y2="70.49"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="108.41"
                            y1="81.98"
                            x2="108.41"
                            y2="81.98"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="122.33"
                            y1="99.32"
                            x2="122.33"
                            y2="99.32"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="124.16"
                            y1="87"
                            x2="124.16"
                            y2="87"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="108.41"
                            y1="101.83"
                            x2="108.41"
                            y2="101.83"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="112.06"
                            y1="116.24"
                            x2="112.06"
                            y2="116.24"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="124.16"
                            y1="120"
                            x2="124.16"
                            y2="120"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="112.29"
                            y1="130.94"
                            x2="112.29"
                            y2="130.94"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                    <rect
                        x="2.5"
                        y="2.5"
                        width="8.94"
                        height="139.2"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <rect
                        x="45.92"
                        y="2.5"
                        width="8.94"
                        height="139.2"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <rect
                        x="89.35"
                        y="2.5"
                        width="8.94"
                        height="139.2"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <rect
                        x="132.77"
                        y="2.5"
                        width="8.94"
                        height="139.2"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <line
                            x1="64.96"
                            y1="11.47"
                            x2="64.96"
                            y2="11.47"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="77.88"
                            y1="19.64"
                            x2="77.88"
                            y2="19.64"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="66.54"
                            y1="33.09"
                            x2="66.54"
                            y2="33.09"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="77.88"
                            y1="47.86"
                            x2="77.88"
                            y2="47.86"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="70.08"
                            y1="64.92"
                            x2="70.08"
                            y2="64.92"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="64.96"
                            y1="54.72"
                            x2="64.96"
                            y2="54.72"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="81.31"
                            y1="61.57"
                            x2="81.31"
                            y2="61.57"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="76.83"
                            y1="77.66"
                            x2="76.83"
                            y2="77.66"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="67.07"
                            y1="77.66"
                            x2="67.07"
                            y2="77.66"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="67.59"
                            y1="95.34"
                            x2="67.59"
                            y2="95.34"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="77.09"
                            y1="91.64"
                            x2="77.09"
                            y2="91.64"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="79.73"
                            y1="107.47"
                            x2="79.73"
                            y2="107.47"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="66.54"
                            y1="108.52"
                            x2="66.54"
                            y2="108.52"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="68.65"
                            y1="123.29"
                            x2="68.65"
                            y2="123.29"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="78.94"
                            y1="130.94"
                            x2="78.94"
                            y2="130.94"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                    <g>
                        <line
                            x1="22.5"
                            y1="17.83"
                            x2="22.5"
                            y2="17.83"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="35.42"
                            y1="11.47"
                            x2="35.42"
                            y2="11.47"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="37.26"
                            y1="25.18"
                            x2="37.26"
                            y2="25.18"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="22.5"
                            y1="29.66"
                            x2="22.5"
                            y2="29.66"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="24.61"
                            y1="41.53"
                            x2="24.61"
                            y2="41.53"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="34.89"
                            y1="36.39"
                            x2="34.89"
                            y2="36.39"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="36.21"
                            y1="55.77"
                            x2="36.21"
                            y2="55.77"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="22.5"
                            y1="62.47"
                            x2="22.5"
                            y2="62.47"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="25.66"
                            y1="53.66"
                            x2="25.66"
                            y2="53.66"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="33.31"
                            y1="78.72"
                            x2="33.31"
                            y2="78.72"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="22.5"
                            y1="74.24"
                            x2="22.5"
                            y2="74.24"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="25.23 89.18 25.92 92.96 28.98 95.14"
                            style="
                                fill: none;
                                stroke-linecap: round;
                                stroke-linejoin: round;
                                stroke-width: 5px;
                                stroke-dasharray: 0, 15.19014835357666;
                            "
                        />
                        <line
                            x1="35.16"
                            y1="99.55"
                            x2="35.16"
                            y2="99.55"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="22.5"
                            y1="112.01"
                            x2="22.5"
                            y2="112.01"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="35.16"
                            y1="131"
                            x2="35.16"
                            y2="131"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="37.26"
                            y1="116.43"
                            x2="37.26"
                            y2="116.43"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="22.5"
                            y1="126.72"
                            x2="22.5"
                            y2="126.72"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                </g>
                <g>
                    <polygon
                        points="169.98 141.71 113.43 141.71 113.43 103.78 141.71 75.88 169.98 103.78 169.98 141.71"
                        style="fill: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="154.61"
                        y1="116.55"
                        x2="190.99"
                        y2="116.55"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="181.09 106.64 190.99 116.55 181.09 126.45"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
            </symbol>
            <symbol id="pack-wall-interior" viewBox="0 0 172.48 144.2">
                <g>
                    <rect
                        x="2.5"
                        y="2.5"
                        width="139.2"
                        height="139.2"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="141.7"
                        y1="2.5"
                        x2="141.7"
                        y2="141.7"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <line
                            x1="108.41"
                            y1="13.05"
                            x2="108.41"
                            y2="13.05"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="120.96"
                            y1="20.36"
                            x2="120.96"
                            y2="20.36"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="112.06"
                            y1="30.6"
                            x2="112.06"
                            y2="30.6"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="119.14"
                            y1="43.34"
                            x2="119.14"
                            y2="43.34"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="108.41"
                            y1="58.17"
                            x2="108.41"
                            y2="58.17"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="122.33"
                            y1="61.93"
                            x2="122.33"
                            y2="61.93"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="120.51"
                            y1="78.22"
                            x2="120.51"
                            y2="78.22"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="111.6"
                            y1="70.49"
                            x2="111.6"
                            y2="70.49"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="108.41"
                            y1="81.98"
                            x2="108.41"
                            y2="81.98"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="122.33"
                            y1="99.32"
                            x2="122.33"
                            y2="99.32"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="124.16"
                            y1="87"
                            x2="124.16"
                            y2="87"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="108.41"
                            y1="101.83"
                            x2="108.41"
                            y2="101.83"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="112.06"
                            y1="116.24"
                            x2="112.06"
                            y2="116.24"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="124.16"
                            y1="120"
                            x2="124.16"
                            y2="120"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="112.29"
                            y1="130.94"
                            x2="112.29"
                            y2="130.94"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                    <rect
                        x="2.5"
                        y="2.5"
                        width="8.94"
                        height="139.2"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <rect
                        x="45.92"
                        y="2.5"
                        width="8.94"
                        height="139.2"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <rect
                        x="89.35"
                        y="2.5"
                        width="8.94"
                        height="139.2"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <rect
                        x="132.77"
                        y="2.5"
                        width="8.94"
                        height="139.2"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <line
                            x1="64.96"
                            y1="11.47"
                            x2="64.96"
                            y2="11.47"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="77.88"
                            y1="19.64"
                            x2="77.88"
                            y2="19.64"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="66.54"
                            y1="33.09"
                            x2="66.54"
                            y2="33.09"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="77.88"
                            y1="47.86"
                            x2="77.88"
                            y2="47.86"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="70.08"
                            y1="64.92"
                            x2="70.08"
                            y2="64.92"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="64.96"
                            y1="54.72"
                            x2="64.96"
                            y2="54.72"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="81.31"
                            y1="61.57"
                            x2="81.31"
                            y2="61.57"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="76.83"
                            y1="77.66"
                            x2="76.83"
                            y2="77.66"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="67.07"
                            y1="77.66"
                            x2="67.07"
                            y2="77.66"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="67.59"
                            y1="95.34"
                            x2="67.59"
                            y2="95.34"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="77.09"
                            y1="91.64"
                            x2="77.09"
                            y2="91.64"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="79.73"
                            y1="107.47"
                            x2="79.73"
                            y2="107.47"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="66.54"
                            y1="108.52"
                            x2="66.54"
                            y2="108.52"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="68.65"
                            y1="123.29"
                            x2="68.65"
                            y2="123.29"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="78.94"
                            y1="130.94"
                            x2="78.94"
                            y2="130.94"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                    <g>
                        <line
                            x1="22.5"
                            y1="17.83"
                            x2="22.5"
                            y2="17.83"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="35.42"
                            y1="11.47"
                            x2="35.42"
                            y2="11.47"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="37.26"
                            y1="25.18"
                            x2="37.26"
                            y2="25.18"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="22.5"
                            y1="29.66"
                            x2="22.5"
                            y2="29.66"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="24.61"
                            y1="41.53"
                            x2="24.61"
                            y2="41.53"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="34.89"
                            y1="36.39"
                            x2="34.89"
                            y2="36.39"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="36.21"
                            y1="55.77"
                            x2="36.21"
                            y2="55.77"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="22.5"
                            y1="62.47"
                            x2="22.5"
                            y2="62.47"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="25.66"
                            y1="53.66"
                            x2="25.66"
                            y2="53.66"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="33.31"
                            y1="78.72"
                            x2="33.31"
                            y2="78.72"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="22.5"
                            y1="74.24"
                            x2="22.5"
                            y2="74.24"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="25.23 89.18 25.92 92.96 28.98 95.14"
                            style="
                                fill: none;
                                stroke-linecap: round;
                                stroke-linejoin: round;
                                stroke-width: 5px;
                                stroke-dasharray: 0, 15.19014835357666;
                            "
                        />
                        <line
                            x1="35.16"
                            y1="99.55"
                            x2="35.16"
                            y2="99.55"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="22.5"
                            y1="112.01"
                            x2="22.5"
                            y2="112.01"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="35.16"
                            y1="131"
                            x2="35.16"
                            y2="131"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="37.26"
                            y1="116.43"
                            x2="37.26"
                            y2="116.43"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="22.5"
                            y1="126.72"
                            x2="22.5"
                            y2="126.72"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                </g>
                <g>
                    <polygon
                        points="169.98 141.71 113.43 141.71 113.43 103.78 141.71 75.88 169.98 103.78 169.98 141.71"
                        style="fill: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="169.98"
                        y1="116.55"
                        x2="133.59"
                        y2="116.55"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="143.49 126.45 133.59 116.55 143.49 106.64"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
            </symbol>
            <symbol id="recess-ic-rated" viewBox="0 0 152.3 95.82">
                <path
                    d="M99.54,45.05c0,5.54-13.46,10-30.06,10s-30.07-4.48-30.07-10c0-1.83,1.48-3.55,4.05-5,5.2-3,14.91-5,26-5s20.81,2,26,5C98.07,41.5,99.54,43.22,99.54,45.05Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <ellipse
                    cx="69.48"
                    cy="40.04"
                    rx="26.02"
                    ry="5.01"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="69.48"
                    y1="62.46"
                    x2="69.48"
                    y2="93.32"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="50.42"
                    y1="61.63"
                    x2="41.12"
                    y2="88.14"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="88.54"
                    y1="61.63"
                    x2="97.84"
                    y2="88.14"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="105.91 68.39 33.06 68.39 2.5 21.71 136.47 21.71 105.91 68.39"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <circle
                        cx="128.99"
                        cy="23.3"
                        r="20.8"
                        style="fill: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <path d="M119,15.77h3.66V31.15H119Z" style="" />
                        <path
                            d="M133.84,31.35c-4.24,0-7.92-2.74-7.92-7.84,0-4.4,2.85-8,7.92-8a8,8,0,0,1,6.19,3l-2.65,2.26A4.8,4.8,0,0,0,133.84,19c-2.26,0-4.13,1.66-4.13,4.49a4.12,4.12,0,0,0,4.13,4.38,4.68,4.68,0,0,0,3.54-1.76L140,28.41a7.85,7.85,0,0,1-6.19,2.94Z"
                            style=""
                        />
                    </g>
                </g>
            </symbol>
            <symbol id="recess-not-ic-rated" viewBox="0 0 152.3 95.82">
                <path
                    d="M99.54,45.05c0,5.54-13.46,10-30.06,10s-30.07-4.48-30.07-10c0-1.83,1.48-3.55,4.05-5,5.2-3,14.91-5,26-5s20.81,2,26,5C98.07,41.5,99.54,43.22,99.54,45.05Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <ellipse
                    cx="69.48"
                    cy="40.04"
                    rx="26.02"
                    ry="5.01"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="69.48"
                    y1="62.46"
                    x2="69.48"
                    y2="93.32"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="50.42"
                    y1="61.63"
                    x2="41.12"
                    y2="88.14"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="88.54"
                    y1="61.63"
                    x2="97.84"
                    y2="88.14"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="105.91 68.39 33.06 68.39 2.5 21.71 136.47 21.71 105.91 68.39"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <circle
                    cx="128.99"
                    cy="23.3"
                    r="20.8"
                    style="fill: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="114.29"
                    y1="8.6"
                    x2="143.7"
                    y2="38.01"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px"
                />
                <path
                    d="M133.84,31.85a8,8,0,0,1-8.42-8.34c0-5.06,3.38-8.45,8.42-8.45a8.53,8.53,0,0,1,6.58,3.15l.31.38-3.41,2.91-.32-.39a4.4,4.4,0,0,0-3.16-1.59c-1.81,0-3.63,1.23-3.63,4a3.6,3.6,0,0,0,3.63,3.88A4.17,4.17,0,0,0,137,25.82l.32-.4,3.42,2.92-.31.38a8.37,8.37,0,0,1-6.58,3.13Zm-15.38-.2V15.27h4.66V31.65Z"
                    style=""
                />
            </symbol>
            <symbol id="top-plates" viewBox="0 0 115.01 100.32">
                <rect
                    x="50.27"
                    y="29.96"
                    width="14.46"
                    height="67.86"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="25.38"
                    y="16.23"
                    width="64.25"
                    height="13.73"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="2.5"
                    x2="112.51"
                    y2="2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="112.51"
                    y1="16.23"
                    x2="2.5"
                    y2="16.23"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="38.36"
                    y1="16.23"
                    x2="25.38"
                    y2="29.22"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="51.35"
                    y1="16.23"
                    x2="37.63"
                    y2="29.96"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="64.34"
                    y1="16.23"
                    x2="50.62"
                    y2="29.96"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="77.33"
                    y1="16.23"
                    x2="63.61"
                    y2="29.96"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="89.62"
                    y1="16.93"
                    x2="76.59"
                    y2="29.96"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="air-sealing-package" viewBox="0 0 159.18 130.68">
                <polygon
                    points="17.8 125.78 2.5 113.79 2.5 54.47 17.8 66.47 17.8 125.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="17.8"
                    y1="66.47"
                    x2="79.59"
                    y2="24.81"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="54.47"
                    x2="79.59"
                    y2="2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="79.59"
                    y1="24.81"
                    x2="79.59"
                    y2="2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="141.39 125.78 156.68 113.79 156.68 54.47 141.39 66.47 141.39 125.78"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M137.93,113.87,90.87,82.14a7.83,7.83,0,0,1-3.45-6.49V35a7.83,7.83,0,0,0-7.83-7.82h0A7.82,7.82,0,0,0,71.77,35V75.65a7.84,7.84,0,0,1-3.46,6.49L21.25,113.87a7.83,7.83,0,0,0-2.12,10.86h0A7.84,7.84,0,0,0,30,126.85L75.22,96.36a7.84,7.84,0,0,1,8.75,0l45.21,30.49a7.84,7.84,0,0,0,10.87-2.12h0A7.81,7.81,0,0,0,137.93,113.87Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="141.39"
                    y1="66.47"
                    x2="79.59"
                    y2="24.81"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="156.68"
                    y1="54.47"
                    x2="79.59"
                    y2="2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <path
                        d="M137.55,113.62l-7.83,13.56m1.25-18h0l-7.85,13.58m1.26-18-7.85,13.59m1.26-18L110,113.88m1.26-18-7.85,13.59m1.25-18L96.77,105M98,87l-7.85,13.59m1.26-18L83.58,96.13m3.84-22.49L73.71,97.39m-15,10.1h0L87.42,57.79M61.6,86.66h0L43.75,117.58M87.42,41.94,71.76,69.07M46.61,96.77l-17.73,30.7h0m56.46-97.8L71.76,53.21M31.62,106.88,20.45,126.23m57-98.77-5.72,9.9"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M141.38,120.36a7.82,7.82,0,0,1-11.66,6.82q-.27-.15-.54-.33l-6.06-4.09-6.59-4.44L110,113.88l-6.59-4.44L96.77,105l-6.59-4.44L84,96.37a4.11,4.11,0,0,0-.39-.24,7.78,7.78,0,0,0-8.36.24l-1.51,1-15,10.09h0l-15,10.09L30,126.85a7.22,7.22,0,0,1-1.12.62h0a7.89,7.89,0,0,1-3.25.7,7.8,7.8,0,0,1-5.18-2,7.63,7.63,0,0,1-1.32-1.5,7.82,7.82,0,0,1,2.12-10.86l10.37-7,15-10.11,15-10.1h0l6.71-4.52a7.82,7.82,0,0,0,3.45-6.49V35a7.81,7.81,0,0,1,5.72-7.53,7.73,7.73,0,0,1,2.11-.29A7.82,7.82,0,0,1,87.42,35V75.65a7.82,7.82,0,0,0,3.45,6.49l.57.38L98,87l6.58,4.44,6.6,4.44,6.58,4.44,6.59,4.44,6.59,4.44h0l6.58,4.44.38.25A7.79,7.79,0,0,1,141.38,120.36Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
            </symbol>
            <symbol id="basement-box-still" viewBox="0 0 159.18 135.99">
                <polygon
                    points="67.18 54.72 67.18 110.89 55.56 90.07 38.02 58.67 38.02 2.5 67.18 54.72"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="67.18 110.89 55.56 110.89 26.39 58.67 38.02 58.67 55.56 90.07 67.18 110.89"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="26.4"
                    y="2.5"
                    width="11.63"
                    height="56.17"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="132.79 54.72 132.79 110.89 121.16 90.07 103.63 58.67 103.63 2.5 132.79 54.72"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="132.79 110.89 121.16 110.89 92 58.67 103.63 58.67 121.16 90.07 132.79 110.89"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="92"
                    y="2.5"
                    width="11.63"
                    height="56.17"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M153.51,112.66a14.92,14.92,0,0,1,3.17,9.55,14.35,14.35,0,0,1-1.73,7.28c-2-1.67-3.94-3.34-7.29-3.84a13,13,0,0,0-2.14-.16c-8.92,0-9.39,7.19-17.44,7.93a12.49,12.49,0,0,1-1.4.07c-6.36,0-8.42-3.65-12-6a11.63,11.63,0,0,0-6.84-2c-5.48,0-7.77,2.7-10.57,5h0a12.09,12.09,0,0,1-8.27,3,11.85,11.85,0,0,1-7.93-2.78c-3-2.31-5.23-5.22-10.91-5.22a13.25,13.25,0,0,0-3,.31c-6.59,1.46-7.56,7.69-15.88,7.69a13.21,13.21,0,0,1-3.47-.43c-5.41-1.47-6.93-6.24-12.78-7.34a13.6,13.6,0,0,0-2.58-.23c-8.74,0-9.38,6.88-16.93,7.87a12.88,12.88,0,0,1-1.92.13,11.63,11.63,0,0,1-7-2.12,14.69,14.69,0,0,0,2.9-9.16,14.4,14.4,0,0,0-1.75-7.29c-2.08-3.8-5.27-6-5.27-12.77,0-10,7-10,7-20.07A15.63,15.63,0,0,0,8.75,77C6.93,71.62,2.5,70,2.5,62a14.3,14.3,0,0,1,1.75-7.29H26.4v4l3.69,6.62L39,81.24l8.9,16,7.66,13.7H67.18V54.72H92v4L95,64,103.89,80l8.91,16,8.36,15h11.63V54.72h18.62A14.29,14.29,0,0,0,149.66,62c0,6.49,2.93,8.78,5,12.31a14.25,14.25,0,0,1,2,7.76c0,10-7,10-7,20.07C149.66,107.48,151.65,110,153.51,112.66Z"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <path
                    d="M18.77,54.72,8.75,77m21.34-11.7L7.77,114.92M39,81.24,15.56,133.36M47.9,97.19,35.07,125.72m22.75-14.83-10,22.17M83.08,54.72,67.18,90.08M95,64,67.2,125.8M103.89,80,81.07,130.71m31.73-34.8L97.27,130.45h0M147.4,54.72,132.79,87.21m-10.66,23.68-7.45,16.59m40-53.17-26.59,59.11m25.43-20.76-5.85,13"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="closed-floor" viewBox="0 0 155 121.22">
                <polygon
                    points="152.5 118.72 44.8 118.72 50.35 109.86 55.91 100.99 57.79 97.98 61.46 92.12 66.26 84.46 67.01 83.26 72.57 74.39 78.12 65.53 98.65 32.75 152.5 118.72"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="98.65 32.75 78.12 65.53 72.57 74.39 67.01 83.26 66.26 84.46 61.46 92.12 57.79 97.98 55.91 100.99 50.35 109.86 44.8 118.72 34.68 111.49 2.5 88.47 8.05 79.6 13.61 70.73 19.16 61.87 20.7 59.42 45.14 20.39 56.36 2.5 98.65 32.75"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <g>
                        <polyline
                            points="78.12 65.53 104.6 84.46 142.39 111.49 152.5 118.72"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="72.57 74.39 86.64 84.46 105.55 97.98 124.43 111.49 134.55 118.72"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="67.01 83.26 68.69 84.46 87.6 97.98 106.48 111.49 116.6 118.72"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="61.46 92.12 69.64 97.98 88.54 111.49 98.65 118.72"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="80.7 118.72 70.59 111.49 55.91 100.99"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="62.75 118.72 52.63 111.49 50.35 109.86"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                    <line
                        x1="142.39"
                        y1="111.49"
                        x2="124.43"
                        y2="111.49"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="70.59"
                        y1="111.49"
                        x2="52.64"
                        y2="111.49"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="34.68"
                        y1="111.49"
                        x2="34.51"
                        y2="111.49"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="106.48"
                        y1="111.49"
                        x2="88.54"
                        y2="111.49"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="69.64"
                        y1="97.98"
                        x2="57.79"
                        y2="97.98"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="105.55"
                        y1="97.98"
                        x2="87.6"
                        y2="97.98"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="104.6"
                        y1="84.46"
                        x2="86.64"
                        y2="84.46"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="68.69"
                        y1="84.46"
                        x2="66.26"
                        y2="84.46"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
            </symbol>
            <symbol id="dropped-soffits" viewBox="0 0 179.86 94.95">
                <line
                    x1="40.41"
                    y1="2.5"
                    x2="177.36"
                    y2="2.5"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="72.66"
                    y="2.5"
                    width="77.8"
                    height="41.29"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="2.5"
                    y1="51.16"
                    x2="34.74"
                    y2="51.16"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="34.75"
                    y1="79.75"
                    x2="34.75"
                    y2="51.15"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="102.11"
                    y1="92.45"
                    x2="45.16"
                    y2="92.45"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="72.66 2.5 60.02 18.73 47.38 34.95 34.75 51.16"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <line
                        x1="102.11"
                        y1="92.45"
                        x2="45.16"
                        y2="92.45"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="114.75"
                        y1="76.23"
                        x2="57.8"
                        y2="76.23"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="127.39"
                        y1="60.01"
                        x2="70.44"
                        y2="60.01"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="140.03"
                        y1="43.79"
                        x2="83.08"
                        y2="43.79"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <line
                        x1="34.75"
                        y1="79.75"
                        x2="34.75"
                        y2="51.15"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="47.38"
                        y1="63.54"
                        x2="47.38"
                        y2="34.94"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="60.02"
                        y1="47.31"
                        x2="60.02"
                        y2="18.72"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="72.66"
                        y1="31.09"
                        x2="72.66"
                        y2="2.5"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <polygon
                    points="72.66 31.09 72.66 43.79 60.02 60.01 47.39 76.23 47.38 76.23 34.75 92.44 34.75 79.75 47.38 63.54 60.02 47.31 72.66 31.09"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="83.08 43.79 70.44 60.01 57.8 76.23 45.16 92.45 34.75 92.45 34.75 92.44 47.38 76.23 47.39 76.23 60.02 60.01 72.66 43.79 83.08 43.79"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="150.46 43.79 137.82 60.01 125.18 76.23 112.55 92.45 102.11 92.45 114.75 76.23 127.39 60.01 140.03 43.79 150.46 43.79"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="140.03"
                    y="2.5"
                    width="10.43"
                    height="41.29"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="72.66"
                    y="2.5"
                    width="10.42"
                    height="41.29"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="83.08"
                    y="34.94"
                    width="56.95"
                    height="8.85"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="144.72"
                    y1="51.16"
                    x2="161.01"
                    y2="51.16"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
            <symbol id="attic-access" viewBox="0 0 161.73 130.37">
                <g>
                    <polyline
                        points="97.34 100.54 143.86 100.54 80.87 21.73 17.87 100.54 64.39 100.54"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="64.39 100.54 17.87 100.54 2.5 100.54 80.87 2.5 159.23 100.54 143.86 100.54 97.34 100.54"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <line
                    x1="149.96"
                    y1="100.54"
                    x2="149.96"
                    y2="127.87"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="136.83"
                    y1="100.54"
                    x2="136.83"
                    y2="127.87"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="80.87"
                    y1="127.87"
                    x2="80.87"
                    y2="64.97"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polyline
                    points="66.14 83.38 80.87 64.97 95.59 83.38"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="11.78"
                    y1="100.54"
                    x2="11.78"
                    y2="127.87"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <line
                    x1="24.9"
                    y1="100.54"
                    x2="24.9"
                    y2="127.87"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
            </symbol>
        </g>

        <!-- Repair estimate icons -->
        <g>
            <symbol id="replace-butterfly-valley" viewBox="0 0 168.78 122.52">
                <polygon
                    points="92.8 105.62 37.8 105.62 37.8 2.5 92.8 32.73 92.8 105.62"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="166.28 105.62 111.28 105.62 111.28 32.73 166.28 2.5 166.28 105.62"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <rect
                    x="92.8"
                    y="44.43"
                    width="18.48"
                    height="61.19"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="111.28 28.35 111.28 32.73 129.64 22.64 111.28 28.35"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="129.56 18.31 129.56 22.69 147.92 12.59 129.56 18.31"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="147.92 8.21 147.92 12.59 166.28 2.5 147.92 8.21"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="92.8 28.35 92.8 32.73 74.44 22.64 92.8 28.35"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="74.53 18.31 74.53 22.69 56.17 12.59 74.53 18.31"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <polygon
                    points="56.17 8.21 56.17 12.59 37.8 2.5 56.17 8.21"
                    style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                />
                <g>
                    <circle
                        cx="37.8"
                        cy="84.71"
                        r="35.3"
                        style="fill: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <line
                            x1="21.58"
                            y1="95.16"
                            x2="54.02"
                            y2="95.16"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="44.65 85.79 54.02 95.16 44.65 104.54"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="54.02"
                            y1="74.26"
                            x2="21.58"
                            y2="74.26"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="30.96 83.64 21.58 74.26 30.96 64.89"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                </g>
            </symbol>
            <symbol id="replace-dormer" viewBox="0 0 169.32 146.61">
                <g>
                    <polygon
                        points="113.04 55.38 110.64 59.3 89.47 93.89 80.01 88.47 75.73 86.02 75.73 34.04 113.04 55.38"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="136.61 68.87 134.19 72.77 127.9 69.18 114.05 61.25 96.24 90.35 92.88 95.84 89.47 93.89 110.64 59.3 113.04 55.38 116.44 57.34 136.61 68.87"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="134.19"
                        y1="72.78"
                        x2="134.19"
                        y2="72.77"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="96.24 90.35 96.24 111.69 96.22 111.7 80.01 88.47 89.47 93.89 92.88 95.84 96.24 90.35"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="127.9 69.18 127.9 93.3 108.32 104.67 96.24 111.69 96.24 90.35 114.05 61.25 127.9 69.18"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="166.82 88.99 164.77 90.18 122.19 114.92 81.97 138.28 71.58 123.41 28.06 61.07 21.58 51.79 59.34 29.86 64.16 27.06 106.44 2.5 163.12 83.69 166.82 88.99"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <circle
                        cx="37.8"
                        cy="108.81"
                        r="35.3"
                        style="fill: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <line
                            x1="21.58"
                            y1="119.26"
                            x2="54.02"
                            y2="119.26"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="44.65 109.88 54.02 119.26 44.65 128.63"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="54.02"
                            y1="98.36"
                            x2="21.58"
                            y2="98.36"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="30.96 107.73 21.58 98.36 30.96 88.98"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                </g>
            </symbol>
            <symbol id="replace-ridge-shingles" viewBox="0 0 162.55 119.07">
                <g>
                    <path
                        d="M154.05,66.21l-6-12.84-6-12.85-4-8.58a5.33,5.33,0,0,0-6.48-2.79L126,31l-10,3.33-10,3.32L95.91,41h0l-3.69,1.22L72.89,48.6a5.28,5.28,0,0,1,4.87,3.11L93.6,85.55l5.91,12.63L109.59,95l10.09-3.19,10.08-3.19,10.1-3.18,10.08-3.19L160,79h0Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M99.5,98.18H46.27l16.8-35.91L68,51.71a5.38,5.38,0,0,1,9.75,0Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M83.58,31.47h0L80,23.79a7.77,7.77,0,0,0-7.11-4.55c-.33,0-.67,0-1,.06l0,0a7.75,7.75,0,0,0-6.09,4.46l-3.59,7.69"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="160.05 79.04 149.94 82.24 139.86 85.43 136.07 86.62 119.68 91.8 109.59 94.99 99.51 98.18"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M136.55,14.72h0l-7.46,2.35L118.9,20.3l-17.65,5.59L83.59,31.47,80,23.79a7.76,7.76,0,0,0-7.11-4.55c-.33,0-.66,0-1,.06l17.4-5.53h0l17.49-5.56,17.55-5.57a8,8,0,0,1,1.47-.14A7.76,7.76,0,0,1,133,7.05Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="71.9"
                        y1="19.3"
                        x2="71.87"
                        y2="19.32"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="83.59"
                        y1="31.47"
                        x2="83.58"
                        y2="31.47"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="83.59"
                        y1="31.47"
                        x2="83.58"
                        y2="31.47"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="62.19"
                        y1="31.47"
                        x2="80.73"
                        y2="25.36"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M136.55,14.73h0L133,7.05a7.76,7.76,0,0,0-7.11-4.55,8,8,0,0,0-1.47.14l-.17,0-1.47.47"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M105.08,8.72l1.48-.46a8.06,8.06,0,0,1,1.63-.18,7.75,7.75,0,0,1,7.11,4.56l3.59,7.67"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M87.43,14.31l1.48-.47a8.05,8.05,0,0,1,1.63-.17,7.74,7.74,0,0,1,7.11,4.55l3.59,7.67"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <polygon
                            points="148.04 53.37 148.03 53.37 137.97 56.63 131.98 43.82 142.02 40.52 148.04 53.37"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polygon
                            points="113.73 79.1 103.66 82.33 93.6 85.55 87.68 72.9 97.73 69.64 107.79 66.39 113.73 79.1"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="87.68"
                            y1="72.9"
                            x2="81.77"
                            y2="60.26"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="99.5"
                            y1="98.18"
                            x2="93.6"
                            y2="85.55"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                    <g>
                        <polygon
                            points="129.76 88.61 119.67 91.8 109.59 94.99 103.66 82.33 113.73 79.1 113.75 79.1 123.81 75.88 129.76 88.61"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="109.59"
                            y1="94.99"
                            x2="99.5"
                            y2="98.18"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polygon
                            points="149.94 82.23 149.94 82.24 139.86 85.42 129.76 88.61 123.81 75.88 133.89 72.66 143.95 69.44 149.94 82.23"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polygon
                            points="160.05 79.03 160.05 79.04 160.03 79.04 149.94 82.23 143.96 69.44 154.03 66.21 154.05 66.21 160.05 79.03"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polygon
                            points="154.03 66.21 143.95 69.44 133.89 72.66 127.91 59.88 137.96 56.63 148.02 53.37 154.03 66.21"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polygon
                            points="133.89 72.66 123.81 75.88 113.75 79.1 113.73 79.1 107.79 66.39 117.85 63.14 127.91 59.88 133.89 72.66"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polygon
                            points="117.85 63.14 107.79 66.39 97.73 69.64 91.82 56.98 101.85 53.68 111.9 50.4 117.85 63.14"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polygon
                            points="101.85 53.68 91.82 56.98 81.77 60.26 75.86 47.62 85.89 44.3 95.91 40.96 101.85 53.68"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polygon
                            points="121.94 47.1 111.9 50.4 101.85 53.68 95.91 40.96 105.94 37.64 115.96 34.32 121.94 47.1"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polygon
                            points="137.96 56.63 127.91 59.88 117.85 63.14 111.9 50.4 121.94 47.1 131.97 43.82 137.96 56.63"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M142,40.52l-10,3.3-10,3.28-6-12.78L126,31l5.54-1.84A5.33,5.33,0,0,1,138,31.94Z"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                </g>
                <g>
                    <circle
                        cx="37.8"
                        cy="81.26"
                        r="35.3"
                        style="fill: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <line
                            x1="21.58"
                            y1="91.71"
                            x2="54.02"
                            y2="91.71"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="44.65 82.34 54.02 91.72 44.65 101.09"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="54.02"
                            y1="70.81"
                            x2="21.58"
                            y2="70.81"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="30.96 80.19 21.58 70.81 30.96 61.44"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                </g>
            </symbol>
            <symbol id="replace-roof-to-wall" viewBox="0 0 152.62 145.31">
                <g>
                    <polygon
                        points="115.73 102.36 115.73 133.27 38.06 133.27 38.06 52.58 53.58 62.54 69.12 72.49 84.66 82.45 100.2 92.4 115.73 102.36"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="70.78 49.12 62.18 55.84 53.58 62.54 38.06 52.58 46.65 45.89 55.25 39.17 70.78 49.12"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="79.38 42.42 70.78 49.12 55.25 39.17 63.85 32.46 79.38 42.42"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="77.72 65.8 69.12 72.49 53.58 62.54 62.18 55.84 77.72 65.8"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="150.11 75.54 141.51 82.23 141.5 82.25 125.98 72.29 125.99 72.28 110.45 62.33 110.44 62.34 94.91 52.37 79.38 42.42 63.85 32.46 72.45 25.76 87.98 35.71 103.51 45.66 103.52 45.66 119.04 55.62 119.05 55.62 134.59 65.58 150.11 75.54"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="141.5 82.25 132.93 88.95 132.92 88.95 117.39 79 125.98 72.29 141.5 82.25"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="132.92 88.95 124.33 95.66 115.73 102.36 100.2 92.4 108.79 85.7 117.39 79 132.92 88.95"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="108.79 85.7 100.2 92.4 84.66 82.45 93.26 75.75 108.79 85.7"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="150.12"
                        y1="75.53"
                        x2="150.12"
                        y2="75.53"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="150.12"
                        y1="75.53"
                        x2="150.12"
                        y2="75.53"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <polygon
                            points="101.84 69.03 93.26 75.75 84.66 82.45 69.12 72.49 77.72 65.8 86.31 59.08 101.84 69.03"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polygon
                            points="125.99 72.28 125.98 72.29 110.44 62.34 110.45 62.33 125.99 72.28"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                    <g>
                        <line
                            x1="69.12"
                            y1="72.5"
                            x2="53.58"
                            y2="62.54"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="100.19"
                            y1="92.41"
                            x2="84.65"
                            y2="82.45"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polygon
                            points="110.44 62.34 101.85 69.03 101.84 69.03 86.31 59.08 94.91 52.37 110.44 62.34"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                    <polygon
                        points="150.11 52.29 150.11 75.54 134.59 65.58 119.05 55.62 119.04 55.62 103.52 45.66 103.51 45.66 87.98 35.71 72.45 25.76 72.45 2.5 150.11 52.29"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="72.45 11.02 72.45 2.5 150.11 2.5 150.12 2.5 150.11 60.81"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="150.12 75.54 150.12 106.43 115.73 133.27 115.73 102.36 124.33 95.66 132.92 88.95 132.93 88.95 141.5 82.25 141.51 82.23 150.11 75.54 150.12 75.54"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="94.91 52.37 86.31 59.08 77.72 65.8 62.18 55.84 70.78 49.12 79.38 42.42 94.91 52.37"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polygon
                        points="125.98 72.29 117.39 79 108.79 85.7 93.26 75.75 101.84 69.03 101.85 69.03 110.44 62.34 125.98 72.29"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="101.84"
                        y1="69.03"
                        x2="86.32"
                        y2="59.08"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="132.92"
                        y1="88.95"
                        x2="117.39"
                        y2="79"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="70.78"
                        y1="49.12"
                        x2="55.25"
                        y2="39.17"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <circle
                        cx="37.8"
                        cy="107.51"
                        r="35.3"
                        style="fill: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <line
                            x1="21.58"
                            y1="117.96"
                            x2="54.02"
                            y2="117.96"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="44.65 108.58 54.02 117.96 44.65 127.33"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="54.02"
                            y1="97.05"
                            x2="21.58"
                            y2="97.05"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="30.96 106.43 21.58 97.06 30.96 87.68"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                </g>
            </symbol>
            <symbol id="replace-shingles" viewBox="0 0 130.54 110.34">
                <g>
                    <g>
                        <rect
                            x="37.8"
                            y="70.17"
                            width="30.08"
                            height="22.56"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <rect
                            x="67.88"
                            y="70.17"
                            width="29.87"
                            height="22.56"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <rect
                            x="37.8"
                            y="2.5"
                            width="14.93"
                            height="22.55"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <rect
                            x="37.8"
                            y="25.05"
                            width="30.08"
                            height="22.56"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <rect
                            x="37.8"
                            y="47.61"
                            width="14.93"
                            height="22.56"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <rect
                            x="52.74"
                            y="47.61"
                            width="30.08"
                            height="22.56"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <rect
                            x="67.88"
                            y="25.05"
                            width="29.87"
                            height="22.56"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                    <g>
                        <rect
                            x="97.75"
                            y="70.17"
                            width="30.08"
                            height="22.56"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <rect
                            x="112.89"
                            y="2.5"
                            width="14.93"
                            height="22.55"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <rect
                            x="82.81"
                            y="2.5"
                            width="30.08"
                            height="22.55"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <rect
                            x="52.74"
                            y="2.5"
                            width="30.08"
                            height="22.55"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <rect
                            x="97.75"
                            y="25.05"
                            width="30.08"
                            height="22.56"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <rect
                            x="112.89"
                            y="47.61"
                            width="14.93"
                            height="22.56"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <rect
                            x="82.81"
                            y="47.61"
                            width="30.08"
                            height="22.56"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                    <rect
                        x="37.8"
                        y="2.5"
                        width="90.23"
                        height="90.23"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <circle
                        cx="37.8"
                        cy="72.53"
                        r="35.3"
                        style="fill: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <line
                            x1="21.58"
                            y1="82.98"
                            x2="54.02"
                            y2="82.98"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="44.65 73.61 54.02 82.98 44.65 92.36"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="54.02"
                            y1="62.08"
                            x2="21.58"
                            y2="62.08"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="30.96 71.45 21.58 62.08 30.96 52.71"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                </g>
            </symbol>
            <symbol id="replace-shingles-underlayment" viewBox="0 0 168.83 116.92">
                <g>
                    <g>
                        <path
                            d="M166.33,72.47h0q-5.7,2-11.4,4l-27.11,9.64-25.75,9.16L74.82,105,53.16,68.67l13.33-4.74,15,25.14,13.92-4.95,13.06-4.64L121.14,75l13.07-4.64,14-5,11.4-4Z"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M159.65,61.27l-11.4,4-14,5L121.14,75l-12.69,4.52L95.39,84.12,81.47,89.07l-15-25.14q-3.34-5.59-6.68-11.21L73.14,48l15,25.14,13.65-4.85,12.48-4.44,13.28-4.72L140,54.67l13-4.61Z"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M153,50.06l-13,4.61-12.47,4.44-13.28,4.72-12.48,4.44L88.12,73.12,73.14,48q-3.35-5.59-6.68-11.21L79.8,32l15,25.14,26.07-9.27,12.48-4.43,13-4.62Z"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M146.3,38.85l-13,4.62L120.85,47.9,94.78,57.17,79.8,32l-6.68-11.2L124.63,2.51Z"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="166.33 72.48 166.33 72.47 159.65 61.27 152.97 50.06 146.3 38.85 124.63 2.51 124.63 2.5"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M140,54.67l-6.68-11.2"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M120.84,47.9l-6.68-11.2"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M114.24,63.83l-6.68-11.2"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M134.2,70.32q-3.33-5.61-6.68-11.21"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M108.44,79.48q-3.33-5.61-6.68-11.21"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M154.92,76.53l-6.67-11.21"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M127.82,86.17,121.14,75"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <path
                            d="M102.06,95.33q-3.33-5.61-6.68-11.21"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                    <line
                        x1="74.82"
                        y1="114.42"
                        x2="74.82"
                        y2="105.02"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="53.15"
                        y1="68.67"
                        x2="53.15"
                        y2="78.07"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="53.15"
                        y1="78.07"
                        x2="74.81"
                        y2="114.42"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="166.33"
                        y1="81.87"
                        x2="74.82"
                        y2="114.42"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <polyline
                        points="166.33 72.47 166.33 72.48 166.33 81.87"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                </g>
                <g>
                    <circle
                        cx="37.8"
                        cy="76.09"
                        r="35.3"
                        style="fill: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <line
                            x1="21.58"
                            y1="86.54"
                            x2="54.02"
                            y2="86.54"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="44.65 77.17 54.02 86.54 44.65 95.91"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="54.02"
                            y1="65.64"
                            x2="21.58"
                            y2="65.64"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="30.96 75.01 21.58 65.64 30.96 56.27"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                </g>
            </symbol>
            <symbol id="replace-shingles-underlayment-decking" viewBox="0 0 149.92 136.16">
                <path
                    d="M147.24,66.72,95,8.08a.08.08,0,0,0-.14.05V53a.73.73,0,0,0,.19.48l52.2,58.64a.08.08,0,0,0,.14-.05V67.21A.74.74,0,0,0,147.24,66.72Z"
                    style="fill: #fff"
                />
                <path
                    d="M147.33,114.65a2.53,2.53,0,0,1-1.9-.85L93.22,55.15A3.23,3.23,0,0,1,92.39,53V8.21a2.71,2.71,0,0,1,1.66-2.49h0a2.48,2.48,0,0,1,2.79.63l52.25,58.7a3.19,3.19,0,0,1,.83,2.16V112a2.7,2.7,0,0,1-1.65,2.49h0A2.56,2.56,0,0,1,147.33,114.65ZM97.39,52.31l47.53,53.47V67.89L97.39,14.42Zm48,16.09Z"
                />
                <path
                    d="M87.39,43.92,64,18a9.43,9.43,0,0,0-7-3h0a9.49,9.49,0,0,0-7,3L38.54,30.62a2.34,2.34,0,0,0-.61,1.59h0a2.37,2.37,0,0,0,4.13,1.59L53.45,21.16A4.71,4.71,0,0,1,57,19.7h0a4.67,4.67,0,0,1,3.51,1.46L87.39,51Z"
                />
                <path
                    d="M41.94,18.85,53.33,6.21a4.7,4.7,0,0,1,3.52-1.47h0a4.7,4.7,0,0,1,3.52,1.47l27,30V29.11L63.9,3a9.47,9.47,0,0,0-7-3h0A9.46,9.46,0,0,0,49.8,3L38.41,15.67a2.39,2.39,0,0,0-.61,1.59h0A2.38,2.38,0,0,0,41.94,18.85Z"
                />
                <path
                    d="M126.94,103.06l-4.75-5.27v15L63.9,48.09a9.72,9.72,0,0,0-14.1,0L38.41,60.73a2.38,2.38,0,0,0,3.53,3.18L53.33,51.27a5.14,5.14,0,0,1,7,0l60.85,67.52-7,6.35L103,112.76a2.37,2.37,0,0,0-1.76-.79h-42a2.38,2.38,0,0,0,0,4.75h41l12,13.36a2.38,2.38,0,0,0,1.77.78,2.34,2.34,0,0,0,1.58-.61l10.57-9.52s0,0,0,0a2.45,2.45,0,0,0,.31-.41,3.15,3.15,0,0,0,.22-.33,3.39,3.39,0,0,0,.11-.43,3.25,3.25,0,0,0,.11-.42s0,0,0-.07,0,0,0-.06Z"
                />
                <path
                    d="M63.9,33.05a9.44,9.44,0,0,0-7-3h0a9.46,9.46,0,0,0-7.05,3L38.41,45.69a2.37,2.37,0,0,0-.61,1.58h0a2.37,2.37,0,0,0,4.14,1.58L53.33,36.22a4.69,4.69,0,0,1,3.52-1.46h0a4.69,4.69,0,0,1,3.52,1.46l61.82,68.61v-7Z"
                />
                <path
                    d="M87.39,43.92,64,18a9.43,9.43,0,0,0-7-3h0a9.49,9.49,0,0,0-7,3L38.54,30.62a2.34,2.34,0,0,0-.61,1.59h0a2.37,2.37,0,0,0,4.13,1.59L53.45,21.16A4.71,4.71,0,0,1,57,19.7h0a4.67,4.67,0,0,1,3.51,1.46L87.39,51Z"
                />
                <path
                    d="M63.9,33.05a9.44,9.44,0,0,0-7-3h0a9.46,9.46,0,0,0-7.05,3L38.41,45.69a2.37,2.37,0,0,0-.61,1.58h0a2.37,2.37,0,0,0,4.14,1.58L53.33,36.22a4.69,4.69,0,0,1,3.52-1.46h0a4.69,4.69,0,0,1,3.52,1.46l61.82,68.61v-7Z"
                />
                <rect x="54.35" y="2.11" width="5" height="43.77" />
                <rect x="94.31" y="72.78" width="5" height="14.96" />
                <rect x="70.18" y="15.75" width="5" height="14.96" />
                <rect x="82.39" y="44.03" width="5" height="15.39" />
                <g>
                    <circle
                        cx="37.8"
                        cy="98.35"
                        r="35.3"
                        style="fill: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <line
                            x1="21.58"
                            y1="108.8"
                            x2="54.02"
                            y2="108.8"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="44.65 99.43 54.02 108.8 44.65 118.18"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="54.02"
                            y1="87.9"
                            x2="21.58"
                            y2="87.9"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="30.96 97.28 21.58 87.9 30.96 78.53"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                </g>
            </symbol>
            <symbol id="replace-shingles-type" viewBox="0 0 95.23 95.23">
                <g>
                    <rect
                        x="2.5"
                        y="70.17"
                        width="30.08"
                        height="22.56"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="5"
                    />
                    <rect
                        x="32.58"
                        y="70.17"
                        width="29.87"
                        height="22.56"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="5"
                    />
                    <rect
                        x="2.5"
                        y="2.5"
                        width="14.93"
                        height="22.55"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="5"
                    />
                    <rect
                        x="2.5"
                        y="25.05"
                        width="30.08"
                        height="22.56"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="5"
                    />
                    <rect
                        x="2.5"
                        y="47.61"
                        width="14.93"
                        height="22.56"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="5"
                    />
                    <rect
                        x="17.43"
                        y="47.61"
                        width="30.08"
                        height="22.56"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="5"
                    />
                    <rect
                        x="32.58"
                        y="25.05"
                        width="29.87"
                        height="22.56"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="5"
                    />
                </g>
                <g>
                    <rect
                        x="62.44"
                        y="70.17"
                        width="30.08"
                        height="22.56"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="5"
                    />
                    <rect
                        x="77.59"
                        y="2.5"
                        width="14.93"
                        height="22.55"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="5"
                    />
                    <rect
                        x="47.51"
                        y="2.5"
                        width="30.08"
                        height="22.55"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="5"
                    />
                    <rect
                        x="17.43"
                        y="2.5"
                        width="30.08"
                        height="22.55"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="5"
                    />
                    <rect
                        x="62.44"
                        y="25.05"
                        width="30.08"
                        height="22.56"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="5"
                    />
                    <rect
                        x="77.59"
                        y="47.61"
                        width="14.93"
                        height="22.56"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="5"
                    />
                    <rect
                        x="47.51"
                        y="47.61"
                        width="30.08"
                        height="22.56"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="5"
                    />
                </g>
                <rect
                    x="2.5"
                    y="2.5"
                    width="90.23"
                    height="90.23"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="5"
                />
            </symbol>
            <symbol id="replace-valley" viewBox="0 0 159.12 107.67">
                <g>
                    <path
                        d="M73.11,82.07,30.36,66.66l15.79-44a2.86,2.86,0,0,1,5.63,0Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="93.49"
                        y1="71.24"
                        x2="93.49"
                        y2="2.5"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <path
                        d="M113.87,82.07l42.75-15.41-15.79-44a2.86,2.86,0,0,0-5.63,0Z"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="48.97"
                        y1="20.28"
                        x2="93.49"
                        y2="2.5"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="73.11"
                        y1="82.07"
                        x2="93.49"
                        y2="71.24"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="138.01"
                        y1="20.28"
                        x2="93.49"
                        y2="2.5"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <line
                        x1="113.87"
                        y1="82.07"
                        x2="93.49"
                        y2="71.24"
                        style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <line
                            x1="85.52"
                            y1="5.68"
                            x2="85.52"
                            y2="10.68"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="85.52"
                            y1="19.23"
                            x2="85.52"
                            y2="66.24"
                            style="
                                fill: none;
                                stroke-linecap: round;
                                stroke-linejoin: round;
                                stroke-width: 5px;
                                stroke-dasharray: 8.547545433044434, 8.547545433044434;
                            "
                        />
                        <line
                            x1="85.52"
                            y1="70.52"
                            x2="85.52"
                            y2="75.52"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                    <g>
                        <line
                            x1="101.46"
                            y1="5.68"
                            x2="101.46"
                            y2="10.68"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="101.46"
                            y1="19.23"
                            x2="101.46"
                            y2="66.24"
                            style="
                                fill: none;
                                stroke-linecap: round;
                                stroke-linejoin: round;
                                stroke-width: 5px;
                                stroke-dasharray: 8.547545433044434, 8.547545433044434;
                            "
                        />
                        <line
                            x1="101.46"
                            y1="70.52"
                            x2="101.46"
                            y2="75.52"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                </g>
                <g>
                    <circle
                        cx="37.8"
                        cy="69.87"
                        r="35.3"
                        style="fill: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                    />
                    <g>
                        <line
                            x1="21.58"
                            y1="80.32"
                            x2="54.02"
                            y2="80.32"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="44.65 70.95 54.02 80.32 44.65 89.69"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <line
                            x1="54.02"
                            y1="59.42"
                            x2="21.58"
                            y2="59.42"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                        <polyline
                            points="30.96 68.79 21.58 59.42 30.96 50.05"
                            style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 5px"
                        />
                    </g>
                </g>
            </symbol>
        </g>
    </svg>
</template>
